import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { BASE_URL } from '../../../config/axios';
import { handleErrorToast, CSSForSelect15vWWidth, ProgressModal, CSSForSelectModern } from '../../CustomFunctions';
import { Modal } from "react-bootstrap";
import { AddwithWhiteCircle, UpdatePencil } from '../../AllSvg';
import Select from 'react-select';
import { CarFrontIcon, Pencil, PencilLineIcon } from 'lucide-react';

const BulkUpdateEmployeeBOQ = ({ boqEmployeeList, i, getData, id, value, getLogData, usedFor }) => {


  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState([]);
  const [changeReason, setChangeReason] = useState("null");
  const [showChange, setShowChange] = useState(false);

  const [showEOT, setShowEOT] = useState(false);
  const handleShowWOT = () => {
    setShowEOT(true)
  }
  const handleclOSEOT = () => {
    setShowEOT(false)
  }

  const createdAtRef = useRef(new Date().toISOString());

  const handleShow = () => {
    createdAtRef.current = new Date().toISOString() + "-" + Math.random().toString(36).slice(2);
    // ^ timestamp + random string, taaki same-millisecond pe do updates ho to bhi clash na ho
    setShow(true);
    setFormData(boqEmployeeList);
  }
  useEffect(() => {
    if (changeReason !== "null") {
      setFormData((prevData) =>
        prevData.map((item) => ({
          ...item,
          reason_of_change: changeReason,
        }))
      );
    }
  }, [changeReason]);

  const createdAt = new Date().toISOString();

  useEffect(() => {
    if (!showChange) {
      setFormData((prevData) =>
        prevData.map((item) => ({
          ...item,
          random_value_of_changes: createdAt,
          change_by_emp_code: sessionStorage.getItem('sitemanagement_emp_code'),
          change_by_emp_name: sessionStorage.getItem('name'),

        }))
      );
    }

  }, [createdAt, showChange])



  useEffect(() => {
    if (Array.isArray(boqEmployeeList)) {
      const initialData = boqEmployeeList.map((item) => ({
        rate: "",
        num_of_man_month: "",
        employee_name_details: [],
        project: id,
        professional_type: null,
        MM_OM_period: "",
        designation_name: "",
        rank: "",
        random_value_of_changes: "",
        MM_construction_period: "",
        reason_of_change: changeReason !== "null" ? changeReason : "",
        designation: "",
        empcode: [],
        eot_details: [{
          boqId: item.id,
          designation_name: item.designation_name,
          professional_type: item.professional_type,
          cp: "",
          dlp: "",
          t_month: "",
          rate: "",
          total_amount: "",
        }],
        change_by_emp_code: sessionStorage.getItem('sitemanagement_emp_code'),
        change_by_emp_name: sessionStorage.getItem('name'),
      }));
      setFormData(initialData);
    }
  }, [boqEmployeeList]);


  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const [inputState, setInputState] = useState({});



  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => {
      const newFields = [...prevFormData];
      newFields[index] = {
        ...newFields[index],
        [name]: value,
      };
      return newFields;
    });
  }




  const handleChangeSubmit = () => {
    setShowChange(true);
  }
  const handleChangeback = () => {
    setShowChange(false);

  }


  const handleClose = () => {
    setShow(false);
    setShowChange(false);
    setShowEOT(false)
    setChangeReason("");
  }

  const [loading, setLoading] = useState(false); //loading logic
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);



  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic
      setShowProgressModal(true);
      setUploadProgress(0); // Reset progress
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

      try {
        let res = await axios.put(
          `${BASE_URL}/siteproject/bulkBOQEmployee/`,
          formData,
          {
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setUploadProgress(percentCompleted);
            },
          }
        );

        if (res.status === 200) {
          await getData();
          await getLogData();
          handleClose();
          setTimeout(() => {
            toast.dismiss(loadingToastId); // Close loading toast
            toast.success("BOQ Updated Successfully"); // Show success toast
          }, 4000);
        } else {
          alert(res);
        }
      } catch (err) {
        //toast Logic
        handleErrorToast(err, loadingToastId);
      } finally {

        setTimeout(() => {
          setShowProgressModal(false);
        }, 2000); // Hide after 3 seconds

        setTimeout(() => {
          setLoading(false); //loading logic
          toast.dismiss(loadingToastId);
        }, 4000)

      }
    }
  };

  const [employeeList, setEmployeeList] = useState([]);
  const [buffer, setBuffering] = useState(true);

  const [designation, setDesignation] = useState([]);

  const getEmployee = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const [pro, multiple] = await Promise.all([
        axios.get(`${BASE_URL}/siteproject/employeeboqbyproject/${id}/null/`),
        axios.get(`${BASE_URL}/siteproject/employeemultipleproject/${id}/`)
      ]);

      const merged = [...pro.data, ...multiple.data];
      const uniqueByIdMap = new Map();
      merged.forEach((emp) => {
        uniqueByIdMap.set(emp.id, emp);
      });

      setEmployeeList(Array.from(uniqueByIdMap.values()));
    } catch (err) {
      //toast Logic
      handleErrorToast(err);
    } finally {
      setBuffering(false); // End Buffering
    }
  };

  useEffect(() => {
    if (show === true) {
      getEmployee();
    }
  }, [show])



  const getDesignation = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const pro = await axios.get(
        `${BASE_URL}/siteproject/designation/`
      );
      setDesignation(pro.data);
    } catch (err) {
      //toast Logic
      handleErrorToast(err);
    } finally {
      setBuffering(false); // End Buffering
    }
  };
  //! **************************** Get API  End ***********************!//

  const getEmployeeOptions = (designation) => [
    {
      value: 'create-new-employee',
      label: 'Create New Employee',
    },
    ...(designation
      ? employeeList
        .filter((employee) => employee.designation === designation)
        .sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code) || a.emp_code.localeCompare(b.emp_code))
        .map((e) => ({
          value: e.id,
          label: `${e.emp_code} - ${e.name}`,
        }))
      : []),


  ];




  const getSelectedEmployees = (entry) => {
    if (!entry) return [];

    const empcode = entry.empcode || [];

    // Get the current list of employees matching this designation
    const options = getEmployeeOptions(entry.designation);

    if (Array.isArray(empcode) && empcode.length > 0) {
      return empcode
        .map((empId) => options.find((option) => option.value === empId))
        .filter(Boolean); // Only return found ones
    }



    const fallback = entry?.person_using_conveyance;
    const fallbackOption = options.find((option) => option.value === fallback);
    return fallbackOption ? [fallbackOption] : [];
  };








  const [showCreateEmployeeModal, setShowCreateEmployeeModal] = useState(false);

  const handleChangecc = (index, selected) => {
    const empcode = Array.isArray(selected) && selected.length > 0
      ? selected.map((item) => item.value)
      : [];

    if (empcode.includes('create-new-employee')) {
      setShowCreateEmployeeModal(true);
    } else {
      setFormData((prevState) =>
        prevState.map((item, i) =>
          i === index
            ? { ...item, empcode }
            : item
        )
      );
    }
  };

  const [allTables, setAllTables] = useState([]);





  const addNewEOT = () => {
    setFormData((prevFormData) =>
      prevFormData.map((entry) => ({
        ...entry,
        eot_details: [
          ...(entry.eot_details || []),
          {
            boqId: entry.boqId || entry.id,
            cp: "",
            dlp: "",
            t_month: "",
            rate: "",
            total_amount: "",
          },
        ],
      }))
    );
  };


  useEffect(() => {
    if (Array.isArray(boqEmployeeList)) {
      const initialData = boqEmployeeList.map((item) => ({
        rate: "",
        num_of_man_month: "",
        employee_name_details: [],
        project: id,
        random_value_of_changes: "",
        professional_type: item.professional_type,
        MM_OM_period: "",
        designation_name: item.designation_name,
        MM_construction_period: "",
        reason_of_change: changeReason !== "null" ? changeReason : "",
        designation: "",
        empcode: [],
        eot_details: [
          {
            boqId: item.id,
            designation_name: item.designation_name,
            professional_type: item.professional_type,
            cp: "",
            dlp: "",
            t_month: "",
            rate: "",
            total_amount: "",
          },
        ], // ✅ first EOT round exists by default
        change_by_emp_code: sessionStorage.getItem("sitemanagement_emp_code"),
        change_by_emp_name: sessionStorage.getItem("name"),
      }));
      setFormData(initialData);
      setShowEOT(true); // ✅ show EOT table immediately
    }
  }, [boqEmployeeList]);




  const handleEOTChange = (entryIndex, detailIndex, field, value) => {
    setFormData((prevFormData) =>
      prevFormData.map((entry, i) => {
        if (i !== entryIndex) return entry;

        const updatedDetails = entry.eot_details.map((detail, j) => {
          if (j !== detailIndex) return detail;

          const updatedDetail = { ...detail, [field]: value };

          // Auto-calc t_month = cp + dlp
          const cp = parseFloat(updatedDetail.cp) || 0;
          const dlp = parseFloat(updatedDetail.dlp) || 0;
          updatedDetail.t_month = cp + dlp;

          // Auto-calc total_amount = t_month * rate
          const rate = parseFloat(updatedDetail.rate) || 0;
          updatedDetail.total_amount = updatedDetail.t_month * rate;

          return updatedDetail;
        });

        return { ...entry, eot_details: updatedDetails };
      })
    );
  };













  // return (
  //   <>
  //     <button title="Update employee BOQ" className="upload-svg flex-row" onClick={handleShow}>
  //       <svg
  //         xmlns="http://www.w3.org/2000/svg"
  //         width="24"
  //         height="24"
  //         fill="white"
  //         viewBox="0 0 24 24"
  //         id="pen-new-square"
  //       >
  //         <path
  //           fill=""
  //           fill-rule="evenodd"
  //           d="M11.9426 1.25L13.5 1.25C13.9142 1.25 14.25 1.58579 14.25 2C14.25 2.41421 13.9142 2.75 13.5 2.75H12C9.62177 2.75 7.91356 2.75159 6.61358 2.92637C5.33517 3.09825 4.56445 3.42514 3.9948 3.9948C3.23505 4.75455 2.91245 5.86509 2.80417 8.03734C2.78355 8.45104 2.43146 8.76969 2.01776 8.74907C1.60406 8.72845 1.28541 8.37636 1.30603 7.96266C1.41642 5.74802 1.74641 4.12187 2.93414 2.93414C3.82895 2.03933 4.96897 1.63399 6.41371 1.43975C7.82519 1.24998 9.63423 1.24999 11.9426 1.25ZM22 9.75C22.4142 9.75 22.75 10.0858 22.75 10.5V12.0574C22.75 14.3658 22.75 16.1748 22.5603 17.5863C22.366 19.031 21.9607 20.1711 21.0659 21.0659C20.1711 21.9607 19.031 22.366 17.5863 22.5603C16.1748 22.75 14.3658 22.75 12.0574 22.75H11.9426C9.63423 22.75 7.82519 22.75 6.41371 22.5603C4.96897 22.366 3.82895 21.9607 2.93414 21.0659C2.03933 20.1711 1.63399 19.031 1.43975 17.5863C1.24998 16.1748 1.24999 14.3658 1.25 12.0574L1.25 12C1.25 11.5858 1.58579 11.25 2 11.25C2.41421 11.25 2.75 11.5858 2.75 12C2.75 14.3782 2.75159 16.0864 2.92637 17.3864C3.09825 18.6648 3.42514 19.4355 3.9948 20.0052C4.56445 20.5749 5.33517 20.9018 6.61358 21.0736C7.91356 21.2484 9.62177 21.25 12 21.25C14.3782 21.25 16.0864 21.2484 17.3864 21.0736C18.6648 20.9018 19.4355 20.5749 20.0052 20.0052C20.5749 19.4355 20.9018 18.6648 21.0736 17.3864C21.2484 16.0864 21.25 14.3782 21.25 12V10.5C21.25 10.0858 21.5858 9.75 22 9.75Z"
  //           clip-rule="evenodd"
  //         ></path>
  //         <path
  //           fill=""
  //           fill-rule="evenodd"
  //           d="M16.7705 2.27592C18.1384 0.908029 20.3562 0.908029 21.7241 2.27592C23.092 3.6438 23.092 5.86158 21.7241 7.22947L18.0928 10.8607C17.7999 11.1536 17.3251 11.1536 17.0322 10.8607C16.7393 10.5678 16.7393 10.093 17.0322 9.80006L19.1051 7.72709C18.5892 7.50519 17.9882 7.14946 17.4193 6.58065C16.8505 6.01185 16.4948 5.41082 16.2729 4.89486L11.2175 9.95026C10.801 10.3668 10.6376 10.532 10.4988 10.71C10.3274 10.9297 10.1804 11.1676 10.0605 11.4192C9.96337 11.623 9.88868 11.8429 9.7024 12.4017L9.27051 13.6974L10.3026 14.7295L11.5983 14.2976C12.1571 14.1113 12.377 14.0366 12.5808 13.9395C12.8324 13.8196 13.0703 13.6726 13.2901 13.5012C13.468 13.3624 13.6332 13.199 14.0497 12.7825C14.3426 12.4896 14.8175 12.4896 15.1104 12.7825C15.4033 13.0754 15.4033 13.5503 15.1104 13.8432L15.076 13.8776C14.7047 14.2489 14.4721 14.4815 14.2126 14.684C13.9069 14.9224 13.5761 15.1268 13.2261 15.2936C12.929 15.4352 12.6169 15.5392 12.1188 15.7052L9.21426 16.6734C8.67801 16.8521 8.0868 16.7126 7.68711 16.3129C7.28742 15.9132 7.14785 15.322 7.3266 14.7857L8.29477 11.8812C8.46079 11.3831 8.56479 11.071 8.7064 10.7739C8.87319 10.4239 9.07761 10.0931 9.31605 9.78742C9.51849 9.52787 9.7511 9.29529 10.1224 8.92401L16.7705 2.27592ZM17.4546 3.7132C17.4773 3.80906 17.509 3.92327 17.5532 4.05066C17.6965 4.46372 17.9677 5.00771 18.48 5.51999C18.9923 6.03227 19.5363 6.30346 19.9493 6.44677C20.0767 6.49097 20.1909 6.52273 20.2868 6.54543L20.6634 6.16881C21.4455 5.38671 21.4455 4.11867 20.6634 3.33658C19.8813 2.55448 18.6133 2.55448 17.8312 3.33658L17.4546 3.7132Z"
  //           clip-rule="evenodd"
  //         ></path>
  //       </svg>{" "}
  //       {" "} Update Employee
  //     </button>
  //     {
  //       showProgressModal ?
  //         <ProgressModal show={showProgressModal} progress={uploadProgress} /> :
  //         <Modal
  //           show={show}
  //           onHide={handleClose}
  //           dialogClassName={!showChange ? "request-leave" : "width-90vw-Modal"}
  //         >
  //           <Modal.Header closeButton >
  //             <Modal.Title>Update Employeee Data for BOQ</Modal.Title>

  //           </Modal.Header>
  //           {
  //             !showChange ?
  //               <Modal.Body>
  //                 <div className="parent-div">
  //                   <div className="bdy-div">
  //                     <div className="flex-column ">
  //                       <label className="form-labels font-weight500 font-size-subheading" title="Invoice Number">
  //                         Reason for Change BOQ<span className="required">*</span>
  //                       </label>
  //                       <input
  //                         type="text"
  //                         name="changeReason"
  //                         title="Reason for Change BOQ"
  //                         placeholder="Example- Revise EOT"
  //                         onChange={(e) => setChangeReason(e.target.value)}
  //                         className={`form-input ${errors.changeReason ? "is-invalid" : ""
  //                           }`}
  //                       />
  //                     </div>
  //                     <div className="button-models">
  //                       <button
  //                         className="model-button-cancel model-button font-weight500"
  //                         onClick={handleClose}
  //                       >
  //                         Cancel
  //                       </button>
  //                       {(changeReason !== "null" && changeReason !== "") && (
  //                         <button
  //                           type="submit"
  //                           className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                           disabled={loading}
  //                           onClick={handleChangeSubmit}
  //                         >
  //                           Next
  //                         </button>
  //                       )}

  //                     </div>

  //                   </div>
  //                 </div>
  //                 <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

  //               </Modal.Body>
  //               : !showEOT ?
  //                 <Modal.Body>
  //                   <div className="parent-div">
  //                     <div className="bdy-div">
  //                       <div className='flex-row justify-between'>
  //                         <button
  //                           type="button"
  //                           className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                           disabled={loading}
  //                           onClick={handleChangeback}
  //                         >
  //                           Back
  //                         </button>
  //                         <button
  //                           type="button"
  //                           className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                           disabled={loading}
  //                           onClick={handleShowWOT}
  //                         >
  //                           <AddwithWhiteCircle /> Add Revised EOT/COS
  //                         </button>
  //                       </div>
  //                       <div className="flex-row justify-center">
  //                         <table className="nested-table-lightblue width-90vw payment">
  //                           <thead className="table-heading">
  //                             <tr className="custom-table-head-tr width-10vw">
  //                               <th className="table-heading-text text-left-sr" >S no.</th>
  //                               <th className="table-heading-text text-center">Designatons <br /> <span className="required">(Read-Only)</span></th>
  //                               <th className="table-heading-text text-center">Professional Type <br /> <span className="required">(Read-Only)</span></th>
  //                               <th className="table-heading-text text-center">Employee Name</th>
  //                               <th className="table-heading-text text-center">MM Construction Period <br /><span className="required">(In-Months)</span></th>
  //                               <th className="table-heading-text text-center">MM O&M Period <br /><span className="required">(In-Months)</span></th>
  //                               <th className="table-heading-text text-center">Total MM <br /> <span className="required">(Read-Only)</span></th>

  //                               <th className="table-heading-text text-center">Rate  <br /> <span className="required">(Monthly-Rate)</span></th>
  //                             </tr>
  //                           </thead>


  //                           <tbody>

  //                             {formData.map((entry, index) => (
  //                               <tr key={index} className="custom-table-head-td ">

  //                                 <td className="align-left width-5vw" >
  //                                   <input
  //                                     name="rank"
  //                                     value={entry.rank}
  //                                     onChange={(e) => handleInputChange(e, index)}
  //                                     className={`form-input-date width-5vw ${errors[`${index}_rank`] ? "error" : ""}`}
  //                                     type="text"
  //                                   />
  //                                 </td>
  //                                 <td className=''>

  //                                   <p>{entry.designation_name}</p>



  //                                 </td>
  //                                 <td>
  //                                   <p>{entry.professional_type}</p>
  //                                 </td>

  //                                 <td>
  //                                   <div title="EmployeeName" className="flex-column align-items-center">
  //                                     <Select
  //                                       options={getEmployeeOptions(entry.designation)}
  //                                       onChange={(selected) => handleChangecc(index, selected)}
  //                                       // placeholder={entry.employee_name_details.length > 0 ? entry.employee_name_details[0]?.name : "Select Employee"}
  //                                       isMulti
  //                                       value={getSelectedEmployees(entry)}
  //                                       styles={{
  //                                         control: (provided) => ({
  //                                           ...provided,
  //                                           width: '15vw',
  //                                           minHeight: '50px',
  //                                           borderRadius: '10px',
  //                                           border: '1px solid #e3e3e3',
  //                                           margin: '10px 0px 20px 0px',
  //                                           color: '#4a4a4a',
  //                                           backgroundColor: '#f7f8fa',
  //                                           padding: '0px 10px',
  //                                         }),
  //                                         placeholder: (provided) => ({
  //                                           ...provided,
  //                                           color: '#4a4a4a',
  //                                         }),
  //                                         menu: (provided) => ({
  //                                           ...provided,
  //                                           width: '10vw',
  //                                           borderRadius: '10px',
  //                                           marginTop: '0',
  //                                         }),
  //                                         singleValue: (provided) => ({
  //                                           ...provided,
  //                                           color: '#4a4a4a',
  //                                         }),
  //                                         input: (provided) => ({
  //                                           ...provided,
  //                                           color: '#4a4a4a',
  //                                         }),
  //                                       }}
  //                                     />
  //                                     {errors.remarks && (
  //                                       <span className="error-message font-size-text ">{errors.remarks}</span>
  //                                     )}
  //                                     <div>
  //                                       {errors[`${index}_actual_month`] && (
  //                                         <span className="error-message font-size-text ">{errors[`${index}_actual_month`]}</span>
  //                                       )}
  //                                     </div>
  //                                   </div>
  //                                 </td>
  //                                 <td>
  //                                   <div title="MM const. Period" className="flex-column align-items-center">
  //                                     <input
  //                                       className={`form-input-date  width-5vw  ${errors[`${index}_MM_construction_period`] ? "error" : ""}`}
  //                                       id={`MM_construction_period_${index}`}
  //                                       name="MM_construction_period"
  //                                       type="number"
  //                                       value={entry.MM_construction_period}
  //                                       onChange={(e) => handleInputChange(e, index)}

  //                                     />
  //                                     <div>
  //                                       {errors[`${index}_MM_construction_period`] && (
  //                                         <span className="error-message font-size-text ">{errors[`${index}_MM_construction_period`]}</span>
  //                                       )}
  //                                     </div>
  //                                   </div>
  //                                 </td>
  //                                 <td>
  //                                   <div title="MM O&M Period" className="flex-column align-items-center">
  //                                     <input
  //                                       className={`form-input-date  width-5vw  ${errors[`${index}_MM_OM_period`] ? "error" : ""}`}
  //                                       id={`MM_OM_period_${index}`}
  //                                       name="MM_OM_period"
  //                                       type="text"
  //                                       value={entry.MM_OM_period}
  //                                       onChange={(e) => handleInputChange(e, index)}

  //                                     />
  //                                     <div>
  //                                       {errors[`${index}_MM_OM_period`] && (
  //                                         <span className="error-message font-size-text ">{errors[`${index}_MM_OM_period`]}</span>
  //                                       )}
  //                                     </div>
  //                                   </div>
  //                                 </td>
  //                                 <td>

  //                                   <p className="text-center">
  //                                     {Number(entry.MM_OM_period || 0) + Number(entry.MM_construction_period || 0)}
  //                                   </p>
  //                                 </td>
  //                                 <td>
  //                                   <div title="Monthly Rate" className="flex-column align-items-center">
  //                                     <input
  //                                       className={`form-input-date  width-5vw  ${errors[`${index}_rate`] ? "error" : ""}`}
  //                                       id={`rate_${index}`}
  //                                       name="rate"
  //                                       type="text"
  //                                       value={entry.rate}
  //                                       onChange={(e) => handleInputChange(e, index)}

  //                                     />
  //                                     <div>
  //                                       {errors[`${index}_rate`] && (
  //                                         <span className="error-message font-size-text ">{errors[`${index}_rate`]}</span>
  //                                       )}
  //                                     </div>
  //                                   </div>
  //                                 </td>


  //                               </tr>
  //                             ))}

  //                           </tbody>

  //                         </table>
  //                       </div>
  //                       <div className="button-models">
  //                         <button
  //                           className="model-button-cancel model-button font-weight500"
  //                           onClick={handleClose}
  //                         >
  //                           Cancel
  //                         </button>
  //                         <button
  //                           type="submit"
  //                           className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                           disabled={loading}
  //                           onClick={handleSubmit}
  //                         >
  //                           Update
  //                         </button>
  //                       </div>

  //                     </div>
  //                   </div>
  //                   <ToastContainer
  //                     position="top-center"
  //                     autoClose={1000}
  //                     hideProgressBar={false}
  //                     newestOnTop={true}
  //                     closeOnClick
  //                     rtl={false}
  //                     pauseOnFocusLoss
  //                     draggable
  //                     pauseOnHover
  //                   />

  //                 </Modal.Body > : showEOT === true ?
  //                   <Modal.Body>
  //                     <div className="parent-div">
  //                       <div className="bdy-div">
  //                         <div className='flex-row justify-between'>
  //                           <button
  //                             type="button"
  //                             className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                             disabled={loading}
  //                             onClick={handleclOSEOT}
  //                           >
  //                             Back
  //                           </button>
  //                           <button
  //                             type="button"
  //                             className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                             disabled={loading}
  //                             onClick={addNewEOT}
  //                           >
  //                             <AddwithWhiteCircle /> Add Another Revised EOT/COS
  //                           </button>
  //                         </div>
  //                         {formData[0]?.eot_details?.map((_, detailIndex) => (
  //                           <div key={detailIndex}>
  //                             <h3>EOT Round {detailIndex + 1}</h3>
  //                             <table className="nested-table-lightblue width-90vw payment">

  //                               <thead>
  //                                 <tr>
  //                                   <th>Designation</th>
  //                                   <th>Professional Type</th>
  //                                   <th>CP</th>
  //                                   <th>DLP</th>
  //                                   <th>T Month</th>
  //                                   <th>Rate</th>

  //                                   <th>Total Amount</th>
  //                                 </tr>
  //                               </thead>
  //                               <tbody>
  //                                 {formData.sort((a, b) => a.rank - b.rank).map((entry, entryIndex) => (
  //                                   <tr key={entryIndex}>
  //                                     <td>{entry.designation_name}</td>
  //                                     <td>{entry.professional_type}</td>
  //                                     <td>
  //                                       <input
  //                                         type="number"
  //                                         className={`form-input-date  width-5vw  ${errors[`${entryIndex}_cp`] ? "error" : ""}`}

  //                                         value={entry.eot_details[detailIndex]?.cp || 0}
  //                                         onChange={(e) =>
  //                                           handleEOTChange(entryIndex, detailIndex, "cp", e.target.value)
  //                                         }
  //                                       />
  //                                     </td>
  //                                     <td>
  //                                       <input
  //                                         type="number"
  //                                         className={`form-input-date  width-5vw  ${errors[`${entryIndex}_dlp`] ? "error" : ""}`}

  //                                         value={entry.eot_details[detailIndex]?.dlp || 0}
  //                                         onChange={(e) =>
  //                                           handleEOTChange(entryIndex, detailIndex, "dlp", e.target.value)
  //                                         }
  //                                       />
  //                                     </td>
  //                                     <td>
  //                                       <input
  //                                         type="number"
  //                                         value={entry.eot_details[detailIndex]?.t_month ?? "0"}
  //                                         className={`form-input-date  width-5vw  ${errors[`${entryIndex}_t_month`] ? "error" : ""}`}
  //                                         disabled
  //                                         onChange={(e) =>
  //                                           handleEOTChange(
  //                                             entryIndex,
  //                                             detailIndex,
  //                                             "t_month",
  //                                             e.target.value
  //                                           )
  //                                         }
  //                                       />
  //                                     </td>
  //                                     <td>
  //                                       <input
  //                                         type="number"
  //                                         className={`form-input-date  width-5vw  ${errors[`${entryIndex}_rate`] ? "error" : ""}`}
  //                                         placeholder={entry.eot_details[detailIndex]?.rate || 0}
  //                                         value={entry.eot_details[detailIndex]?.rate}
  //                                         onChange={(e) =>
  //                                           handleEOTChange(entryIndex, detailIndex, "rate", e.target.value)
  //                                         }
  //                                       />
  //                                     </td>

  //                                     <td>
  //                                       <input
  //                                         type="number"
  //                                         className={`form-input-date  width-5vw  ${errors[`${entryIndex}_total_amount`] ? "error" : ""}`}
  //                                         disabled
  //                                         value={entry.eot_details[detailIndex]?.total_amount || 0}
  //                                         onChange={(e) =>
  //                                           handleEOTChange(
  //                                             entryIndex,
  //                                             detailIndex,
  //                                             "total_amount",
  //                                             e.target.value
  //                                           )
  //                                         }
  //                                       />
  //                                     </td>
  //                                   </tr>
  //                                 ))}
  //                               </tbody>
  //                             </table>
  //                           </div>
  //                         ))}

  //                         <div className="button-models">
  //                           <button
  //                             className="model-button-cancel model-button font-weight500"
  //                             onClick={handleClose}
  //                           >
  //                             Cancel
  //                           </button>
  //                           <button
  //                             type="submit"
  //                             className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                             disabled={loading}
  //                             onClick={handleSubmit}
  //                           >
  //                             Save
  //                           </button>
  //                         </div>

  //                       </div>
  //                     </div>
  //                   </Modal.Body > : ""
  //           }
  //         </Modal >
  //     }

  //   </>
  // )


  return (
    <>
      <button
        title="Update employee BOQ"
        className="eb-bulk-trigger-btn"
        onClick={handleShow}
        style={{ background: "black" }}
      >
        <PencilLineIcon size={15} />
        Update Employee
      </button>

      {showProgressModal ?
        <ProgressModal usedFor="Update" show={showProgressModal} progress={uploadProgress} /> :
        <Modal
          show={show}
          onHide={handleClose}
          dialogClassName={!showChange ? "eb-bulk-modal request-leave" : "max-heightModal eb-bulk-modal model-width90vw"}

        >
          <Modal.Header className="eb-bulk-modal-header">
            <Modal.Title className="eb-bulk-modal-title">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
              </svg>
              Update Employee Data for BOQ
              <button className="close-btn" onClick={handleClose} style={{ marginLeft: 'auto', background: 'none', border: 'none', color: 'white', fontSize: '24px', cursor: 'pointer' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </Modal.Title>
          </Modal.Header>

          {!showChange ?
            <Modal.Body className="eb-bulk-modal-body">

              <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
                <div className="eb-bulk-content">
                  <div className="eb-bulk-reason-section" style={{ padding: '20px', background: '#f7fafc', borderRadius: '12px' }}>
                    <label className="eb-bulk-label" style={{ display: 'block', fontWeight: '600', marginBottom: '8px', color: '#2d3748' }}>
                      Reason for Change BOQ <span className="eb-bulk-required">*</span>
                    </label>
                    <input
                      type="text"
                      name="changeReason"
                      title="Reason for Change BOQ"
                      placeholder="Example- Revise EOT"
                      onChange={(e) => setChangeReason(e.target.value)}
                      className="eb-bulk-input"
                      style={{ width: '90%', padding: '12px 16px', fontSize: '14px' }}
                    />
                  </div>

                  <div className="eb-bulk-footer-actions" style={{ justifyContent: 'flex-end' }}>
                    <button
                      className="eb-bulk-btn eb-bulk-btn-cancel"
                      onClick={handleClose}
                    >
                      Cancel
                    </button>
                    {(changeReason !== "null" && changeReason !== "") && (
                      <button
                        type="submit"
                        className="eb-bulk-btn eb-bulk-btn-submit"
                        disabled={loading}
                        onClick={handleChangeSubmit}
                        style={{ background: "black" }}
                      >
                        Next
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            </Modal.Body>
            : !showEOT ?
              <Modal.Body className="eb-bulk-modal-body">
                <div className="eb-bulk-table-scroll table-box scroll-container-table" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
                  <div className="eb-bulk-content">
                    <div className="eb-bulk-actions" style={{ justifyContent: 'space-between' }}>
                      <button
                        type="button"
                        className="eb-bulk-add-row-btn"
                        style={{ background: '#718096' }}
                        disabled={loading}
                        onClick={handleChangeback}
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <polyline points="15 18 9 12 15 6" />
                        </svg>
                        Back
                      </button>
                      <button
                        type="button"
                        className="eb-bulk-add-row-btn"
                        disabled={loading}
                        onClick={handleShowWOT}
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <circle cx="12" cy="12" r="10" />
                          <line x1="12" y1="8" x2="12" y2="16" />
                          <line x1="8" y1="12" x2="16" y2="12" />
                        </svg>
                        Add Revised EOT/COS
                      </button>
                    </div>

                    <div className="eb-bulk-table-wrapper">
                      <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
                        <table className="eb-bulk-table">
                          <thead className="eb-bulk-table-head">
                            <tr className="eb-bulk-table-header-row">
                              <th className="eb-bulk-th eb-bulk-th-rank">
                                <span className="eb-bulk-th-label">Rank</span>
                              </th>
                              <th className="eb-bulk-th eb-bulk-th-designation">
                                <span className="eb-bulk-th-label">Designations</span>
                                <span className="eb-bulk-th-sub">(Read-Only)</span>
                              </th>
                              <th className="eb-bulk-th eb-bulk-th-professional">
                                <span className="eb-bulk-th-label">Professional Type</span>
                                <span className="eb-bulk-th-sub">(Read-Only)</span>
                              </th>
                              <th className="eb-bulk-th eb-bulk-th-employee">
                                <span className="eb-bulk-th-label">Employee Name</span>
                              </th>
                              <th className="eb-bulk-th eb-bulk-th-period">
                                <span className="eb-bulk-th-label">MM Construction Period</span>
                                <span className="eb-bulk-th-sub">(In-Months)</span>
                              </th>
                              <th className="eb-bulk-th eb-bulk-th-period">
                                <span className="eb-bulk-th-label">MM O&M Period</span>
                                <span className="eb-bulk-th-sub">(In-Months)</span>
                              </th>
                              <th className="eb-bulk-th eb-bulk-th-total">
                                <span className="eb-bulk-th-label">Total MM</span>
                                <span className="eb-bulk-th-sub">(Read-Only)</span>
                              </th>
                              <th className="eb-bulk-th eb-bulk-th-rate">
                                <span className="eb-bulk-th-label">Rate</span>
                                <span className="eb-bulk-th-sub">(Monthly-Rate)</span>
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {formData.map((entry, index) => (
                              <tr key={index} className="eb-bulk-row">
                                <td className="eb-bulk-td eb-bulk-td-rank">
                                  <input
                                    name="rank"
                                    value={entry.rank}
                                    onChange={(e) => handleInputChange(e, index)}
                                    className={`eb-bulk-input eb-bulk-input-rank ${errors[`${index}_rank`] ? "eb-bulk-input-error" : ""}`}
                                    type="text"
                                    placeholder="#"
                                  />
                                </td>
                                <td className="eb-bulk-td">
                                  <span style={{ fontWeight: '500', color: '#2d3748' }}>{entry.designation_name}</span>
                                </td>
                                <td className="eb-bulk-td">
                                  <span style={{ fontWeight: '500', color: '#2d3748' }}>{entry.professional_type}</span>
                                </td>
                                <td className="eb-bulk-td">
                                  <Select
                                    options={getEmployeeOptions(entry.designation)}
                                    onChange={(selected) => handleChangecc(index, selected)}
                                    isMulti
                                    value={getSelectedEmployees(entry)}
                                    styles={CSSForSelectModern}
                                    placeholder="Select Employees"
                                  />
                                </td>
                                <td className="eb-bulk-td">
                                  <div className="eb-bulk-input-wrapper">
                                    <input
                                      className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_MM_construction_period`] ? "eb-bulk-input-error" : ""}`}
                                      id={`MM_construction_period_${index}`}
                                      name="MM_construction_period"
                                      type="number"
                                      value={entry.MM_construction_period}
                                      onChange={(e) => handleInputChange(e, index)}
                                      placeholder="0"
                                    />
                                    {errors[`${index}_MM_construction_period`] && (
                                      <span className="eb-bulk-error-text">{errors[`${index}_MM_construction_period`]}</span>
                                    )}
                                  </div>
                                </td>
                                <td className="eb-bulk-td">
                                  <div className="eb-bulk-input-wrapper">
                                    <input
                                      className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_MM_OM_period`] ? "eb-bulk-input-error" : ""}`}
                                      id={`MM_OM_period_${index}`}
                                      name="MM_OM_period"
                                      type="text"
                                      value={entry.MM_OM_period}
                                      onChange={(e) => handleInputChange(e, index)}
                                      placeholder="0"
                                    />
                                    {errors[`${index}_MM_OM_period`] && (
                                      <span className="eb-bulk-error-text">{errors[`${index}_MM_OM_period`]}</span>
                                    )}
                                  </div>
                                </td>
                                <td className="eb-bulk-td eb-bulk-td-total">
                                  <span className="eb-bulk-total-value">
                                    {Number(entry.MM_OM_period || 0) + Number(entry.MM_construction_period || 0)}
                                  </span>
                                </td>
                                <td className="eb-bulk-td">
                                  <div className="eb-bulk-input-wrapper">
                                    <input
                                      className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_rate`] ? "eb-bulk-input-error" : ""}`}
                                      id={`rate_${index}`}
                                      name="rate"
                                      type="text"
                                      value={entry.rate}
                                      onChange={(e) => handleInputChange(e, index)}
                                      placeholder="₹ 0.00"
                                    />
                                    {errors[`${index}_rate`] && (
                                      <span className="eb-bulk-error-text">{errors[`${index}_rate`]}</span>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="eb-bulk-footer-actions">
                      <button
                        className="eb-bulk-btn eb-bulk-btn-cancel"
                        onClick={handleClose}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="eb-bulk-btn eb-bulk-btn-submit"
                        disabled={loading}
                        onClick={handleSubmit}
                        style={{ background: "black" }}
                      >
                        {loading ? (
                          <span className="eb-bulk-btn-loader">
                            <span className="eb-bulk-spinner"></span>
                            Updating...
                          </span>
                        ) : (
                          <>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                              <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                            </svg>
                            Update
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
                <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
              </Modal.Body>
              : showEOT === true ?
                <Modal.Body className="eb-bulk-modal-body">
                  <div className="eb-bulk-container">
                    <div className="eb-bulk-content">
                      <div className="eb-bulk-actions" style={{ justifyContent: 'space-between' }}>
                        <button
                          type="button"
                          className="eb-bulk-add-row-btn"
                          style={{ background: '#718096' }}
                          disabled={loading}
                          onClick={handleclOSEOT}
                        >
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="15 18 9 12 15 6" />
                          </svg>
                          Back
                        </button>
                        <button
                          type="button"
                          className="eb-bulk-add-row-btn"
                          disabled={loading}
                          onClick={addNewEOT}
                        >
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="12" cy="12" r="10" />
                            <line x1="12" y1="8" x2="12" y2="16" />
                            <line x1="8" y1="12" x2="16" y2="12" />
                          </svg>
                          Add Another Revised EOT/COS
                        </button>
                      </div>
                      <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
                        {formData[0]?.eot_details?.map((_, detailIndex) => (
                          <div key={detailIndex} style={{ marginBottom: '24px' }}>
                            <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#2d3748', marginBottom: '12px' }}>
                              EOT Round {detailIndex + 1}
                            </h3>
                            <div className="eb-bulk-table-wrapper">
                              <table className="eb-bulk-table">
                                <thead className="eb-bulk-table-head">
                                  <tr className="eb-bulk-table-header-row">
                                    <th className="eb-bulk-th"><span className="eb-bulk-th-label">Designation</span></th>
                                    <th className="eb-bulk-th"><span className="eb-bulk-th-label">Professional Type</span></th>
                                    <th className="eb-bulk-th"><span className="eb-bulk-th-label">CP</span></th>
                                    <th className="eb-bulk-th"><span className="eb-bulk-th-label">DLP</span></th>
                                    <th className="eb-bulk-th"><span className="eb-bulk-th-label">T Month</span></th>
                                    <th className="eb-bulk-th"><span className="eb-bulk-th-label">Rate</span></th>
                                    <th className="eb-bulk-th"><span className="eb-bulk-th-label">Total Amount</span></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {formData.sort((a, b) => a.rank - b.rank).map((entry, entryIndex) => (
                                    <tr key={entryIndex} className="eb-bulk-row">
                                      <td className="eb-bulk-td"><span style={{ fontWeight: '500' }}>{entry.designation_name}</span></td>
                                      <td className="eb-bulk-td"><span style={{ fontWeight: '500' }}>{entry.professional_type}</span></td>
                                      <td className="eb-bulk-td">
                                        <input
                                          type="number"
                                          className={`eb-bulk-input eb-bulk-input-number ${errors[`${entryIndex}_cp`] ? "eb-bulk-input-error" : ""}`}
                                          value={entry.eot_details[detailIndex]?.cp || 0}
                                          onChange={(e) =>
                                            handleEOTChange(entryIndex, detailIndex, "cp", e.target.value)
                                          }
                                          placeholder="0"
                                        />
                                      </td>
                                      <td className="eb-bulk-td">
                                        <input
                                          type="number"
                                          className={`eb-bulk-input eb-bulk-input-number ${errors[`${entryIndex}_dlp`] ? "eb-bulk-input-error" : ""}`}
                                          value={entry.eot_details[detailIndex]?.dlp || 0}
                                          onChange={(e) =>
                                            handleEOTChange(entryIndex, detailIndex, "dlp", e.target.value)
                                          }
                                          placeholder="0"
                                        />
                                      </td>
                                      <td className="eb-bulk-td">
                                        <input
                                          type="number"
                                          value={entry.eot_details[detailIndex]?.t_month ?? "0"}
                                          className="eb-bulk-input eb-bulk-input-number"
                                          disabled
                                          style={{ background: '#f7fafc', opacity: 0.8 }}
                                        />
                                      </td>
                                      <td className="eb-bulk-td">
                                        <input
                                          type="number"
                                          className={`eb-bulk-input eb-bulk-input-number ${errors[`${entryIndex}_rate`] ? "eb-bulk-input-error" : ""}`}
                                          placeholder={entry.eot_details[detailIndex]?.rate || 0}
                                          value={entry.eot_details[detailIndex]?.rate}
                                          onChange={(e) =>
                                            handleEOTChange(entryIndex, detailIndex, "rate", e.target.value)
                                          }
                                        />
                                      </td>
                                      <td className="eb-bulk-td eb-bulk-td-total">
                                        <span className="eb-bulk-total-value" style={{ minWidth: '80px' }}>
                                          {entry.eot_details[detailIndex]?.total_amount || 0}
                                        </span>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        ))}
                      </div>


                      <div className="eb-bulk-footer-actions">
                        <button
                          className="eb-bulk-btn eb-bulk-btn-cancel"
                          onClick={handleClose}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="eb-bulk-btn eb-bulk-btn-submit"
                          disabled={loading}
                          onClick={handleSubmit}
                          style={{ background: "black" }}
                        >
                          {loading ? (
                            <span className="eb-bulk-btn-loader">
                              <span className="eb-bulk-spinner"></span>
                              Saving...
                            </span>
                          ) : (
                            <>
                              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" />
                                <polyline points="17 21 17 13 7 13 7 21" />
                                <polyline points="7 3 7 8 15 8" />
                              </svg>
                              Save
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </Modal.Body>
                : ""
          }
        </Modal>
      }
    </>
  )
}
const BulkUpdateTransportData = ({ boqtransportList, i, getData, id, value, getLogData }) => {

  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState([]);
  const [changeReason, setChangeReason] = useState("null");
  const [showChange, setShowChange] = useState(false);




  const createdAt = new Date().toISOString();

  const createdAtRef = useRef(new Date().toISOString());

  // 2. Fix the first useEffect
  useEffect(() => {
    if (!showChange) {
      setFormData((prevData) =>
        prevData.map((item) => ({
          ...item,
          random_value_of_changes: createdAtRef.current, // stable reference
        }))
      );
    }
  }, [showChange]);


  useEffect(() => {
    if (changeReason !== "null") {
      setFormData((prevData) =>
        prevData.map((item) => ({
          ...item,
          reason_of_change: changeReason,
        }))
      );
    }
  }, [changeReason]);



  useEffect(() => {
    if (Array.isArray(boqtransportList)) {
      const initialData = boqtransportList.map((item) => ({
        rate: "",
        vehicle_description: "",
        project: id,
        during_dlp_OM_period: "",
        designation_name: "",
        during_construction_period: "",
        random_value_of_changes: "",
        reason_of_change: changeReason !== "null" ? changeReason : "",
        change_by_emp_code: sessionStorage.getItem('sitemanagement_emp_code'),
        change_by_emp_name: sessionStorage.getItem('name'),
        eot_details: [{
          boqId: item.id,
          vehicle_description: item.vehicle_description,
          cp: "",
          dlp: "",
          t_month: "",
          rate: "",
          total_amount: "",
        }],
      }));
      setFormData(initialData);
    }
  }, [boqtransportList]);











  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const [inputState, setInputState] = useState({});



  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => {
      const newFields = [...prevFormData];
      newFields[index] = {
        ...newFields[index],
        [name]: value,
      };
      return newFields;
    });
  }

  const handleShow = () => {
    setShow(true);
    setFormData(boqtransportList);
  }


  const handleChangeSubmit = () => {
    setShowChange(true);
    setShowEOT(false)
  }
  const handleChangeback = () => {
    setShowChange(false);

  }


  const handleClose = () => {
    setShow(false);
    setShowChange(false);
    setShowEOT(false)
    setChangeReason("");
  }

  const [loading, setLoading] = useState(false); //loading logic

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

      try {
        let res = await axios.put(
          `${BASE_URL}/siteproject/bulkBOQTransport/`,
          formData
        );

        if (res.status === 200) {
          await getData();
          await getLogData();
          handleClose();
          toast.dismiss(loadingToastId); // Dismiss loading toast
          toast.success('Transportation BOQ data updated successfully.')
          // window.location.reload();
        } else {
          alert(res);
        }
      } catch (err) {
        //toast Logic
        handleErrorToast(err, loadingToastId);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  const [showEOT, setShowEOT] = useState(false);
  const handleShowWOT = () => {
    setShowEOT(true)
  }
  const handleclOSEOT = () => {
    setShowEOT(false)
  }


  const addNewEOT = () => {
    setFormData((prevFormData) =>
      prevFormData.map((entry) => ({
        ...entry,
        eot_details: [
          ...(entry.eot_details || []),
          {
            boqId: entry.boqId || entry.id,
            cp: "",
            dlp: "",
            t_month: "",
            rate: "",
            total_amount: "",
          },
        ],
      }))
    );
  };


  useEffect(() => {
    if (Array.isArray(boqtransportList)) {
      const initialData = boqtransportList.map((item) => ({
        rate: "",
        vehicle_description: "",
        project: id,
        during_dlp_OM_period: "",
        designation_name: "",
        during_construction_period: "",
        random_value_of_changes: "",
        reason_of_change: changeReason !== "null" ? changeReason : "",
        change_by_emp_code: sessionStorage.getItem('sitemanagement_emp_code'),
        change_by_emp_name: sessionStorage.getItem('name'),
        eot_details: [{
          boqId: item.id,
          vehicle_description: item.vehicle_description,
          cp: "",
          dlp: "",
          t_month: "",
          rate: "",
          total_amount: "",
        }],
      }));
      setFormData(initialData);
      setShowEOT(true); // ✅ show EOT table immediately

    }
  }, [boqtransportList]);



  const handleEOTChange = (entryIndex, detailIndex, field, value) => {
    setFormData((prevFormData) =>
      prevFormData.map((entry, i) => {
        if (i !== entryIndex) return entry;

        const updatedDetails = entry.eot_details.map((detail, j) => {
          if (j !== detailIndex) return detail;

          const updatedDetail = { ...detail, [field]: value };

          // Auto-calc t_month = cp + dlp
          const cp = parseFloat(updatedDetail.cp) || 0;
          const dlp = parseFloat(updatedDetail.dlp) || 0;
          updatedDetail.t_month = cp + dlp;

          // Auto-calc total_amount = t_month * rate
          const rate = parseFloat(updatedDetail.rate) || 0;
          updatedDetail.total_amount = updatedDetail.t_month * rate;

          return updatedDetail;
        });

        return { ...entry, eot_details: updatedDetails };
      })
    );
  };
  // return (
  //   <>
  //     <button title="Update Transportation" className="upload-svg flex-row" onClick={handleShow}>
  //       <svg
  //         xmlns="http://www.w3.org/2000/svg"
  //         width="24"
  //         height="24"
  //         fill="white"
  //         viewBox="0 0 24 24"
  //         id="pen-new-square"
  //       >
  //         <path
  //           fill=""
  //           fill-rule="evenodd"
  //           d="M11.9426 1.25L13.5 1.25C13.9142 1.25 14.25 1.58579 14.25 2C14.25 2.41421 13.9142 2.75 13.5 2.75H12C9.62177 2.75 7.91356 2.75159 6.61358 2.92637C5.33517 3.09825 4.56445 3.42514 3.9948 3.9948C3.23505 4.75455 2.91245 5.86509 2.80417 8.03734C2.78355 8.45104 2.43146 8.76969 2.01776 8.74907C1.60406 8.72845 1.28541 8.37636 1.30603 7.96266C1.41642 5.74802 1.74641 4.12187 2.93414 2.93414C3.82895 2.03933 4.96897 1.63399 6.41371 1.43975C7.82519 1.24998 9.63423 1.24999 11.9426 1.25ZM22 9.75C22.4142 9.75 22.75 10.0858 22.75 10.5V12.0574C22.75 14.3658 22.75 16.1748 22.5603 17.5863C22.366 19.031 21.9607 20.1711 21.0659 21.0659C20.1711 21.9607 19.031 22.366 17.5863 22.5603C16.1748 22.75 14.3658 22.75 12.0574 22.75H11.9426C9.63423 22.75 7.82519 22.75 6.41371 22.5603C4.96897 22.366 3.82895 21.9607 2.93414 21.0659C2.03933 20.1711 1.63399 19.031 1.43975 17.5863C1.24998 16.1748 1.24999 14.3658 1.25 12.0574L1.25 12C1.25 11.5858 1.58579 11.25 2 11.25C2.41421 11.25 2.75 11.5858 2.75 12C2.75 14.3782 2.75159 16.0864 2.92637 17.3864C3.09825 18.6648 3.42514 19.4355 3.9948 20.0052C4.56445 20.5749 5.33517 20.9018 6.61358 21.0736C7.91356 21.2484 9.62177 21.25 12 21.25C14.3782 21.25 16.0864 21.2484 17.3864 21.0736C18.6648 20.9018 19.4355 20.5749 20.0052 20.0052C20.5749 19.4355 20.9018 18.6648 21.0736 17.3864C21.2484 16.0864 21.25 14.3782 21.25 12V10.5C21.25 10.0858 21.5858 9.75 22 9.75Z"
  //           clip-rule="evenodd"
  //         ></path>
  //         <path
  //           fill=""
  //           fill-rule="evenodd"
  //           d="M16.7705 2.27592C18.1384 0.908029 20.3562 0.908029 21.7241 2.27592C23.092 3.6438 23.092 5.86158 21.7241 7.22947L18.0928 10.8607C17.7999 11.1536 17.3251 11.1536 17.0322 10.8607C16.7393 10.5678 16.7393 10.093 17.0322 9.80006L19.1051 7.72709C18.5892 7.50519 17.9882 7.14946 17.4193 6.58065C16.8505 6.01185 16.4948 5.41082 16.2729 4.89486L11.2175 9.95026C10.801 10.3668 10.6376 10.532 10.4988 10.71C10.3274 10.9297 10.1804 11.1676 10.0605 11.4192C9.96337 11.623 9.88868 11.8429 9.7024 12.4017L9.27051 13.6974L10.3026 14.7295L11.5983 14.2976C12.1571 14.1113 12.377 14.0366 12.5808 13.9395C12.8324 13.8196 13.0703 13.6726 13.2901 13.5012C13.468 13.3624 13.6332 13.199 14.0497 12.7825C14.3426 12.4896 14.8175 12.4896 15.1104 12.7825C15.4033 13.0754 15.4033 13.5503 15.1104 13.8432L15.076 13.8776C14.7047 14.2489 14.4721 14.4815 14.2126 14.684C13.9069 14.9224 13.5761 15.1268 13.2261 15.2936C12.929 15.4352 12.6169 15.5392 12.1188 15.7052L9.21426 16.6734C8.67801 16.8521 8.0868 16.7126 7.68711 16.3129C7.28742 15.9132 7.14785 15.322 7.3266 14.7857L8.29477 11.8812C8.46079 11.3831 8.56479 11.071 8.7064 10.7739C8.87319 10.4239 9.07761 10.0931 9.31605 9.78742C9.51849 9.52787 9.7511 9.29529 10.1224 8.92401L16.7705 2.27592ZM17.4546 3.7132C17.4773 3.80906 17.509 3.92327 17.5532 4.05066C17.6965 4.46372 17.9677 5.00771 18.48 5.51999C18.9923 6.03227 19.5363 6.30346 19.9493 6.44677C20.0767 6.49097 20.1909 6.52273 20.2868 6.54543L20.6634 6.16881C21.4455 5.38671 21.4455 4.11867 20.6634 3.33658C19.8813 2.55448 18.6133 2.55448 17.8312 3.33658L17.4546 3.7132Z"
  //           clip-rule="evenodd"
  //         ></path>
  //       </svg>
  //       {" "} Update Transportation
  //     </button>
  //     <Modal
  //       show={show}
  //       onHide={handleClose}
  //       dialogClassName={!showChange ? "request-leave" : "request-leave-document"}
  //     >
  //       <Modal.Header closeButton >
  //         <Modal.Title>Update Transportation Data for BOQ</Modal.Title>

  //       </Modal.Header>
  //       {
  //         !showChange ?
  //           <Modal.Body>
  //             <div className="parent-div">
  //               <div className="bdy-div">
  //                 <div className="flex-column align-items-center">
  //                   <label className="form-labels font-weight500 font-size-subheading" title="Invoice Number">
  //                     Reason for Change BOQ<span className="required">*</span>
  //                   </label>
  //                   <input
  //                     type="text"
  //                     name="changeReason"
  //                     title="Reason for Change BOQ"
  //                     placeholder="Example- Revise EOT"
  //                     onChange={(e) => setChangeReason(e.target.value)}
  //                     className={`form-input ${errors.changeReason ? "is-invalid" : ""
  //                       }`}
  //                   />
  //                 </div>
  //                 <div className="button-models">
  //                   <button
  //                     className="model-button-cancel model-button font-weight500"
  //                     onClick={handleClose}
  //                   >
  //                     Cancel
  //                   </button>
  //                   {(changeReason !== "null" && changeReason !== "") && (
  //                     <button
  //                       type="submit"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleChangeSubmit}
  //                     >
  //                       Next
  //                     </button>
  //                   )}

  //                 </div>

  //               </div>
  //             </div>
  //             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

  //           </Modal.Body>
  //           : showEOT === false ?
  //             <Modal.Body>
  //               <div className="parent-div">
  //                 <div className="bdy-div">
  //                   <div className='flex-row justify-between'>
  //                     <button
  //                       type="button"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleChangeback}
  //                     >
  //                       Back
  //                     </button>
  //                     <button
  //                       type="button"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleShowWOT}
  //                     >
  //                       <AddwithWhiteCircle /> Add Revised EOT/COS
  //                     </button>
  //                   </div>
  //                   <div className="flex-row justify-center">
  //                     <table className="table-css ">
  //                       <thead className="table-heading">
  //                         <tr className="custom-table-head-tr width-10vw">
  //                           <th className="table-heading-text text-left-sr" >S no.</th>
  //                           <th className="table-heading-text text-center">Description of Vehicles <br /> <span className="required">(Read-Only)</span></th>
  //                           <th className="table-heading-text text-center">Duration of Construction Period <br /><span className="required">(In-Months)</span></th>
  //                           <th className="table-heading-text text-center">Duration of DLP <br /><span className="required">(In-Months)</span></th>
  //                           <th className="table-heading-text text-center">Total Period <br /> <span className="required">(Read-Only)</span></th>
  //                           <th className="table-heading-text text-center">Rate  <br /> <span className="required">(Monthly-Rate)</span></th>
  //                         </tr>
  //                       </thead>

  //                       <tbody>

  //                         {formData.map((entry, index) => (
  //                           <tr key={index} className="custom-table-head-td ">

  //                             <td className="align-left width-5vw" >
  //                               {index + 1}.
  //                             </td>
  //                             <td>
  //                               <div title="Vehicle Description" className="flex-column align-items-center">
  //                                 <input
  //                                   className={`form-input width-20vw  ${errors[`${index}_vehicle_description`] ? "error" : ""}`}
  //                                   id={`vehicle_description_${index}`}
  //                                   name="vehicle_description"
  //                                   type="text"
  //                                   value={entry.vehicle_description}
  //                                   onChange={(e) => handleInputChange(e, index)}
  //                                   readOnly

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_vehicle_description`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_vehicle_description`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>

  //                             <td className=''>
  //                               <div title="CP" className="flex-column align-items-center align-items-center">
  //                                 <input
  //                                   className={`form-input width-5vw ${errors[`${index}_during_construction_period`] ? "error" : ""}`}
  //                                   id={`during_construction_period_${index}`}
  //                                   name="during_construction_period"
  //                                   type="text"
  //                                   value={entry.during_construction_period}
  //                                   onChange={(e) => handleInputChange(e, index)}

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_during_construction_period`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_during_construction_period`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>
  //                             <td>
  //                               <div title="O&M Period" className="flex-column align-items-center">
  //                                 <input
  //                                   className={`form-input-date  width-5vw  ${errors[`${index}_during_dlp_OM_period`] ? "error" : ""}`}
  //                                   id={`during_dlp_OM_period_${index}`}
  //                                   name="during_dlp_OM_period"
  //                                   type="number"
  //                                   value={entry.during_dlp_OM_period}
  //                                   onChange={(e) => handleInputChange(e, index)}

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_during_dlp_OM_period`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_during_dlp_OM_period`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>
  //                             <td>
  //                               <div title="Total Period" className="flex-column align-items-center">
  //                                 <input
  //                                   className={`form-input-date  width-5vw  ${errors[`${index}_num_of_man_month`] ? "error" : ""}`}
  //                                   id={`num_of_man_month_${index}`}
  //                                   name="num_of_man_month"
  //                                   type="text"
  //                                   value={Number(entry.during_construction_period || 0) + Number(entry.during_dlp_OM_period || 0)} // Calculate and display the sum
  //                                   onChange={(e) => handleInputChange(e, index)}
  //                                   readOnly
  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_num_of_man_month`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_num_of_man_month`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>
  //                             <td>
  //                               <div title="Rate" className="flex-column align-items-center">
  //                                 <input
  //                                   className={`form-input-date  width-5vw  ${errors[`${index}_rate`] ? "error" : ""}`}
  //                                   id={`rate_${index}`}
  //                                   name="rate"
  //                                   type="text"
  //                                   value={entry.rate}
  //                                   onChange={(e) => handleInputChange(e, index)}

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_rate`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_rate`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>


  //                           </tr>
  //                         ))}

  //                       </tbody>

  //                     </table>
  //                   </div>
  //                   <div className="button-models">
  //                     <button
  //                       className="model-button-cancel model-button font-weight500"
  //                       onClick={handleClose}
  //                     >
  //                       Cancel
  //                     </button>
  //                     <button
  //                       type="submit"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleSubmit}
  //                     >
  //                       Update
  //                     </button>
  //                   </div>

  //                 </div>
  //               </div>
  //               <ToastContainer
  //                 position="top-center"
  //                 autoClose={1000}
  //                 hideProgressBar={false}
  //                 newestOnTop={true}
  //                 closeOnClick
  //                 rtl={false}
  //                 pauseOnFocusLoss
  //                 draggable
  //                 pauseOnHover
  //               />
  //             </Modal.Body> : showEOT === true ?
  //               <Modal.Body>
  //                 <div className="parent-div">
  //                   <div className="bdy-div">
  //                     <div className='flex-row justify-between'>
  //                       <button
  //                         type="button"
  //                         className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                         disabled={loading}
  //                         onClick={handleclOSEOT}
  //                       >
  //                         Back
  //                       </button>
  //                       <button
  //                         type="button"
  //                         className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                         disabled={loading}
  //                         onClick={addNewEOT}
  //                       >
  //                         <AddwithWhiteCircle /> Add Another Revised EOT/COS
  //                       </button>
  //                     </div>
  //                     {formData[0]?.eot_details?.map((_, detailIndex) => (
  //                       <div key={detailIndex}>
  //                         <h3>EOT Round {detailIndex + 1}</h3>
  //                         <table className="nested-table-lightblue width-90vw payment">

  //                           <thead>
  //                             <tr>
  //                               <th>Vehicle Descritption</th>
  //                               <th>CP</th>
  //                               <th>DLP</th>
  //                               <th>T Month</th>
  //                               <th>Rate</th>
  //                               <th>Total Amount</th>
  //                             </tr>
  //                           </thead>
  //                           <tbody>
  //                             {formData.map((entry, entryIndex) => (
  //                               <tr key={entryIndex}>
  //                                 <td>{entry.vehicle_description}</td>
  //                                 <td>
  //                                   <input
  //                                     type="number"
  //                                     className={`form-input-date  width-5vw  ${errors[`${entryIndex}_cp`] ? "error" : ""}`}

  //                                     value={entry.eot_details[detailIndex]?.cp || ""}
  //                                     onChange={(e) =>
  //                                       handleEOTChange(entryIndex, detailIndex, "cp", e.target.value)
  //                                     }
  //                                   />
  //                                 </td>
  //                                 <td>
  //                                   <input
  //                                     type="number"
  //                                     className={`form-input-date  width-5vw  ${errors[`${entryIndex}_dlp`] ? "error" : ""}`}

  //                                     value={entry.eot_details[detailIndex]?.dlp || ""}
  //                                     onChange={(e) =>
  //                                       handleEOTChange(entryIndex, detailIndex, "dlp", e.target.value)
  //                                     }
  //                                   />
  //                                 </td>
  //                                 <td>
  //                                   <input
  //                                     type="number"
  //                                     value={entry.eot_details[detailIndex]?.t_month || ""}
  //                                     className={`form-input-date  width-5vw  ${errors[`${entryIndex}_t_month`] ? "error" : ""}`}
  //                                     disabled
  //                                     onChange={(e) =>
  //                                       handleEOTChange(
  //                                         entryIndex,
  //                                         detailIndex,
  //                                         "t_month",
  //                                         e.target.value
  //                                       )
  //                                     }
  //                                   />
  //                                 </td>
  //                                 <td>
  //                                   <input
  //                                     type="number"
  //                                     value={entry.eot_details[detailIndex]?.rate || ""}
  //                                     onChange={(e) =>
  //                                       handleEOTChange(entryIndex, detailIndex, "rate", e.target.value)
  //                                     }
  //                                     className={`form-input-date  width-5vw  ${errors[`${entryIndex}_rate`] ? "error" : ""}`}

  //                                   />
  //                                 </td>
  //                                 <td>
  //                                   <input
  //                                     type="number"
  //                                     className={`form-input-date  width-5vw  ${errors[`${entryIndex}_total_amount`] ? "error" : ""}`}
  //                                     disabled
  //                                     value={entry.eot_details[detailIndex]?.total_amount || ""}
  //                                     onChange={(e) =>
  //                                       handleEOTChange(
  //                                         entryIndex,
  //                                         detailIndex,
  //                                         "total_amount",
  //                                         e.target.value
  //                                       )
  //                                     }
  //                                   />
  //                                 </td>
  //                               </tr>
  //                             ))}
  //                           </tbody>
  //                         </table>
  //                       </div>
  //                     ))}

  //                     <div className="button-models">
  //                       <button
  //                         className="model-button-cancel model-button font-weight500"
  //                         onClick={handleClose}
  //                       >
  //                         Cancel
  //                       </button>
  //                       <button
  //                         type="submit"
  //                         className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                         disabled={loading}
  //                         onClick={handleSubmit}
  //                       >
  //                         Save
  //                       </button>
  //                     </div>

  //                   </div>
  //                 </div>
  //                 <ToastContainer
  //                   position="top-center"
  //                   autoClose={1000}
  //                   hideProgressBar={false}
  //                   newestOnTop={true}
  //                   closeOnClick
  //                   rtl={false}
  //                   pauseOnFocusLoss
  //                   draggable
  //                   pauseOnHover
  //                 />
  //               </Modal.Body > : ""
  //       }

  //     </Modal >
  //   </>
  // )

  return (
    <>
      <button
        title="Update Transportation"
        className="eb-bulk-trigger-btn"
        onClick={handleShow}
        style={{ background: "black" }}
      >
        <CarFrontIcon />
        Update Transportation
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName={!showChange ? "eb-bulk-modal request-leave" : "max-heightModal eb-bulk-modal model-width90vw"}
      >
        <Modal.Header className="eb-bulk-modal-header">
          <Modal.Title className="eb-bulk-modal-title">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
              <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
            </svg>
            Update Transportation Data for BOQ
            <button className="close-btn" onClick={handleClose} style={{ marginLeft: 'auto', background: 'none', border: 'none', color: 'white', fontSize: '24px', cursor: 'pointer' }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </Modal.Title>
        </Modal.Header>

        {!showChange ?
          <Modal.Body className="eb-bulk-modal-body">
            <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
              <div className="eb-bulk-content">
                <div className="eb-bulk-reason-section" style={{ padding: '20px', background: '#f7fafc', borderRadius: '12px' }}>
                  <label className="eb-bulk-label" style={{ display: 'block', fontWeight: '600', marginBottom: '8px', color: '#2d3748' }}>
                    Reason for Change BOQ <span className="eb-bulk-required">*</span>
                  </label>
                  <input
                    type="text"
                    name="changeReason"
                    title="Reason for Change BOQ"
                    placeholder="Example- Revise EOT"
                    onChange={(e) => setChangeReason(e.target.value)}
                    className="eb-bulk-input"
                    style={{ width: '90%', padding: '12px 16px', fontSize: '14px' }}
                  />
                </div>

                <div className="eb-bulk-footer-actions" style={{ justifyContent: 'flex-end' }}>
                  <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                    Cancel
                  </button>
                  {(changeReason !== "null" && changeReason !== "") && (
                    <button
                      type="submit"
                      className="eb-bulk-btn eb-bulk-btn-submit"
                      disabled={loading}
                      onClick={handleChangeSubmit}
                      style={{ background: "black" }}
                    >
                      Next
                    </button>
                  )}
                </div>
              </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </Modal.Body>

          : showEOT === false ?
            <Modal.Body className="eb-bulk-modal-body">
              <div className="eb-bulk-table-scroll table-box scroll-container-table" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
                <div className="eb-bulk-content">
                  <div className="eb-bulk-actions" style={{ justifyContent: 'space-between' }}>
                    <button
                      type="button"
                      className="eb-bulk-add-row-btn"
                      style={{ background: '#718096' }}
                      disabled={loading}
                      onClick={handleChangeback}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="15 18 9 12 15 6" />
                      </svg>
                      Back
                    </button>
                    <button
                      type="button"
                      className="eb-bulk-add-row-btn"
                      disabled={loading}
                      onClick={handleShowWOT}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="12" y1="8" x2="12" y2="16" />
                        <line x1="8" y1="12" x2="16" y2="12" />
                      </svg>
                      Add Revised EOT/COS
                    </button>
                  </div>

                  <div className="eb-bulk-table-wrapper">
                    <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
                      <table className="eb-bulk-table">
                        <thead className="eb-bulk-table-head">
                          <tr className="eb-bulk-table-header-row">
                            <th className="eb-bulk-th eb-bulk-th-rank">
                              <span className="eb-bulk-th-label">S.No</span>
                            </th>
                            <th className="eb-bulk-th">
                              <span className="eb-bulk-th-label">Description of Vehicles</span>
                              <span className="eb-bulk-th-sub">(Read-Only)</span>
                            </th>
                            <th className="eb-bulk-th eb-bulk-th-period">
                              <span className="eb-bulk-th-label">Duration of Construction Period</span>
                              <span className="eb-bulk-th-sub">(In-Months)</span>
                            </th>
                            <th className="eb-bulk-th eb-bulk-th-period">
                              <span className="eb-bulk-th-label">Duration of DLP</span>
                              <span className="eb-bulk-th-sub">(In-Months)</span>
                            </th>
                            <th className="eb-bulk-th eb-bulk-th-total">
                              <span className="eb-bulk-th-label">Total Period</span>
                              <span className="eb-bulk-th-sub">(Read-Only)</span>
                            </th>
                            <th className="eb-bulk-th eb-bulk-th-rate">
                              <span className="eb-bulk-th-label">Rate</span>
                              <span className="eb-bulk-th-sub">(Monthly-Rate)</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {formData.map((entry, index) => (
                            <tr key={index} className="eb-bulk-row">
                              <td className="eb-bulk-td eb-bulk-td-rank">
                                <span style={{ fontWeight: '500', color: '#2d3748' }}>{index + 1}.</span>
                              </td>
                              <td className="eb-bulk-td">
                                <span style={{ fontWeight: '500', color: '#2d3748' }}>{entry.vehicle_description}</span>
                              </td>
                              <td className="eb-bulk-td">
                                <div className="eb-bulk-input-wrapper">
                                  <input
                                    className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_during_construction_period`] ? "eb-bulk-input-error" : ""}`}
                                    id={`during_construction_period_${index}`}
                                    name="during_construction_period"
                                    type="text"
                                    value={entry.during_construction_period}
                                    onChange={(e) => handleInputChange(e, index)}
                                    placeholder="0"
                                  />
                                  {errors[`${index}_during_construction_period`] && (
                                    <span className="eb-bulk-error-text">{errors[`${index}_during_construction_period`]}</span>
                                  )}
                                </div>
                              </td>
                              <td className="eb-bulk-td">
                                <div className="eb-bulk-input-wrapper">
                                  <input
                                    className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_during_dlp_OM_period`] ? "eb-bulk-input-error" : ""}`}
                                    id={`during_dlp_OM_period_${index}`}
                                    name="during_dlp_OM_period"
                                    type="number"
                                    value={entry.during_dlp_OM_period}
                                    onChange={(e) => handleInputChange(e, index)}
                                    placeholder="0"
                                  />
                                  {errors[`${index}_during_dlp_OM_period`] && (
                                    <span className="eb-bulk-error-text">{errors[`${index}_during_dlp_OM_period`]}</span>
                                  )}
                                </div>
                              </td>
                              <td className="eb-bulk-td eb-bulk-td-total">
                                <span className="eb-bulk-total-value">
                                  {Number(entry.during_construction_period || 0) + Number(entry.during_dlp_OM_period || 0)}
                                </span>
                              </td>
                              <td className="eb-bulk-td">
                                <div className="eb-bulk-input-wrapper">
                                  <input
                                    className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_rate`] ? "eb-bulk-input-error" : ""}`}
                                    id={`rate_${index}`}
                                    name="rate"
                                    type="text"
                                    value={entry.rate}
                                    onChange={(e) => handleInputChange(e, index)}
                                    placeholder="₹ 0.00"
                                  />
                                  {errors[`${index}_rate`] && (
                                    <span className="eb-bulk-error-text">{errors[`${index}_rate`]}</span>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="eb-bulk-footer-actions">
                    <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="eb-bulk-btn eb-bulk-btn-submit"
                      disabled={loading}
                      onClick={handleSubmit}
                      style={{ background: "black" }}
                    >
                      {loading ? (
                        <span className="eb-bulk-btn-loader">
                          <span className="eb-bulk-spinner"></span>
                          Updating...
                        </span>
                      ) : (
                        <>
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                            <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                          </svg>
                          Update
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
              <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            </Modal.Body>

            : showEOT === true ?
              <Modal.Body className="eb-bulk-modal-body">
                <div className="eb-bulk-container">
                  <div className="eb-bulk-content">
                    <div className="eb-bulk-actions" style={{ justifyContent: 'space-between' }}>
                      <button
                        type="button"
                        className="eb-bulk-add-row-btn"
                        style={{ background: '#718096' }}
                        disabled={loading}
                        onClick={handleclOSEOT}
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <polyline points="15 18 9 12 15 6" />
                        </svg>
                        Back
                      </button>
                      <button
                        type="button"
                        className="eb-bulk-add-row-btn"
                        disabled={loading}
                        onClick={addNewEOT}
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <circle cx="12" cy="12" r="10" />
                          <line x1="12" y1="8" x2="12" y2="16" />
                          <line x1="8" y1="12" x2="16" y2="12" />
                        </svg>
                        Add Another Revised EOT/COS
                      </button>
                    </div>

                    <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
                      {formData[0]?.eot_details?.map((_, detailIndex) => (
                        <div key={detailIndex} style={{ marginBottom: '24px' }}>
                          <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#2d3748', marginBottom: '12px' }}>
                            EOT Round {detailIndex + 1}
                          </h3>
                          <div className="eb-bulk-table-wrapper">
                            <table className="eb-bulk-table">
                              <thead className="eb-bulk-table-head">
                                <tr className="eb-bulk-table-header-row">
                                  <th className="eb-bulk-th"><span className="eb-bulk-th-label">Vehicle Description</span></th>
                                  <th className="eb-bulk-th"><span className="eb-bulk-th-label">CP</span></th>
                                  <th className="eb-bulk-th"><span className="eb-bulk-th-label">DLP</span></th>
                                  <th className="eb-bulk-th"><span className="eb-bulk-th-label">T Month</span></th>
                                  <th className="eb-bulk-th"><span className="eb-bulk-th-label">Rate</span></th>
                                  <th className="eb-bulk-th"><span className="eb-bulk-th-label">Total Amount</span></th>
                                </tr>
                              </thead>
                              <tbody>
                                {formData.map((entry, entryIndex) => (
                                  <tr key={entryIndex} className="eb-bulk-row">
                                    <td className="eb-bulk-td">
                                      <span style={{ fontWeight: '500' }}>{entry.vehicle_description}</span>
                                    </td>
                                    <td className="eb-bulk-td">
                                      <div className="eb-bulk-input-wrapper">

                                        <input
                                          type="number"
                                          className={`eb-bulk-input eb-bulk-input-number ${errors[`${entryIndex}_cp`] ? "eb-bulk-input-error" : ""}`}
                                          value={entry.eot_details[detailIndex]?.cp || ""}
                                          onChange={(e) => handleEOTChange(entryIndex, detailIndex, "cp", e.target.value)}
                                          placeholder="0"
                                        />
                                      </div>
                                    </td>
                                    <td className="eb-bulk-td">
                                      <div className="eb-bulk-input-wrapper">

                                        <input
                                          type="number"
                                          className={`eb-bulk-input eb-bulk-input-number ${errors[`${entryIndex}_dlp`] ? "eb-bulk-input-error" : ""}`}
                                          value={entry.eot_details[detailIndex]?.dlp || ""}
                                          onChange={(e) => handleEOTChange(entryIndex, detailIndex, "dlp", e.target.value)}
                                          placeholder="0"
                                        />
                                      </div>
                                    </td>
                                    <td className="eb-bulk-td">
                                      <div className="eb-bulk-input-wrapper">

                                        <input
                                          type="number"
                                          value={entry.eot_details[detailIndex]?.t_month || ""}
                                          className="eb-bulk-input eb-bulk-input-number"
                                          disabled
                                          style={{ background: '#f7fafc', opacity: 0.8 }}
                                        />
                                      </div>
                                    </td>
                                    <td className="eb-bulk-td">
                                      <div className="eb-bulk-input-wrapper">

                                        <input
                                          type="number"
                                          className={`eb-bulk-input eb-bulk-input-number ${errors[`${entryIndex}_rate`] ? "eb-bulk-input-error" : ""}`}
                                          value={entry.eot_details[detailIndex]?.rate || ""}
                                          onChange={(e) => handleEOTChange(entryIndex, detailIndex, "rate", e.target.value)}
                                          placeholder="₹ 0.00"
                                        />
                                      </div>
                                    </td>
                                    <td className="eb-bulk-td eb-bulk-td-total">
                                      <div className="eb-bulk-input-wrapper">

                                        <span className="eb-bulk-total-value" style={{ minWidth: '80px' }}>
                                          {entry.eot_details[detailIndex]?.total_amount || 0}
                                        </span>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      ))}
                    </div>

                    <div className="eb-bulk-footer-actions">
                      <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="eb-bulk-btn eb-bulk-btn-submit"
                        disabled={loading}
                        onClick={handleSubmit}
                        style={{ background: "black" }}
                      >
                        {loading ? (
                          <span className="eb-bulk-btn-loader">
                            <span className="eb-bulk-spinner"></span>
                            Saving...
                          </span>
                        ) : (
                          <>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" />
                              <polyline points="17 21 17 13 7 13 7 21" />
                              <polyline points="7 3 7 8 15 8" />
                            </svg>
                            Save
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
                <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
              </Modal.Body>
              : ""
        }
      </Modal>
    </>
  )
}
const BulkUpdateutyTravelData = ({ boqDutyTravelList, i, getData, id, value, getLogData }) => {

  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState([]);
  const [changeReason, setChangeReason] = useState("null");
  const [showChange, setShowChange] = useState(false);




  const createdAt = new Date().toISOString();

  useEffect(() => {
    if (!showChange) {
      setFormData((prevData) =>
        prevData.map((item) => ({
          ...item,
          random_value_of_changes: createdAt,
          change_by_emp_code: sessionStorage.getItem('sitemanagement_emp_code'),
          change_by_emp_name: sessionStorage.getItem('name'),

        }))
      );
    }

  }, [createdAt, showChange])




  useEffect(() => {
    if (changeReason !== "null") {
      setFormData((prevData) =>
        prevData.map((item) => ({
          ...item,
          reason_of_change: changeReason,

        }))
      );
    }
  }, [changeReason]);




  useEffect(() => {
    if (Array.isArray(boqDutyTravelList)) {
      const initialData = boqDutyTravelList.map((item) => ({
        trips: "",
        num_of_min_trip: "",
        rate_per_trip: "",
        during_dlp_OM_period: "",
        during_construction_period: "",
        project: id,
        random_value_of_changes: "",
        reason_of_change: changeReason !== "null" ? changeReason : "",
        change_by_emp_code: sessionStorage.getItem('sitemanagement_emp_code'),
        change_by_emp_name: sessionStorage.getItem('name'),
        eot_details: [{
          boqId: item.id,
          trips: item.trips,
          t_trips: "",
          rate: "",
          total_amount: "",
        }],
      }));
      setFormData(initialData);
    }
  }, [boqDutyTravelList]);






  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const [inputState, setInputState] = useState({});


  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => {
      const newFields = [...prevFormData];
      newFields[index] = {
        ...newFields[index],
        [name]: value,
      };
      return newFields;
    });
  };

  const handleShow = () => {
    setShow(true);
    setFormData(boqDutyTravelList);
  }


  const handleChangeSubmit = () => {
    setShowChange(true);
  }
  const handleChangeback = () => {
    setShowChange(false);

  }


  const handleClose = () => {
    setShow(false);
    setShowChange(false);
    setChangeReason("");
  }

  const [loading, setLoading] = useState(false); //loading logic

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

      try {
        let res = await axios.put(
          `${BASE_URL}/siteproject/bulkBOQDutyTravel/`,
          formData
        );

        if (res.status === 200) {
          await getData();
          await getLogData();
          handleClose();
          toast.dismiss(loadingToastId); // Dismiss loading toast
          toast.success('Duty travel BOQ data updated successfully.')
          // window.location.reload();
        } else {
          alert(res);
        }
      } catch (err) {
        //toast Logic
        handleErrorToast(err, loadingToastId);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  const [showEOT, setShowEOT] = useState(false);
  const handleShowWOT = () => {
    setShowEOT(true)
  }
  const handleclOSEOT = () => {
    setShowEOT(false)
  }


  const addNewEOT = () => {
    setFormData((prevFormData) =>
      prevFormData.map((entry) => ({
        ...entry,
        eot_details: [
          ...(entry.eot_details || []),
          {
            boqId: entry.boqId || entry.id,
            t_trips: "",
            rate: "",
            total_amount: "",
          },
        ],
      }))
    );
  };


  useEffect(() => {
    if (Array.isArray(boqDutyTravelList)) {
      const initialData = boqDutyTravelList.map((item) => ({
        trips: "",
        num_of_min_trip: "",
        rate_per_trip: "",
        during_dlp_OM_period: "",
        during_construction_period: "",
        project: id,
        random_value_of_changes: "",
        reason_of_change: changeReason !== "null" ? changeReason : "",
        change_by_emp_code: sessionStorage.getItem('sitemanagement_emp_code'),
        change_by_emp_name: sessionStorage.getItem('name'),
        eot_details: [{
          boqId: item.id,
          trips: item.trips,
          t_trips: "",
          rate: "",
          total_amount: "",
        }],
      }));
      setFormData(initialData);
      setShowEOT(true); // ✅ show EOT table immediately

    }
  }, [boqDutyTravelList]);



  const handleEOTChange = (entryIndex, detailIndex, field, value) => {
    setFormData((prevFormData) =>
      prevFormData.map((entry, i) => {
        if (i !== entryIndex) return entry;

        const updatedDetails = entry.eot_details.map((detail, j) => {
          if (j !== detailIndex) return detail;

          const updatedDetail = { ...detail, [field]: value };

          // Auto-calc t_month = cp + dlp
          const trips = parseFloat(updatedDetail.t_trips) || 0;

          // Auto-calc total_amount = t_month * rate
          const rate = parseFloat(updatedDetail.rate) || 0;
          updatedDetail.total_amount = trips * rate;

          return updatedDetail;
        });

        return { ...entry, eot_details: updatedDetails };
      })
    );
  };
  // return (
  //   <>
  //     <button title="Update Duty Travel" className="upload-svg flex-row" onClick={handleShow}>
  //       <svg
  //         xmlns="http://www.w3.org/2000/svg"
  //         width="24"
  //         height="24"
  //         fill="white"
  //         viewBox="0 0 24 24"
  //         id="pen-new-square"
  //       >
  //         <path
  //           fill=""
  //           fill-rule="evenodd"
  //           d="M11.9426 1.25L13.5 1.25C13.9142 1.25 14.25 1.58579 14.25 2C14.25 2.41421 13.9142 2.75 13.5 2.75H12C9.62177 2.75 7.91356 2.75159 6.61358 2.92637C5.33517 3.09825 4.56445 3.42514 3.9948 3.9948C3.23505 4.75455 2.91245 5.86509 2.80417 8.03734C2.78355 8.45104 2.43146 8.76969 2.01776 8.74907C1.60406 8.72845 1.28541 8.37636 1.30603 7.96266C1.41642 5.74802 1.74641 4.12187 2.93414 2.93414C3.82895 2.03933 4.96897 1.63399 6.41371 1.43975C7.82519 1.24998 9.63423 1.24999 11.9426 1.25ZM22 9.75C22.4142 9.75 22.75 10.0858 22.75 10.5V12.0574C22.75 14.3658 22.75 16.1748 22.5603 17.5863C22.366 19.031 21.9607 20.1711 21.0659 21.0659C20.1711 21.9607 19.031 22.366 17.5863 22.5603C16.1748 22.75 14.3658 22.75 12.0574 22.75H11.9426C9.63423 22.75 7.82519 22.75 6.41371 22.5603C4.96897 22.366 3.82895 21.9607 2.93414 21.0659C2.03933 20.1711 1.63399 19.031 1.43975 17.5863C1.24998 16.1748 1.24999 14.3658 1.25 12.0574L1.25 12C1.25 11.5858 1.58579 11.25 2 11.25C2.41421 11.25 2.75 11.5858 2.75 12C2.75 14.3782 2.75159 16.0864 2.92637 17.3864C3.09825 18.6648 3.42514 19.4355 3.9948 20.0052C4.56445 20.5749 5.33517 20.9018 6.61358 21.0736C7.91356 21.2484 9.62177 21.25 12 21.25C14.3782 21.25 16.0864 21.2484 17.3864 21.0736C18.6648 20.9018 19.4355 20.5749 20.0052 20.0052C20.5749 19.4355 20.9018 18.6648 21.0736 17.3864C21.2484 16.0864 21.25 14.3782 21.25 12V10.5C21.25 10.0858 21.5858 9.75 22 9.75Z"
  //           clip-rule="evenodd"
  //         ></path>
  //         <path
  //           fill=""
  //           fill-rule="evenodd"
  //           d="M16.7705 2.27592C18.1384 0.908029 20.3562 0.908029 21.7241 2.27592C23.092 3.6438 23.092 5.86158 21.7241 7.22947L18.0928 10.8607C17.7999 11.1536 17.3251 11.1536 17.0322 10.8607C16.7393 10.5678 16.7393 10.093 17.0322 9.80006L19.1051 7.72709C18.5892 7.50519 17.9882 7.14946 17.4193 6.58065C16.8505 6.01185 16.4948 5.41082 16.2729 4.89486L11.2175 9.95026C10.801 10.3668 10.6376 10.532 10.4988 10.71C10.3274 10.9297 10.1804 11.1676 10.0605 11.4192C9.96337 11.623 9.88868 11.8429 9.7024 12.4017L9.27051 13.6974L10.3026 14.7295L11.5983 14.2976C12.1571 14.1113 12.377 14.0366 12.5808 13.9395C12.8324 13.8196 13.0703 13.6726 13.2901 13.5012C13.468 13.3624 13.6332 13.199 14.0497 12.7825C14.3426 12.4896 14.8175 12.4896 15.1104 12.7825C15.4033 13.0754 15.4033 13.5503 15.1104 13.8432L15.076 13.8776C14.7047 14.2489 14.4721 14.4815 14.2126 14.684C13.9069 14.9224 13.5761 15.1268 13.2261 15.2936C12.929 15.4352 12.6169 15.5392 12.1188 15.7052L9.21426 16.6734C8.67801 16.8521 8.0868 16.7126 7.68711 16.3129C7.28742 15.9132 7.14785 15.322 7.3266 14.7857L8.29477 11.8812C8.46079 11.3831 8.56479 11.071 8.7064 10.7739C8.87319 10.4239 9.07761 10.0931 9.31605 9.78742C9.51849 9.52787 9.7511 9.29529 10.1224 8.92401L16.7705 2.27592ZM17.4546 3.7132C17.4773 3.80906 17.509 3.92327 17.5532 4.05066C17.6965 4.46372 17.9677 5.00771 18.48 5.51999C18.9923 6.03227 19.5363 6.30346 19.9493 6.44677C20.0767 6.49097 20.1909 6.52273 20.2868 6.54543L20.6634 6.16881C21.4455 5.38671 21.4455 4.11867 20.6634 3.33658C19.8813 2.55448 18.6133 2.55448 17.8312 3.33658L17.4546 3.7132Z"
  //           clip-rule="evenodd"
  //         ></path>
  //       </svg>
  //       {" "} Update Duty Travel
  //     </button>
  //     <Modal
  //       show={show}
  //       onHide={handleClose}
  //       dialogClassName={!showChange ? "request-leave" : "model-width60vw"}
  //     >
  //       <Modal.Header closeButton >
  //         <Modal.Title>Update Duty Travel Data for BOQ</Modal.Title>

  //       </Modal.Header>
  //       {
  //         !showChange ?
  //           <Modal.Body>
  //             <div className="parent-div">
  //               <div className="bdy-div">
  //                 <div className="flex-column align-items-center">
  //                   <label className="form-labels font-weight500 font-size-subheading" title="Invoice Number">
  //                     Reason for Change BOQ<span className="required">*</span>
  //                   </label>
  //                   <input
  //                     type="text"
  //                     name="changeReason"
  //                     title="Reason for Change BOQ"
  //                     placeholder="Example- Revise EOT"
  //                     onChange={(e) => setChangeReason(e.target.value)}
  //                     className={`form-input ${errors.changeReason ? "is-invalid" : ""
  //                       }`}
  //                   />
  //                 </div>
  //                 <div className="button-models">
  //                   <button
  //                     className="model-button-cancel model-button font-weight500"
  //                     onClick={handleClose}
  //                   >
  //                     Cancel
  //                   </button>
  //                   {(changeReason !== "null" && changeReason !== "") && (
  //                     <button
  //                       type="submit"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleChangeSubmit}
  //                     >
  //                       Next
  //                     </button>
  //                   )}

  //                 </div>

  //               </div>
  //             </div>
  //             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

  //           </Modal.Body>
  //           : showEOT === false ?

  //             <Modal.Body>
  //               <div className="parent-div">
  //                 <div className="bdy-div">
  //                   <div className='flex-row justify-between'>
  //                     <button
  //                       type="button"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleChangeback}
  //                     >
  //                       Back
  //                     </button>
  //                     <button
  //                       type="button"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleShowWOT}
  //                     >
  //                       <AddwithWhiteCircle /> Add Revised EOT/COS
  //                     </button>
  //                   </div>
  //                   <div className="flex-row justify-center">
  //                     <table className="table-css ">

  //                       <thead className="table-heading">
  //                         <tr className="custom-table-head-tr width-10vw">
  //                           <th className="table-heading-text text-left-sr" >S no.</th>
  //                           <th className="table-heading-text text-center">Description of Trips <br /> <span className="required">(Read-Only)</span></th>
  //                           <th className="table-heading-text text-center">Total Trips </th>
  //                           <th className="table-heading-text text-center">Rate  <br /> <span className="required">(Per Trip)</span></th>
  //                         </tr>
  //                       </thead>

  //                       <tbody>

  //                         {formData.map((entry, index) => (
  //                           <tr key={index} className="custom-table-head-td ">

  //                             <td className="align-left width-5vw" >
  //                               {index + 1}
  //                             </td>
  //                             <td>
  //                               <div title="Trips Description" className="flex-column align-items-center  align-items-center">
  //                                 <input
  //                                   className={`form-input width-20vw ${errors[`${index}_trips`] ? "error" : ""}`}
  //                                   id={`trips_${index}`}
  //                                   name="trips"
  //                                   type="text"
  //                                   value={entry.trips}
  //                                   onChange={(e) => handleInputChange(e, index)}

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_trips`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_trips`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>
  //                             <td>
  //                               <div title="Total Trips" className="flex-column align-items-center" >
  //                                 <input
  //                                   className={`form-input-date  width-10vw  ${errors[`${index}_num_of_min_trip`] ? "error" : ""}`}
  //                                   id={`num_of_min_trip_${index}`}
  //                                   name="num_of_min_trip"
  //                                   type="text"
  //                                   value={entry.num_of_min_trip} // Calculate and display the sum
  //                                   onChange={(e) => handleInputChange(e, index)}

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_num_of_min_trip`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_num_of_min_trip`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>
  //                             <td>
  //                               <div title="Rate" className="flex-column align-items-center">
  //                                 <input
  //                                   className={`form-input-date  width-10vw  ${errors[`${index}_rate_per_trip`] ? "error" : ""}`}
  //                                   id={`rate_per_trip_${index}`}
  //                                   name="rate_per_trip"
  //                                   type="text"
  //                                   value={entry.rate_per_trip}
  //                                   onChange={(e) => handleInputChange(e, index)}

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_rate_per_trip`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_rate_per_trip`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>


  //                           </tr>
  //                         ))}

  //                       </tbody>

  //                     </table>
  //                   </div>
  //                   <div className="button-models">
  //                     <button
  //                       className="model-button-cancel model-button font-weight500"
  //                       onClick={handleClose}
  //                     >
  //                       Cancel
  //                     </button>
  //                     <button
  //                       type="submit"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleSubmit}
  //                     >
  //                       Update
  //                     </button>
  //                   </div>

  //                 </div>
  //               </div>
  //               <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

  //             </Modal.Body> :
  //             <Modal.Body>
  //               <div className="parent-div">
  //                 <div className="bdy-div">
  //                   <div className='flex-row justify-between'>
  //                     <button
  //                       type="button"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleclOSEOT}
  //                     >
  //                       Back
  //                     </button>
  //                     <button
  //                       type="button"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={addNewEOT}
  //                     >
  //                       <AddwithWhiteCircle /> Add Another Revised EOT/COS
  //                     </button>
  //                   </div>
  //                   {formData[0]?.eot_details?.map((_, detailIndex) => (
  //                     <div key={detailIndex}>
  //                       <h3>EOT Round {detailIndex + 1}</h3>
  //                       <table className="nested-table-lightblue width-90vw payment">

  //                         <thead>
  //                           <tr>
  //                             <th>Descritption of Trips</th>
  //                             <th>Total Trips</th>
  //                             <th>Rate</th>
  //                             <th>Total Amount</th>
  //                           </tr>
  //                         </thead>
  //                         <tbody>
  //                           {formData.map((entry, entryIndex) => (
  //                             <tr key={entryIndex}>
  //                               <td>{entry.trips}</td>
  //                               <td>
  //                                 <input
  //                                   type="number"
  //                                   className={`form-input-date  width-5vw  ${errors[`${entryIndex}_t_trips`] ? "error" : ""}`}

  //                                   value={entry.eot_details[detailIndex]?.t_trips || ""}
  //                                   onChange={(e) =>
  //                                     handleEOTChange(entryIndex, detailIndex, "t_trips", e.target.value)
  //                                   }
  //                                 />
  //                               </td>


  //                               <td>
  //                                 <input
  //                                   type="number"
  //                                   value={entry.eot_details[detailIndex]?.rate || ""}
  //                                   onChange={(e) =>
  //                                     handleEOTChange(entryIndex, detailIndex, "rate", e.target.value)
  //                                   }
  //                                   className={`form-input-date  width-5vw  ${errors[`${entryIndex}_rate`] ? "error" : ""}`}

  //                                 />
  //                               </td>
  //                               <td>
  //                                 <input
  //                                   type="number"
  //                                   className={`form-input-date  width-5vw  ${errors[`${entryIndex}_total_amount`] ? "error" : ""}`}
  //                                   disabled
  //                                   value={entry.eot_details[detailIndex]?.total_amount || ""}
  //                                   onChange={(e) =>
  //                                     handleEOTChange(
  //                                       entryIndex,
  //                                       detailIndex,
  //                                       "total_amount",
  //                                       e.target.value
  //                                     )
  //                                   }
  //                                 />
  //                               </td>
  //                             </tr>
  //                           ))}
  //                         </tbody>
  //                       </table>
  //                     </div>
  //                   ))}

  //                   <div className="button-models">
  //                     <button
  //                       className="model-button-cancel model-button font-weight500"
  //                       onClick={handleClose}
  //                     >
  //                       Cancel
  //                     </button>
  //                     <button
  //                       type="submit"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleSubmit}
  //                     >
  //                       Save
  //                     </button>
  //                   </div>

  //                 </div>
  //               </div>
  //             </Modal.Body >
  //       }
  //     </Modal >
  //   </>
  // )


  return (
    <>
      <button
        title="Update Duty Travel"
        className="eb-bulk-trigger-btn"
        onClick={handleShow}
        style={{ background: "black" }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="white"
          viewBox="0 0 24 24"
          id="pen-new-square"
        >
          <path fill="" fillRule="evenodd" d="M11.9426 1.25L13.5 1.25C13.9142 1.25 14.25 1.58579 14.25 2C14.25 2.41421 13.9142 2.75 13.5 2.75H12C9.62177 2.75 7.91356 2.75159 6.61358 2.92637C5.33517 3.09825 4.56445 3.42514 3.9948 3.9948C3.23505 4.75455 2.91245 5.86509 2.80417 8.03734C2.78355 8.45104 2.43146 8.76969 2.01776 8.74907C1.60406 8.72845 1.28541 8.37636 1.30603 7.96266C1.41642 5.74802 1.74641 4.12187 2.93414 2.93414C3.82895 2.03933 4.96897 1.63399 6.41371 1.43975C7.82519 1.24998 9.63423 1.24999 11.9426 1.25ZM22 9.75C22.4142 9.75 22.75 10.0858 22.75 10.5V12.0574C22.75 14.3658 22.75 16.1748 22.5603 17.5863C22.366 19.031 21.9607 20.1711 21.0659 21.0659C20.1711 21.9607 19.031 22.366 17.5863 22.5603C16.1748 22.75 14.3658 22.75 12.0574 22.75H11.9426C9.63423 22.75 7.82519 22.75 6.41371 22.5603C4.96897 22.366 3.82895 21.9607 2.93414 21.0659C2.03933 20.1711 1.63399 19.031 1.43975 17.5863C1.24998 16.1748 1.24999 14.3658 1.25 12.0574L1.25 12C1.25 11.5858 1.58579 11.25 2 11.25C2.41421 11.25 2.75 11.5858 2.75 12C2.75 14.3782 2.75159 16.0864 2.92637 17.3864C3.09825 18.6648 3.42514 19.4355 3.9948 20.0052C4.56445 20.5749 5.33517 20.9018 6.61358 21.0736C7.91356 21.2484 9.62177 21.25 12 21.25C14.3782 21.25 16.0864 21.2484 17.3864 21.0736C18.6648 20.9018 19.4355 20.5749 20.0052 20.0052C20.5749 19.4355 20.9018 18.6648 21.0736 17.3864C21.2484 16.0864 21.25 14.3782 21.25 12V10.5C21.25 10.0858 21.5858 9.75 22 9.75Z" clipRule="evenodd"></path>
          <path fill="" fillRule="evenodd" d="M16.7705 2.27592C18.1384 0.908029 20.3562 0.908029 21.7241 2.27592C23.092 3.6438 23.092 5.86158 21.7241 7.22947L18.0928 10.8607C17.7999 11.1536 17.3251 11.1536 17.0322 10.8607C16.7393 10.5678 16.7393 10.093 17.0322 9.80006L19.1051 7.72709C18.5892 7.50519 17.9882 7.14946 17.4193 6.58065C16.8505 6.01185 16.4948 5.41082 16.2729 4.89486L11.2175 9.95026C10.801 10.3668 10.6376 10.532 10.4988 10.71C10.3274 10.9297 10.1804 11.1676 10.0605 11.4192C9.96337 11.623 9.88868 11.8429 9.7024 12.4017L9.27051 13.6974L10.3026 14.7295L11.5983 14.2976C12.1571 14.1113 12.377 14.0366 12.5808 13.9395C12.8324 13.8196 13.0703 13.6726 13.2901 13.5012C13.468 13.3624 13.6332 13.199 14.0497 12.7825C14.3426 12.4896 14.8175 12.4896 15.1104 12.7825C15.4033 13.0754 15.4033 13.5503 15.1104 13.8432L15.076 13.8776C14.7047 14.2489 14.4721 14.4815 14.2126 14.684C13.9069 14.9224 13.5761 15.1268 13.2261 15.2936C12.929 15.4352 12.6169 15.5392 12.1188 15.7052L9.21426 16.6734C8.67801 16.8521 8.0868 16.7126 7.68711 16.3129C7.28742 15.9132 7.14785 15.322 7.3266 14.7857L8.29477 11.8812C8.46079 11.3831 8.56479 11.071 8.7064 10.7739C8.87319 10.4239 9.07761 10.0931 9.31605 9.78742C9.51849 9.52787 9.7511 9.29529 10.1224 8.92401L16.7705 2.27592ZM17.4546 3.7132C17.4773 3.80906 17.509 3.92327 17.5532 4.05066C17.6965 4.46372 17.9677 5.00771 18.48 5.51999C18.9923 6.03227 19.5363 6.30346 19.9493 6.44677C20.0767 6.49097 20.1909 6.52273 20.2868 6.54543L20.6634 6.16881C21.4455 5.38671 21.4455 4.11867 20.6634 3.33658C19.8813 2.55448 18.6133 2.55448 17.8312 3.33658L17.4546 3.7132Z" clipRule="evenodd"></path>
        </svg>
        Update Duty Travel
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName={!showChange ? "eb-bulk-modal request-leave" : "max-heightModal eb-bulk-modal model-width90vw"}
      >
        <Modal.Header className="eb-bulk-modal-header">
          <Modal.Title className="eb-bulk-modal-title">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
              <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
            </svg>
            Update Duty Travel Data for BOQ
            <button
              className="close-btn"
              onClick={handleClose}
              style={{ marginLeft: 'auto', background: 'none', border: 'none', color: 'white', fontSize: '24px', cursor: 'pointer' }}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </Modal.Title>
        </Modal.Header>

        {!showChange ?
          /* ===== STEP 1: Reason for Change ===== */
          <Modal.Body className="eb-bulk-modal-body">
            <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
              <div className="eb-bulk-content">
                <div className="eb-bulk-reason-section" style={{ padding: '20px', background: '#f7fafc', borderRadius: '12px' }}>
                  <label className="eb-bulk-label" style={{ display: 'block', fontWeight: '600', marginBottom: '8px', color: '#2d3748' }}>
                    Reason for Change BOQ <span className="eb-bulk-required">*</span>
                  </label>
                  <input
                    type="text"
                    name="changeReason"
                    title="Reason for Change BOQ"
                    placeholder="Example- Revise EOT"
                    onChange={(e) => setChangeReason(e.target.value)}
                    className="eb-bulk-input"
                    style={{ width: '90%', padding: '12px 16px', fontSize: '14px' }}
                  />
                </div>
                <div className="eb-bulk-footer-actions" style={{ justifyContent: 'flex-end' }}>
                  <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                    Cancel
                  </button>
                  {(changeReason !== "null" && changeReason !== "") && (
                    <button
                      type="submit"
                      className="eb-bulk-btn eb-bulk-btn-submit"
                      disabled={loading}
                      onClick={handleChangeSubmit}
                      style={{ background: "black" }}
                    >
                      Next
                    </button>
                  )}
                </div>
              </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </Modal.Body>

          : showEOT === false ?
            /* ===== STEP 2: Main Table ===== */
            <Modal.Body className="eb-bulk-modal-body">
              <div className="eb-bulk-table-scroll table-box scroll-container-table" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
                <div className="eb-bulk-content">
                  <div className="eb-bulk-actions" style={{ justifyContent: 'space-between' }}>
                    <button
                      type="button"
                      className="eb-bulk-add-row-btn"
                      style={{ background: '#718096' }}
                      disabled={loading}
                      onClick={handleChangeback}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="15 18 9 12 15 6" />
                      </svg>
                      Back
                    </button>
                    <button
                      type="button"
                      className="eb-bulk-add-row-btn"
                      disabled={loading}
                      onClick={handleShowWOT}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="12" y1="8" x2="12" y2="16" />
                        <line x1="8" y1="12" x2="16" y2="12" />
                      </svg>
                      Add Revised EOT/COS
                    </button>
                  </div>

                  <div className="eb-bulk-table-wrapper">
                    <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "40vh", minHeight: "40vh" }}>
                      <table className="eb-bulk-table">
                        <thead className="eb-bulk-table-head">
                          <tr className="eb-bulk-table-header-row">
                            <th className="eb-bulk-th eb-bulk-th-rank">
                              <span className="eb-bulk-th-label">S.No</span>
                            </th>
                            <th className="eb-bulk-th">
                              <span className="eb-bulk-th-label">Description of Trips</span>
                              <span className="eb-bulk-th-sub">(Read-Only)</span>
                            </th>
                            <th className="eb-bulk-th eb-bulk-th-period">
                              <span className="eb-bulk-th-label">Total Trips</span>
                            </th>
                            <th className="eb-bulk-th eb-bulk-th-rate">
                              <span className="eb-bulk-th-label">Rate</span>
                              <span className="eb-bulk-th-sub">(Per Trip)</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {formData.map((entry, index) => (
                            <tr key={index} className="eb-bulk-row">
                              <td className="eb-bulk-td eb-bulk-td-rank">
                                <span style={{ fontWeight: '500', color: '#2d3748' }}>{index + 1}.</span>
                              </td>
                              <td className="eb-bulk-td">
                                <span style={{ fontWeight: '500', color: '#2d3748' }}>{entry.trips}</span>
                              </td>
                              <td className="eb-bulk-td">
                                <div className="eb-bulk-input-wrapper">
                                  <input
                                    className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_num_of_min_trip`] ? "eb-bulk-input-error" : ""}`}
                                    id={`num_of_min_trip_${index}`}
                                    name="num_of_min_trip"
                                    type="text"
                                    value={entry.num_of_min_trip}
                                    onChange={(e) => handleInputChange(e, index)}
                                    placeholder="0"
                                  />
                                  {errors[`${index}_num_of_min_trip`] && (
                                    <span className="eb-bulk-error-text">{errors[`${index}_num_of_min_trip`]}</span>
                                  )}
                                </div>
                              </td>
                              <td className="eb-bulk-td">
                                <div className="eb-bulk-input-wrapper">
                                  <input
                                    className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_rate_per_trip`] ? "eb-bulk-input-error" : ""}`}
                                    id={`rate_per_trip_${index}`}
                                    name="rate_per_trip"
                                    type="text"
                                    value={entry.rate_per_trip}
                                    onChange={(e) => handleInputChange(e, index)}
                                    placeholder="₹ 0.00"
                                  />
                                  {errors[`${index}_rate_per_trip`] && (
                                    <span className="eb-bulk-error-text">{errors[`${index}_rate_per_trip`]}</span>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="eb-bulk-footer-actions">
                    <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="eb-bulk-btn eb-bulk-btn-submit"
                      disabled={loading}
                      onClick={handleSubmit}
                      style={{ background: "black" }}
                    >
                      {loading ? (
                        <span className="eb-bulk-btn-loader">
                          <span className="eb-bulk-spinner"></span>
                          Updating...
                        </span>
                      ) : (
                        <>
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                            <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                          </svg>
                          Update
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
              <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            </Modal.Body>

            :
            /* ===== STEP 3: EOT Table ===== */
            <Modal.Body className="eb-bulk-modal-body">
              <div className="eb-bulk-container">
                <div className="eb-bulk-content">
                  <div className="eb-bulk-actions" style={{ justifyContent: 'space-between' }}>
                    <button
                      type="button"
                      className="eb-bulk-add-row-btn"
                      style={{ background: '#718096' }}
                      disabled={loading}
                      onClick={handleclOSEOT}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="15 18 9 12 15 6" />
                      </svg>
                      Back
                    </button>
                    <button
                      type="button"
                      className="eb-bulk-add-row-btn"
                      disabled={loading}
                      onClick={addNewEOT}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="12" y1="8" x2="12" y2="16" />
                        <line x1="8" y1="12" x2="16" y2="12" />
                      </svg>
                      Add Another Revised EOT/COS
                    </button>
                  </div>

                  <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
                    {formData[0]?.eot_details?.map((_, detailIndex) => (
                      <div key={detailIndex} style={{ marginBottom: '24px' }}>
                        <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#2d3748', marginBottom: '12px' }}>
                          EOT Round {detailIndex + 1}
                        </h3>
                        <div className="eb-bulk-table-wrapper">
                          <table className="eb-bulk-table">
                            <thead className="eb-bulk-table-head">
                              <tr className="eb-bulk-table-header-row">
                                <th className="eb-bulk-th"><span className="eb-bulk-th-label">Description of Trips</span></th>
                                <th className="eb-bulk-th"><span className="eb-bulk-th-label">Total Trips</span></th>
                                <th className="eb-bulk-th"><span className="eb-bulk-th-label">Rate</span></th>
                                <th className="eb-bulk-th"><span className="eb-bulk-th-label">Total Amount</span></th>
                              </tr>
                            </thead>
                            <tbody>
                              {formData.map((entry, entryIndex) => (
                                <tr key={entryIndex} className="eb-bulk-row">
                                  <td className="eb-bulk-td">
                                    <span style={{ fontWeight: '500' }}>{entry.trips}</span>
                                  </td>
                                  <td className="eb-bulk-td">
                                    <div className="eb-bulk-input-wrapper">

                                      <input
                                        type="number"
                                        className={`eb-bulk-input eb-bulk-input-number ${errors[`${entryIndex}_t_trips`] ? "eb-bulk-input-error" : ""}`}
                                        value={entry.eot_details[detailIndex]?.t_trips || ""}
                                        onChange={(e) => handleEOTChange(entryIndex, detailIndex, "t_trips", e.target.value)}
                                        placeholder="0"
                                      />
                                    </div>
                                  </td>
                                  <td className="eb-bulk-td">
                                    <div className="eb-bulk-input-wrapper">

                                      <input
                                        type="number"
                                        className={`eb-bulk-input eb-bulk-input-number ${errors[`${entryIndex}_rate`] ? "eb-bulk-input-error" : ""}`}
                                        value={entry.eot_details[detailIndex]?.rate || ""}
                                        onChange={(e) => handleEOTChange(entryIndex, detailIndex, "rate", e.target.value)}
                                        placeholder="₹ 0.00"
                                      />
                                    </div>
                                  </td>
                                  <td className="eb-bulk-td eb-bulk-td-total">
                                    <div className="eb-bulk-input-wrapper">

                                      <span className="eb-bulk-total-value" style={{ minWidth: '80px' }}>
                                        {entry.eot_details[detailIndex]?.total_amount || 0}
                                      </span>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="eb-bulk-footer-actions">
                    <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="eb-bulk-btn eb-bulk-btn-submit"
                      disabled={loading}
                      onClick={handleSubmit}
                      style={{ background: "black" }}
                    >
                      {loading ? (
                        <span className="eb-bulk-btn-loader">
                          <span className="eb-bulk-spinner"></span>
                          Saving...
                        </span>
                      ) : (
                        <>
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" />
                            <polyline points="17 21 17 13 7 13 7 21" />
                            <polyline points="7 3 7 8 15 8" />
                          </svg>
                          Save
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
              <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            </Modal.Body>
        }
      </Modal>
    </>
  );
}
const BulkUpdateOfficeRentData = ({ boqOfficeRentList, i, getData, id, value, getLogData }) => {

  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState([]);
  const [changeReason, setChangeReason] = useState("null");
  const [showChange, setShowChange] = useState(false);




  const createdAt = new Date().toISOString();

  useEffect(() => {
    if (!showChange) {
      setFormData((prevData) =>
        prevData.map((item) => ({
          ...item,
          random_value_of_changes: createdAt,
          change_by_emp_code: sessionStorage.getItem('sitemanagement_emp_code'),
          change_by_emp_name: sessionStorage.getItem('name'),

        }))
      );
    }

  }, [createdAt, showChange])




  useEffect(() => {
    if (changeReason !== "null") {
      setFormData((prevData) =>
        prevData.map((item) => ({
          ...item,
          reason_of_change: changeReason,

        }))
      );
    }
  }, [changeReason]);




  useEffect(() => {
    if (Array.isArray(boqOfficeRentList)) {
      const initialData = boqOfficeRentList.map((item) => ({
        num_of_months: "",
        rate_per_month: "",
        during_dlp_OM_period: "",
        during_construction_period: "",
        project: id,
        random_value_of_changes: "",
        reason_of_change: changeReason !== "null" ? changeReason : "",
        change_by_emp_code: sessionStorage.getItem('sitemanagement_emp_code'),
        change_by_emp_name: sessionStorage.getItem('name'),
        eot_details: [{
          boqId: item.id,
          cp: "",
          dlp: "",
          t_month: "",
          rate: "",
          total_amount: "",
        }],
      }));
      setFormData(initialData);
    }
  }, [boqOfficeRentList]);






  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const [inputState, setInputState] = useState({});


  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const updatedData = [...formData];

    updatedData[index][name] = value;

    const dlp = Number(updatedData[index].during_dlp_OM_period || 0);
    const construction = Number(updatedData[index].during_construction_period || 0);
    updatedData[index].num_of_months = dlp + construction;

    setFormData(updatedData);
  };

  const handleShow = () => {
    setShow(true);
    setFormData(boqOfficeRentList);
  }


  const handleChangeSubmit = () => {
    setShowChange(true);
    setShowEOT(false)

  }
  const handleChangeback = () => {
    setShowChange(false);

  }


  const handleClose = () => {
    setShow(false);
    setShowChange(false);
    setChangeReason("");
  }

  const [loading, setLoading] = useState(false); //loading logic

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

      try {
        let res = await axios.put(
          `${BASE_URL}/siteproject/bulkBOQOfficeRent/`,
          formData
        );

        if (res.status === 200) {
          await getData();
          await getLogData();
          handleClose();
          toast.dismiss(loadingToastId); // Dismiss loading toast
          toast.success('Office Rent BOQ data updated successfully.')

          // window.location.reload();
        } else {
          alert(res);
        }
      } catch (err) {
        //toast Logic
        handleErrorToast(err, loadingToastId);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  const [showEOT, setShowEOT] = useState(false);
  const handleShowWOT = () => {
    setShowEOT(true)
  }
  const handleclOSEOT = () => {
    setShowEOT(false)
  }


  const addNewEOT = () => {
    setFormData((prevFormData) =>
      prevFormData.map((entry) => ({
        ...entry,
        eot_details: [
          ...(entry.eot_details || []),
          {
            boqId: entry.boqId || entry.id,
            cp: "",
            dlp: "",
            t_month: "",
            rate: "",
            total_amount: "",
          },
        ],
      }))
    );
  };


  useEffect(() => {
    if (Array.isArray(boqOfficeRentList)) {
      const initialData = boqOfficeRentList.map((item) => ({
        num_of_months: "",
        rate_per_month: "",
        during_dlp_OM_period: "",
        during_construction_period: "",
        project: id,
        random_value_of_changes: "",
        reason_of_change: changeReason !== "null" ? changeReason : "",
        change_by_emp_code: sessionStorage.getItem('sitemanagement_emp_code'),
        change_by_emp_name: sessionStorage.getItem('name'),
        eot_details: [{
          boqId: item.id,
          cp: "",
          dlp: "",
          t_month: "",
          rate: "",
          total_amount: "",
        }],
      }));
      setFormData(initialData);
      setShowEOT(true); // ✅ show EOT table immediately

    }
  }, [boqOfficeRentList]);



  const handleEOTChange = (entryIndex, detailIndex, field, value) => {
    setFormData((prevFormData) =>
      prevFormData.map((entry, i) => {
        if (i !== entryIndex) return entry;

        const updatedDetails = entry.eot_details.map((detail, j) => {
          if (j !== detailIndex) return detail;

          const updatedDetail = { ...detail, [field]: value };

          // Auto-calc t_month = cp + dlp
          const cp = parseFloat(updatedDetail.cp) || 0;
          const dlp = parseFloat(updatedDetail.dlp) || 0;
          updatedDetail.t_month = cp + dlp;

          // Auto-calc total_amount = t_month * rate
          const rate = parseFloat(updatedDetail.rate) || 0;
          updatedDetail.total_amount = updatedDetail.t_month * rate;

          return updatedDetail;
        });

        return { ...entry, eot_details: updatedDetails };
      })
    );
  };
  // return (
  //   <>
  //     <button title="Update Office Rent" className="upload-svg flex-row" onClick={handleShow}>
  //       <svg
  //         xmlns="http://www.w3.org/2000/svg"
  //         width="24"
  //         height="24"
  //         fill="white"
  //         viewBox="0 0 24 24"
  //         id="pen-new-square"
  //       >
  //         <path
  //           fill=""
  //           fill-rule="evenodd"
  //           d="M11.9426 1.25L13.5 1.25C13.9142 1.25 14.25 1.58579 14.25 2C14.25 2.41421 13.9142 2.75 13.5 2.75H12C9.62177 2.75 7.91356 2.75159 6.61358 2.92637C5.33517 3.09825 4.56445 3.42514 3.9948 3.9948C3.23505 4.75455 2.91245 5.86509 2.80417 8.03734C2.78355 8.45104 2.43146 8.76969 2.01776 8.74907C1.60406 8.72845 1.28541 8.37636 1.30603 7.96266C1.41642 5.74802 1.74641 4.12187 2.93414 2.93414C3.82895 2.03933 4.96897 1.63399 6.41371 1.43975C7.82519 1.24998 9.63423 1.24999 11.9426 1.25ZM22 9.75C22.4142 9.75 22.75 10.0858 22.75 10.5V12.0574C22.75 14.3658 22.75 16.1748 22.5603 17.5863C22.366 19.031 21.9607 20.1711 21.0659 21.0659C20.1711 21.9607 19.031 22.366 17.5863 22.5603C16.1748 22.75 14.3658 22.75 12.0574 22.75H11.9426C9.63423 22.75 7.82519 22.75 6.41371 22.5603C4.96897 22.366 3.82895 21.9607 2.93414 21.0659C2.03933 20.1711 1.63399 19.031 1.43975 17.5863C1.24998 16.1748 1.24999 14.3658 1.25 12.0574L1.25 12C1.25 11.5858 1.58579 11.25 2 11.25C2.41421 11.25 2.75 11.5858 2.75 12C2.75 14.3782 2.75159 16.0864 2.92637 17.3864C3.09825 18.6648 3.42514 19.4355 3.9948 20.0052C4.56445 20.5749 5.33517 20.9018 6.61358 21.0736C7.91356 21.2484 9.62177 21.25 12 21.25C14.3782 21.25 16.0864 21.2484 17.3864 21.0736C18.6648 20.9018 19.4355 20.5749 20.0052 20.0052C20.5749 19.4355 20.9018 18.6648 21.0736 17.3864C21.2484 16.0864 21.25 14.3782 21.25 12V10.5C21.25 10.0858 21.5858 9.75 22 9.75Z"
  //           clip-rule="evenodd"
  //         ></path>
  //         <path
  //           fill=""
  //           fill-rule="evenodd"
  //           d="M16.7705 2.27592C18.1384 0.908029 20.3562 0.908029 21.7241 2.27592C23.092 3.6438 23.092 5.86158 21.7241 7.22947L18.0928 10.8607C17.7999 11.1536 17.3251 11.1536 17.0322 10.8607C16.7393 10.5678 16.7393 10.093 17.0322 9.80006L19.1051 7.72709C18.5892 7.50519 17.9882 7.14946 17.4193 6.58065C16.8505 6.01185 16.4948 5.41082 16.2729 4.89486L11.2175 9.95026C10.801 10.3668 10.6376 10.532 10.4988 10.71C10.3274 10.9297 10.1804 11.1676 10.0605 11.4192C9.96337 11.623 9.88868 11.8429 9.7024 12.4017L9.27051 13.6974L10.3026 14.7295L11.5983 14.2976C12.1571 14.1113 12.377 14.0366 12.5808 13.9395C12.8324 13.8196 13.0703 13.6726 13.2901 13.5012C13.468 13.3624 13.6332 13.199 14.0497 12.7825C14.3426 12.4896 14.8175 12.4896 15.1104 12.7825C15.4033 13.0754 15.4033 13.5503 15.1104 13.8432L15.076 13.8776C14.7047 14.2489 14.4721 14.4815 14.2126 14.684C13.9069 14.9224 13.5761 15.1268 13.2261 15.2936C12.929 15.4352 12.6169 15.5392 12.1188 15.7052L9.21426 16.6734C8.67801 16.8521 8.0868 16.7126 7.68711 16.3129C7.28742 15.9132 7.14785 15.322 7.3266 14.7857L8.29477 11.8812C8.46079 11.3831 8.56479 11.071 8.7064 10.7739C8.87319 10.4239 9.07761 10.0931 9.31605 9.78742C9.51849 9.52787 9.7511 9.29529 10.1224 8.92401L16.7705 2.27592ZM17.4546 3.7132C17.4773 3.80906 17.509 3.92327 17.5532 4.05066C17.6965 4.46372 17.9677 5.00771 18.48 5.51999C18.9923 6.03227 19.5363 6.30346 19.9493 6.44677C20.0767 6.49097 20.1909 6.52273 20.2868 6.54543L20.6634 6.16881C21.4455 5.38671 21.4455 4.11867 20.6634 3.33658C19.8813 2.55448 18.6133 2.55448 17.8312 3.33658L17.4546 3.7132Z"
  //           clip-rule="evenodd"
  //         ></path>
  //       </svg>
  //       {" "} Update Office Rent
  //     </button>
  //     <Modal
  //       show={show}
  //       onHide={handleClose}
  //       dialogClassName={!showChange ? "request-leave" : "width-50vwModal"}

  //     >
  //       <Modal.Header closeButton >
  //         <Modal.Title>Update Office Rent Data for BOQ</Modal.Title>

  //       </Modal.Header>
  //       {
  //         !showChange ?
  //           <Modal.Body>
  //             <div className="parent-div">
  //               <div className="bdy-div">
  //                 <div className="flex-column align-items-center">
  //                   <label className="form-labels font-weight500 font-size-subheading" title="Invoice Number">
  //                     Reason for Change BOQ<span className="required">*</span>
  //                   </label>
  //                   <input
  //                     type="text"
  //                     name="changeReason"
  //                     title="Reason for Change BOQ"
  //                     placeholder="Example- Revise EOT"
  //                     onChange={(e) => setChangeReason(e.target.value)}
  //                     className={`form-input ${errors.changeReason ? "is-invalid" : ""
  //                       }`}
  //                   />
  //                 </div>
  //                 <div className="button-models">
  //                   <button
  //                     className="model-button-cancel model-button font-weight500"
  //                     onClick={handleClose}
  //                   >
  //                     Cancel
  //                   </button>
  //                   {(changeReason !== "null" && changeReason !== "") && (
  //                     <button
  //                       type="submit"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleChangeSubmit}
  //                     >
  //                       Next
  //                     </button>
  //                   )}

  //                 </div>

  //               </div>
  //             </div>
  //             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

  //           </Modal.Body>
  //           : showEOT === false ?
  //             <Modal.Body>
  //               <div className="parent-div">
  //                 <div className="bdy-div">
  //                   <div className='flex-row justify-between'>
  //                     <button
  //                       type="button"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleChangeback}
  //                     >
  //                       Back
  //                     </button>
  //                     <button
  //                       type="button"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleShowWOT}
  //                     >
  //                       <AddwithWhiteCircle /> Add Revised EOT/COS
  //                     </button>
  //                   </div>
  //                   <div className="flex-row justify-center">
  //                     <table className="table-css ">

  //                       <thead className="table-heading">
  //                         <tr className="custom-table-head-tr width-10vw">
  //                           <th className="table-heading-text text-left-sr" >S no.</th>
  //                           <th className="table-heading-text text-center">Duration of Construction Period <br /><span className="required">(In-Months)</span></th>
  //                           <th className="table-heading-text text-center">Duration of DLP <br /><span className="required">(In-Months)</span></th>
  //                           <th className="table-heading-text text-center">Total Period <br /> <span className="required">(Read-Only)</span></th>
  //                           <th className="table-heading-text text-center">Rate  <br /> <span className="required">(Monthly-Rate)</span></th>
  //                         </tr>
  //                       </thead>

  //                       <tbody>

  //                         {formData.map((entry, index) => (
  //                           <tr key={index} className="custom-table-head-td ">

  //                             <td className="align-left width-5vw" >
  //                               {index + 1}
  //                             </td>


  //                             <td>
  //                               <div title="During Construction Period" className="flex-column align-items-center  align-items-center">
  //                                 <input
  //                                   className={`form-input width-5vw ${errors[`${index}_during_construction_period`] ? "error" : ""}`}
  //                                   id={`during_construction_period_${index}`}
  //                                   name="during_construction_period"
  //                                   type="number"
  //                                   value={entry.during_construction_period}
  //                                   onChange={(e) => handleInputChange(e, index)}

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_during_construction_period`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_during_construction_period`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>
  //                             <td>
  //                               <div title="O&M Period" className="flex-column align-items-center">
  //                                 <input
  //                                   className={`form-input-date  width-5vw  ${errors[`${index}_during_dlp_OM_period`] ? "error" : ""}`}
  //                                   id={`during_dlp_OM_period_${index}`}
  //                                   name="during_dlp_OM_period"
  //                                   type="number"
  //                                   value={entry.during_dlp_OM_period}
  //                                   onChange={(e) => handleInputChange(e, index)}

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_during_dlp_OM_period`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_during_dlp_OM_period`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>
  //                             <td>
  //                               <div title="Total Months" className="flex-column align-items-center">
  //                                 <input
  //                                   className={`form-input-date  width-5vw  ${errors[`${index}_num_of_months`] ? "error" : ""}`}
  //                                   id={`num_of_months_${index}`}
  //                                   name="num_of_months"
  //                                   type="text"
  //                                   readOnly
  //                                   value={entry.num_of_months} // Calculate and display the sum
  //                                   onChange={(e) => handleInputChange(e, index)}

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_num_of_months`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_num_of_months`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>
  //                             <td>
  //                               <div title="Rate" className="flex-column align-items-center">
  //                                 <input
  //                                   className={`form-input-date  width-5vw  ${errors[`${index}_rate_per_month`] ? "error" : ""}`}
  //                                   id={`rate_per_month_${index}`}
  //                                   name="rate_per_month"
  //                                   type="text"
  //                                   value={entry.rate_per_month}
  //                                   onChange={(e) => handleInputChange(e, index)}

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_rate_per_month`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_rate_per_month`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>


  //                           </tr>
  //                         ))}

  //                       </tbody>

  //                     </table>
  //                   </div>
  //                   <div className="button-models">
  //                     <button
  //                       className="model-button-cancel model-button font-weight500"
  //                       onClick={handleClose}
  //                     >
  //                       Cancel
  //                     </button>
  //                     <button
  //                       type="submit"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleSubmit}
  //                     >
  //                       Update
  //                     </button>
  //                   </div>

  //                 </div>
  //               </div>
  //               <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

  //             </Modal.Body> : showEOT === true ?
  //               <Modal.Body>
  //                 <div className="parent-div">
  //                   <div className="bdy-div">
  //                     <div className='flex-row justify-between'>
  //                       <button
  //                         type="button"
  //                         className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                         disabled={loading}
  //                         onClick={handleclOSEOT}
  //                       >
  //                         Back
  //                       </button>
  //                       <button
  //                         type="button"
  //                         className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                         disabled={loading}
  //                         onClick={addNewEOT}
  //                       >
  //                         <AddwithWhiteCircle /> Add Another Revised EOT/COS
  //                       </button>
  //                     </div>
  //                     {formData[0]?.eot_details?.map((_, detailIndex) => (
  //                       <div key={detailIndex}>
  //                         <h3>EOT Round {detailIndex + 1}</h3>
  //                         <table className="nested-table-lightblue width-90vw payment">

  //                           <thead>
  //                             <tr>
  //                               <th>CP</th>
  //                               <th>DLP</th>
  //                               <th>T Month</th>
  //                               <th>Rate</th>
  //                               <th>Total Amount</th>
  //                             </tr>
  //                           </thead>
  //                           <tbody>
  //                             {formData.map((entry, entryIndex) => (
  //                               <tr key={entryIndex}>
  //                                 <td>
  //                                   <input
  //                                     type="number"
  //                                     className={`form-input-date  width-5vw  ${errors[`${entryIndex}_cp`] ? "error" : ""}`}

  //                                     value={entry.eot_details[detailIndex]?.cp || 0}
  //                                     onChange={(e) =>
  //                                       handleEOTChange(entryIndex, detailIndex, "cp", e.target.value)
  //                                     }
  //                                   />
  //                                 </td>
  //                                 <td>
  //                                   <input
  //                                     type="number"
  //                                     className={`form-input-date  width-5vw  ${errors[`${entryIndex}_dlp`] ? "error" : ""}`}

  //                                     value={entry.eot_details[detailIndex]?.dlp || 0}
  //                                     onChange={(e) =>
  //                                       handleEOTChange(entryIndex, detailIndex, "dlp", e.target.value)
  //                                     }
  //                                   />
  //                                 </td>
  //                                 <td>
  //                                   <input
  //                                     type="number"
  //                                     value={entry.eot_details[detailIndex]?.t_month || 0}
  //                                     className={`form-input-date  width-5vw  ${errors[`${entryIndex}_t_month`] ? "error" : ""}`}
  //                                     disabled
  //                                     onChange={(e) =>
  //                                       handleEOTChange(
  //                                         entryIndex,
  //                                         detailIndex,
  //                                         "t_month",
  //                                         e.target.value
  //                                       )
  //                                     }
  //                                   />
  //                                 </td>
  //                                 <td>
  //                                   <input
  //                                     type="number"
  //                                     value={entry.eot_details[detailIndex]?.rate || 0}
  //                                     onChange={(e) =>
  //                                       handleEOTChange(entryIndex, detailIndex, "rate", e.target.value)
  //                                     }
  //                                     className={`form-input-date  width-5vw  ${errors[`${entryIndex}_rate`] ? "error" : ""}`}

  //                                   />
  //                                 </td>
  //                                 <td>
  //                                   <input
  //                                     type="number"
  //                                     className={`form-input-date  width-5vw  ${errors[`${entryIndex}_total_amount`] ? "error" : ""}`}
  //                                     disabled
  //                                     value={entry.eot_details[detailIndex]?.total_amount || 0}
  //                                     onChange={(e) =>
  //                                       handleEOTChange(
  //                                         entryIndex,
  //                                         detailIndex,
  //                                         "total_amount",
  //                                         e.target.value
  //                                       )
  //                                     }
  //                                   />
  //                                 </td>
  //                               </tr>
  //                             ))}
  //                           </tbody>
  //                         </table>
  //                       </div>
  //                     ))}

  //                     <div className="button-models">
  //                       <button
  //                         className="model-button-cancel model-button font-weight500"
  //                         onClick={handleClose}
  //                       >
  //                         Cancel
  //                       </button>
  //                       <button
  //                         type="submit"
  //                         className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                         disabled={loading}
  //                         onClick={handleSubmit}
  //                       >
  //                         Save
  //                       </button>
  //                     </div>

  //                   </div>
  //                 </div>
  //                 <ToastContainer
  //                   position="top-center"
  //                   autoClose={1000}
  //                   hideProgressBar={false}
  //                   newestOnTop={true}
  //                   closeOnClick
  //                   rtl={false}
  //                   pauseOnFocusLoss
  //                   draggable
  //                   pauseOnHover
  //                 />
  //               </Modal.Body > : ""
  //       }
  //     </Modal >
  //   </>
  // )


  return (
    <>
      <button
        title="Update Office Rent"
        className="eb-bulk-trigger-btn"
        onClick={handleShow}
        style={{ background: "black" }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="white"
          viewBox="0 0 24 24"
          id="pen-new-square"
        >
          <path fill="" fillRule="evenodd" d="M11.9426 1.25L13.5 1.25C13.9142 1.25 14.25 1.58579 14.25 2C14.25 2.41421 13.9142 2.75 13.5 2.75H12C9.62177 2.75 7.91356 2.75159 6.61358 2.92637C5.33517 3.09825 4.56445 3.42514 3.9948 3.9948C3.23505 4.75455 2.91245 5.86509 2.80417 8.03734C2.78355 8.45104 2.43146 8.76969 2.01776 8.74907C1.60406 8.72845 1.28541 8.37636 1.30603 7.96266C1.41642 5.74802 1.74641 4.12187 2.93414 2.93414C3.82895 2.03933 4.96897 1.63399 6.41371 1.43975C7.82519 1.24998 9.63423 1.24999 11.9426 1.25ZM22 9.75C22.4142 9.75 22.75 10.0858 22.75 10.5V12.0574C22.75 14.3658 22.75 16.1748 22.5603 17.5863C22.366 19.031 21.9607 20.1711 21.0659 21.0659C20.1711 21.9607 19.031 22.366 17.5863 22.5603C16.1748 22.75 14.3658 22.75 12.0574 22.75H11.9426C9.63423 22.75 7.82519 22.75 6.41371 22.5603C4.96897 22.366 3.82895 21.9607 2.93414 21.0659C2.03933 20.1711 1.63399 19.031 1.43975 17.5863C1.24998 16.1748 1.24999 14.3658 1.25 12.0574L1.25 12C1.25 11.5858 1.58579 11.25 2 11.25C2.41421 11.25 2.75 11.5858 2.75 12C2.75 14.3782 2.75159 16.0864 2.92637 17.3864C3.09825 18.6648 3.42514 19.4355 3.9948 20.0052C4.56445 20.5749 5.33517 20.9018 6.61358 21.0736C7.91356 21.2484 9.62177 21.25 12 21.25C14.3782 21.25 16.0864 21.2484 17.3864 21.0736C18.6648 20.9018 19.4355 20.5749 20.0052 20.0052C20.5749 19.4355 20.9018 18.6648 21.0736 17.3864C21.2484 16.0864 21.25 14.3782 21.25 12V10.5C21.25 10.0858 21.5858 9.75 22 9.75Z" clipRule="evenodd" />
          <path fill="" fillRule="evenodd" d="M16.7705 2.27592C18.1384 0.908029 20.3562 0.908029 21.7241 2.27592C23.092 3.6438 23.092 5.86158 21.7241 7.22947L18.0928 10.8607C17.7999 11.1536 17.3251 11.1536 17.0322 10.8607C16.7393 10.5678 16.7393 10.093 17.0322 9.80006L19.1051 7.72709C18.5892 7.50519 17.9882 7.14946 17.4193 6.58065C16.8505 6.01185 16.4948 5.41082 16.2729 4.89486L11.2175 9.95026C10.801 10.3668 10.6376 10.532 10.4988 10.71C10.3274 10.9297 10.1804 11.1676 10.0605 11.4192C9.96337 11.623 9.88868 11.8429 9.7024 12.4017L9.27051 13.6974L10.3026 14.7295L11.5983 14.2976C12.1571 14.1113 12.377 14.0366 12.5808 13.9395C12.8324 13.8196 13.0703 13.6726 13.2901 13.5012C13.468 13.3624 13.6332 13.199 14.0497 12.7825C14.3426 12.4896 14.8175 12.4896 15.1104 12.7825C15.4033 13.0754 15.4033 13.5503 15.1104 13.8432L15.076 13.8776C14.7047 14.2489 14.4721 14.4815 14.2126 14.684C13.9069 14.9224 13.5761 15.1268 13.2261 15.2936C12.929 15.4352 12.6169 15.5392 12.1188 15.7052L9.21426 16.6734C8.67801 16.8521 8.0868 16.7126 7.68711 16.3129C7.28742 15.9132 7.14785 15.322 7.3266 14.7857L8.29477 11.8812C8.46079 11.3831 8.56479 11.071 8.7064 10.7739C8.87319 10.4239 9.07761 10.0931 9.31605 9.78742C9.51849 9.52787 9.7511 9.29529 10.1224 8.92401L16.7705 2.27592ZM17.4546 3.7132C17.4773 3.80906 17.509 3.92327 17.5532 4.05066C17.6965 4.46372 17.9677 5.00771 18.48 5.51999C18.9923 6.03227 19.5363 6.30346 19.9493 6.44677C20.0767 6.49097 20.1909 6.52273 20.2868 6.54543L20.6634 6.16881C21.4455 5.38671 21.4455 4.11867 20.6634 3.33658C19.8813 2.55448 18.6133 2.55448 17.8312 3.33658L17.4546 3.7132Z" clipRule="evenodd" />
        </svg>
        Update Office Rent
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName={!showChange ? "eb-bulk-modal request-leave" : "max-heightModal eb-bulk-modal model-width90vw"}
      >
        <Modal.Header className="eb-bulk-modal-header">
          <Modal.Title className="eb-bulk-modal-title">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
              <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
            </svg>
            Update Office Rent Data for BOQ
            <button
              className="close-btn"
              onClick={handleClose}
              style={{ marginLeft: 'auto', background: 'none', border: 'none', color: 'white', fontSize: '24px', cursor: 'pointer' }}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </Modal.Title>
        </Modal.Header>

        {!showChange ?
          /* ===== STEP 1: Reason for Change ===== */
          <Modal.Body className="eb-bulk-modal-body">
            <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
              <div className="eb-bulk-content">
                <div className="eb-bulk-reason-section" style={{ padding: '20px', background: '#f7fafc', borderRadius: '12px' }}>
                  <label className="eb-bulk-label" style={{ display: 'block', fontWeight: '600', marginBottom: '8px', color: '#2d3748' }}>
                    Reason for Change BOQ <span className="eb-bulk-required">*</span>
                  </label>
                  <input
                    type="text"
                    name="changeReason"
                    title="Reason for Change BOQ"
                    placeholder="Example- Revise EOT"
                    onChange={(e) => setChangeReason(e.target.value)}
                    className="eb-bulk-input"
                    style={{ width: '90%', padding: '12px 16px', fontSize: '14px' }}
                  />
                </div>
                <div className="eb-bulk-footer-actions" style={{ justifyContent: 'flex-end' }}>
                  <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                    Cancel
                  </button>
                  {(changeReason !== "null" && changeReason !== "") && (
                    <button
                      type="submit"
                      className="eb-bulk-btn eb-bulk-btn-submit"
                      disabled={loading}
                      onClick={handleChangeSubmit}
                      style={{ background: "black" }}
                    >
                      Next
                    </button>
                  )}
                </div>
              </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </Modal.Body>

          : showEOT === false ?
            /* ===== STEP 2: Main Table ===== */
            <Modal.Body className="eb-bulk-modal-body">
              <div className="eb-bulk-table-scroll table-box scroll-container-table" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
                <div className="eb-bulk-content">
                  <div className="eb-bulk-actions" style={{ justifyContent: 'space-between' }}>
                    <button
                      type="button"
                      className="eb-bulk-add-row-btn"
                      style={{ background: '#718096' }}
                      disabled={loading}
                      onClick={handleChangeback}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="15 18 9 12 15 6" />
                      </svg>
                      Back
                    </button>
                    <button
                      type="button"
                      className="eb-bulk-add-row-btn"
                      disabled={loading}
                      onClick={handleShowWOT}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="12" y1="8" x2="12" y2="16" />
                        <line x1="8" y1="12" x2="16" y2="12" />
                      </svg>
                      Add Revised EOT/COS
                    </button>
                  </div>

                  <div className="eb-bulk-table-wrapper">
                    <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "40vh", minHeight: "40vh" }}>
                      <table className="eb-bulk-table">
                        <thead className="eb-bulk-table-head">
                          <tr className="eb-bulk-table-header-row">
                            <th className="eb-bulk-th eb-bulk-th-rank">
                              <span className="eb-bulk-th-label">S.No</span>
                            </th>
                            <th className="eb-bulk-th">
                              <span className="eb-bulk-th-label">Construction Period</span>
                              <span className="eb-bulk-th-sub">(In-Months)</span>
                            </th>
                            <th className="eb-bulk-th">
                              <span className="eb-bulk-th-label">O&M Period</span>
                              <span className="eb-bulk-th-sub">(In-Months)</span>
                            </th>
                            <th className="eb-bulk-th eb-bulk-th-period">
                              <span className="eb-bulk-th-label">Total Period</span>
                              <span className="eb-bulk-th-sub">(Read-Only)</span>
                            </th>
                            <th className="eb-bulk-th eb-bulk-th-rate">
                              <span className="eb-bulk-th-label">Rate</span>
                              <span className="eb-bulk-th-sub">(Monthly)</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {formData.map((entry, index) => (
                            <tr key={index} className="eb-bulk-row">
                              <td className="eb-bulk-td eb-bulk-td-rank">
                                <span style={{ fontWeight: '500', color: '#2d3748' }}>{index + 1}.</span>
                              </td>

                              {/* During Construction Period */}
                              <td className="eb-bulk-td">
                                <div className="eb-bulk-input-wrapper">
                                  <input
                                    className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_during_construction_period`] ? "eb-bulk-input-error" : ""}`}
                                    id={`during_construction_period_${index}`}
                                    name="during_construction_period"
                                    type="number"
                                    value={entry.during_construction_period}
                                    onChange={(e) => handleInputChange(e, index)}
                                    placeholder="0"
                                  />
                                  {errors[`${index}_during_construction_period`] && (
                                    <span className="eb-bulk-error-text">{errors[`${index}_during_construction_period`]}</span>
                                  )}
                                </div>
                              </td>

                              {/* O&M Period */}
                              <td className="eb-bulk-td">
                                <div className="eb-bulk-input-wrapper">
                                  <input
                                    className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_during_dlp_OM_period`] ? "eb-bulk-input-error" : ""}`}
                                    id={`during_dlp_OM_period_${index}`}
                                    name="during_dlp_OM_period"
                                    type="number"
                                    value={entry.during_dlp_OM_period}
                                    onChange={(e) => handleInputChange(e, index)}
                                    placeholder="0"
                                  />
                                  {errors[`${index}_during_dlp_OM_period`] && (
                                    <span className="eb-bulk-error-text">{errors[`${index}_during_dlp_OM_period`]}</span>
                                  )}
                                </div>
                              </td>

                              {/* Total Months (Read-Only) */}
                              <td className="eb-bulk-td">
                                <div className="eb-bulk-input-wrapper">
                                  <input
                                    className="eb-bulk-input eb-bulk-input-number"
                                    id={`num_of_months_${index}`}
                                    name="num_of_months"
                                    type="text"
                                    readOnly
                                    value={entry.num_of_months}
                                    style={{ background: 'var(--eb-bulk-input-readonly-bg, #f0f0f0)', cursor: 'not-allowed' }}
                                  />
                                </div>
                              </td>

                              {/* Rate per Month */}
                              <td className="eb-bulk-td">
                                <div className="eb-bulk-input-wrapper">
                                  <input
                                    className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_rate_per_month`] ? "eb-bulk-input-error" : ""}`}
                                    id={`rate_per_month_${index}`}
                                    name="rate_per_month"
                                    type="text"
                                    value={entry.rate_per_month}
                                    onChange={(e) => handleInputChange(e, index)}
                                    placeholder="₹ 0.00"
                                  />
                                  {errors[`${index}_rate_per_month`] && (
                                    <span className="eb-bulk-error-text">{errors[`${index}_rate_per_month`]}</span>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="eb-bulk-footer-actions">
                    <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="eb-bulk-btn eb-bulk-btn-submit"
                      disabled={loading}
                      onClick={handleSubmit}
                      style={{ background: "black" }}
                    >
                      {loading ? (
                        <span className="eb-bulk-btn-loader">
                          <span className="eb-bulk-spinner"></span>
                          Updating...
                        </span>
                      ) : (
                        <>
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                            <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                          </svg>
                          Update
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
              <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            </Modal.Body>

            :
            /* ===== STEP 3: EOT Table ===== */
            <Modal.Body className="eb-bulk-modal-body">
              <div className="eb-bulk-container">
                <div className="eb-bulk-content">
                  <div className="eb-bulk-actions" style={{ justifyContent: 'space-between' }}>
                    <button
                      type="button"
                      className="eb-bulk-add-row-btn"
                      style={{ background: '#718096' }}
                      disabled={loading}
                      onClick={handleclOSEOT}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="15 18 9 12 15 6" />
                      </svg>
                      Back
                    </button>
                    <button
                      type="button"
                      className="eb-bulk-add-row-btn"
                      disabled={loading}
                      onClick={addNewEOT}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="12" y1="8" x2="12" y2="16" />
                        <line x1="8" y1="12" x2="16" y2="12" />
                      </svg>
                      Add Another Revised EOT/COS
                    </button>
                  </div>

                  <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
                    {formData[0]?.eot_details?.map((_, detailIndex) => (
                      <div key={detailIndex} style={{ marginBottom: '24px' }}>
                        <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#2d3748', marginBottom: '12px' }}>
                          EOT Round {detailIndex + 1}
                        </h3>
                        <div className="eb-bulk-table-wrapper">
                          <table className="eb-bulk-table">
                            <thead className="eb-bulk-table-head">
                              <tr className="eb-bulk-table-header-row">
                                <th className="eb-bulk-th"><span className="eb-bulk-th-label">CP</span></th>
                                <th className="eb-bulk-th"><span className="eb-bulk-th-label">DLP</span></th>
                                <th className="eb-bulk-th">
                                  <span className="eb-bulk-th-label">T Month</span>
                                  <span className="eb-bulk-th-sub">(Read-Only)</span>
                                </th>
                                <th className="eb-bulk-th"><span className="eb-bulk-th-label">Rate</span></th>
                                <th className="eb-bulk-th">
                                  <span className="eb-bulk-th-label">Total Amount</span>
                                  <span className="eb-bulk-th-sub">(Read-Only)</span>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {formData.map((entry, entryIndex) => (
                                <tr key={entryIndex} className="eb-bulk-row">
                                  {/* CP */}

                                  <td className="eb-bulk-td">
                                    <div className="eb-bulk-input-wrapper">

                                      <input
                                        type="number"
                                        className={`eb-bulk-input eb-bulk-input-number ${errors[`${entryIndex}_cp`] ? "eb-bulk-input-error" : ""}`}
                                        value={entry.eot_details[detailIndex]?.cp || 0}
                                        onChange={(e) => handleEOTChange(entryIndex, detailIndex, "cp", e.target.value)}
                                        placeholder="0"
                                      />
                                    </div>
                                  </td>
                                  {/* DLP */}

                                  <td className="eb-bulk-td">
                                    <div className="eb-bulk-input-wrapper">

                                      <input
                                        type="number"
                                        className={`eb-bulk-input eb-bulk-input-number ${errors[`${entryIndex}_dlp`] ? "eb-bulk-input-error" : ""}`}
                                        value={entry.eot_details[detailIndex]?.dlp || 0}
                                        onChange={(e) => handleEOTChange(entryIndex, detailIndex, "dlp", e.target.value)}
                                        placeholder="0"
                                      />
                                    </div>
                                  </td>
                                  {/* T Month (Read-Only) */}

                                  <td className="eb-bulk-td">
                                    <div className="eb-bulk-input-wrapper">

                                      <input
                                        type="number"
                                        className="eb-bulk-input eb-bulk-input-number"
                                        value={entry.eot_details[detailIndex]?.t_month || 0}
                                        disabled
                                        style={{ background: 'var(--eb-bulk-input-readonly-bg, #f0f0f0)', cursor: 'not-allowed' }}
                                      />
                                    </div>
                                  </td>
                                  {/* Rate */}

                                  <td className="eb-bulk-td">
                                    <div className="eb-bulk-input-wrapper">

                                      <input
                                        type="number"
                                        className={`eb-bulk-input eb-bulk-input-number ${errors[`${entryIndex}_rate`] ? "eb-bulk-input-error" : ""}`}
                                        value={entry.eot_details[detailIndex]?.rate || 0}
                                        onChange={(e) => handleEOTChange(entryIndex, detailIndex, "rate", e.target.value)}
                                        placeholder="₹ 0.00"
                                      />
                                    </div>
                                  </td>
                                  {/* Total Amount (Read-Only) */}
                                  <td className="eb-bulk-td eb-bulk-td-total">
                                    <div className="eb-bulk-input-wrapper">
                                      <span className="eb-bulk-total-value" style={{ minWidth: '80px' }}>
                                        {entry.eot_details[detailIndex]?.total_amount || 0}
                                      </span>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="eb-bulk-footer-actions">
                    <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="eb-bulk-btn eb-bulk-btn-submit"
                      disabled={loading}
                      onClick={handleSubmit}
                      style={{ background: "black" }}
                    >
                      {loading ? (
                        <span className="eb-bulk-btn-loader">
                          <span className="eb-bulk-spinner"></span>
                          Saving...
                        </span>
                      ) : (
                        <>
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" />
                            <polyline points="17 21 17 13 7 13 7 21" />
                            <polyline points="7 3 7 8 15 8" />
                          </svg>
                          Save
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
              <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            </Modal.Body>
        }
      </Modal>
    </>
  );
}
const BulkUpdateOfficeSuppliesData = ({ boqOfficeSuppliesList, i, getData, id, value, getLogData }) => {

  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState([]);
  const [changeReason, setChangeReason] = useState("null");
  const [showChange, setShowChange] = useState(false);




  const createdAt = new Date().toISOString();

  useEffect(() => {
    if (!showChange) {
      setFormData((prevData) =>
        prevData.map((item) => ({
          ...item,
          random_value_of_changes: createdAt,
          change_by_emp_code: sessionStorage.getItem('sitemanagement_emp_code'),
          change_by_emp_name: sessionStorage.getItem('name'),

        }))
      );
    }

  }, [createdAt, showChange])




  useEffect(() => {
    if (changeReason !== "null") {
      setFormData((prevData) =>
        prevData.map((item) => ({
          ...item,
          reason_of_change: changeReason,

        }))
      );
    }
  }, [changeReason]);




  useEffect(() => {
    if (Array.isArray(boqOfficeSuppliesList)) {
      const initialData = boqOfficeSuppliesList.map((item) => ({
        months: "",
        monthly_rate: "",
        during_dlp_OM_period: "",
        during_construction_period: "",
        item: "",
        project: id,
        random_value_of_changes: "",
        reason_of_change: changeReason !== "null" ? changeReason : "",
        change_by_emp_code: sessionStorage.getItem('sitemanagement_emp_code'),
        change_by_emp_name: sessionStorage.getItem('name'),
        eot_details: [{
          boqId: item.id,
          item: item.item,
          cp: "",
          dlp: "",
          t_month: "",
          rate: "",
          total_amount: "",
        }],
      }));
      setFormData(initialData);
    }
  }, [boqOfficeSuppliesList]);






  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const [inputState, setInputState] = useState({});


  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const updatedData = [...formData];

    updatedData[index][name] = value;

    const dlp = Number(updatedData[index].during_dlp_OM_period || 0);
    const construction = Number(updatedData[index].during_construction_period || 0);
    updatedData[index].months = dlp + construction;

    setFormData(updatedData);
  };

  const handleShow = () => {
    setShow(true);
    setFormData(boqOfficeSuppliesList);
  }


  const handleChangeSubmit = () => {
    setShowChange(true);
  }
  const handleChangeback = () => {
    setShowChange(false);

  }

  const handleClose = () => {
    setShow(false);
    setShowChange(false);
    setShowEOT(false)
    setChangeReason("");
  }

  const [loading, setLoading] = useState(false); //loading logic

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

      try {
        let res = await axios.put(
          `${BASE_URL}/siteproject/bulkBOQOfficeSupplies/`,
          formData
        );

        if (res.status === 200) {
          await getData();
          await getLogData();
          handleClose();
          toast.dismiss(loadingToastId); // Dismiss loading toast
          toast.success('Office Supplies BOQ data updated successfully.')
        } else {
          alert(res);
        }
      } catch (err) {
        //toast Logic
        handleErrorToast(err, loadingToastId);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };
  const [showEOT, setShowEOT] = useState(false);
  const handleShowWOT = () => {
    setShowEOT(true)
  }
  const handleclOSEOT = () => {
    setShowEOT(false)
  }


  const addNewEOT = () => {
    setFormData((prevFormData) =>
      prevFormData.map((entry) => ({
        ...entry,
        eot_details: [
          ...(entry.eot_details || []),
          {
            boqId: entry.boqId || entry.id,
            cp: "",
            dlp: "",
            t_month: "",
            rate: "",
            total_amount: "",
          },
        ],
      }))
    );
  };
  const handleEOTChange = (entryIndex, detailIndex, field, value) => {
    setFormData((prevFormData) =>
      prevFormData.map((entry, i) => {
        if (i !== entryIndex) return entry;

        const updatedDetails = entry.eot_details.map((detail, j) => {
          if (j !== detailIndex) return detail;

          const updatedDetail = { ...detail, [field]: value };

          // Auto-calc t_month = cp + dlp
          const cp = parseFloat(updatedDetail.cp) || 0;
          const dlp = parseFloat(updatedDetail.dlp) || 0;
          updatedDetail.t_month = cp + dlp;

          // Auto-calc total_amount = t_month * rate
          const rate = parseFloat(updatedDetail.rate) || 0;
          updatedDetail.total_amount = updatedDetail.t_month * rate;

          return updatedDetail;
        });

        return { ...entry, eot_details: updatedDetails };
      })
    );
  };

  useEffect(() => {
    if (Array.isArray(boqOfficeSuppliesList)) {
      const initialData = boqOfficeSuppliesList.map((item) => ({
        months: "",
        monthly_rate: "",
        during_dlp_OM_period: "",
        during_construction_period: "",
        item: "",
        project: id,
        random_value_of_changes: "",
        reason_of_change: changeReason !== "null" ? changeReason : "",
        change_by_emp_code: sessionStorage.getItem('sitemanagement_emp_code'),
        change_by_emp_name: sessionStorage.getItem('name'),
        eot_details: [{
          boqId: item.id,
          item: item.item,
          cp: "",
          dlp: "",
          t_month: "",
          rate: "",
          total_amount: "",
        }],
      }));
      setFormData(initialData);
      setShowEOT(true); // ✅ show EOT table immediately

    }
  }, [boqOfficeSuppliesList]);


  return (
    <>
      <button
        title="Update Office Supplies"
        className="eb-bulk-trigger-btn"
        onClick={handleShow}
        style={{ background: "black" }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="white"
          viewBox="0 0 24 24"
          id="pen-new-square"
        >
          <path fill="" fillRule="evenodd" d="M11.9426 1.25L13.5 1.25C13.9142 1.25 14.25 1.58579 14.25 2C14.25 2.41421 13.9142 2.75 13.5 2.75H12C9.62177 2.75 7.91356 2.75159 6.61358 2.92637C5.33517 3.09825 4.56445 3.42514 3.9948 3.9948C3.23505 4.75455 2.91245 5.86509 2.80417 8.03734C2.78355 8.45104 2.43146 8.76969 2.01776 8.74907C1.60406 8.72845 1.28541 8.37636 1.30603 7.96266C1.41642 5.74802 1.74641 4.12187 2.93414 2.93414C3.82895 2.03933 4.96897 1.63399 6.41371 1.43975C7.82519 1.24998 9.63423 1.24999 11.9426 1.25ZM22 9.75C22.4142 9.75 22.75 10.0858 22.75 10.5V12.0574C22.75 14.3658 22.75 16.1748 22.5603 17.5863C22.366 19.031 21.9607 20.1711 21.0659 21.0659C20.1711 21.9607 19.031 22.366 17.5863 22.5603C16.1748 22.75 14.3658 22.75 12.0574 22.75H11.9426C9.63423 22.75 7.82519 22.75 6.41371 22.5603C4.96897 22.366 3.82895 21.9607 2.93414 21.0659C2.03933 20.1711 1.63399 19.031 1.43975 17.5863C1.24998 16.1748 1.24999 14.3658 1.25 12.0574L1.25 12C1.25 11.5858 1.58579 11.25 2 11.25C2.41421 11.25 2.75 11.5858 2.75 12C2.75 14.3782 2.75159 16.0864 2.92637 17.3864C3.09825 18.6648 3.42514 19.4355 3.9948 20.0052C4.56445 20.5749 5.33517 20.9018 6.61358 21.0736C7.91356 21.2484 9.62177 21.25 12 21.25C14.3782 21.25 16.0864 21.2484 17.3864 21.0736C18.6648 20.9018 19.4355 20.5749 20.0052 20.0052C20.5749 19.4355 20.9018 18.6648 21.0736 17.3864C21.2484 16.0864 21.25 14.3782 21.25 12V10.5C21.25 10.0858 21.5858 9.75 22 9.75Z" clipRule="evenodd" />
          <path fill="" fillRule="evenodd" d="M16.7705 2.27592C18.1384 0.908029 20.3562 0.908029 21.7241 2.27592C23.092 3.6438 23.092 5.86158 21.7241 7.22947L18.0928 10.8607C17.7999 11.1536 17.3251 11.1536 17.0322 10.8607C16.7393 10.5678 16.7393 10.093 17.0322 9.80006L19.1051 7.72709C18.5892 7.50519 17.9882 7.14946 17.4193 6.58065C16.8505 6.01185 16.4948 5.41082 16.2729 4.89486L11.2175 9.95026C10.801 10.3668 10.6376 10.532 10.4988 10.71C10.3274 10.9297 10.1804 11.1676 10.0605 11.4192C9.96337 11.623 9.88868 11.8429 9.7024 12.4017L9.27051 13.6974L10.3026 14.7295L11.5983 14.2976C12.1571 14.1113 12.377 14.0366 12.5808 13.9395C12.8324 13.8196 13.0703 13.6726 13.2901 13.5012C13.468 13.3624 13.6332 13.199 14.0497 12.7825C14.3426 12.4896 14.8175 12.4896 15.1104 12.7825C15.4033 13.0754 15.4033 13.5503 15.1104 13.8432L15.076 13.8776C14.7047 14.2489 14.4721 14.4815 14.2126 14.684C13.9069 14.9224 13.5761 15.1268 13.2261 15.2936C12.929 15.4352 12.6169 15.5392 12.1188 15.7052L9.21426 16.6734C8.67801 16.8521 8.0868 16.7126 7.68711 16.3129C7.28742 15.9132 7.14785 15.322 7.3266 14.7857L8.29477 11.8812C8.46079 11.3831 8.56479 11.071 8.7064 10.7739C8.87319 10.4239 9.07761 10.0931 9.31605 9.78742C9.51849 9.52787 9.7511 9.29529 10.1224 8.92401L16.7705 2.27592ZM17.4546 3.7132C17.4773 3.80906 17.509 3.92327 17.5532 4.05066C17.6965 4.46372 17.9677 5.00771 18.48 5.51999C18.9923 6.03227 19.5363 6.30346 19.9493 6.44677C20.0767 6.49097 20.1909 6.52273 20.2868 6.54543L20.6634 6.16881C21.4455 5.38671 21.4455 4.11867 20.6634 3.33658C19.8813 2.55448 18.6133 2.55448 17.8312 3.33658L17.4546 3.7132Z" clipRule="evenodd" />
        </svg>
        Update Office Supplies
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName={!showChange ? "eb-bulk-modal request-leave" : "max-heightModal eb-bulk-modal model-width90vw"}
      >
        <Modal.Header className="eb-bulk-modal-header">
          <Modal.Title className="eb-bulk-modal-title">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
              <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
            </svg>
            Update Office Supplies Data for BOQ
            <button
              className="close-btn"
              onClick={handleClose}
              style={{ marginLeft: 'auto', background: 'none', border: 'none', color: 'white', fontSize: '24px', cursor: 'pointer' }}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </Modal.Title>
        </Modal.Header>

        {!showChange ?
          /* ===== STEP 1: Reason for Change ===== */
          <Modal.Body className="eb-bulk-modal-body">
            <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
              <div className="eb-bulk-content">
                <div className="eb-bulk-reason-section" style={{ padding: '20px', background: '#f7fafc', borderRadius: '12px' }}>
                  <label className="eb-bulk-label" style={{ display: 'block', fontWeight: '600', marginBottom: '8px', color: '#2d3748' }}>
                    Reason for Change BOQ <span className="eb-bulk-required">*</span>
                  </label>
                  <input
                    type="text"
                    name="changeReason"
                    title="Reason for Change BOQ"
                    placeholder="Example- Revise EOT"
                    onChange={(e) => setChangeReason(e.target.value)}
                    className="eb-bulk-input"
                    style={{ width: '90%', padding: '12px 16px', fontSize: '14px' }}
                  />
                </div>
                <div className="eb-bulk-footer-actions" style={{ justifyContent: 'flex-end' }}>
                  <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                    Cancel
                  </button>
                  {(changeReason !== "null" && changeReason !== "") && (
                    <button
                      type="submit"
                      className="eb-bulk-btn eb-bulk-btn-submit"
                      disabled={loading}
                      onClick={handleChangeSubmit}
                      style={{ background: "black" }}
                    >
                      Next
                    </button>
                  )}
                </div>
              </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </Modal.Body>

          : showEOT === false ?
            /* ===== STEP 2: Main Table ===== */
            <Modal.Body className="eb-bulk-modal-body">
              <div className="eb-bulk-table-scroll table-box scroll-container-table" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
                <div className="eb-bulk-content">
                  <div className="eb-bulk-actions" style={{ justifyContent: 'space-between' }}>
                    <button
                      type="button"
                      className="eb-bulk-add-row-btn"
                      style={{ background: '#718096' }}
                      disabled={loading}
                      onClick={handleChangeback}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="15 18 9 12 15 6" />
                      </svg>
                      Back
                    </button>
                    <button
                      type="button"
                      className="eb-bulk-add-row-btn"
                      disabled={loading}
                      onClick={handleShowWOT}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="12" y1="8" x2="12" y2="16" />
                        <line x1="8" y1="12" x2="16" y2="12" />
                      </svg>
                      Add Revised EOT/COS
                    </button>
                  </div>

                  <div className="eb-bulk-table-wrapper">
                    <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "40vh", minHeight: "40vh" }}>
                      <table className="eb-bulk-table">
                        <thead className="eb-bulk-table-head">
                          <tr className="eb-bulk-table-header-row">
                            <th className="eb-bulk-th eb-bulk-th-rank">
                              <span className="eb-bulk-th-label">S.No</span>
                            </th>
                            <th className="eb-bulk-th">
                              <span className="eb-bulk-th-label">Items</span>
                              <span className="eb-bulk-th-sub">(Read-Only)</span>
                            </th>
                            <th className="eb-bulk-th">
                              <span className="eb-bulk-th-label">Construction Period</span>
                              <span className="eb-bulk-th-sub">(In-Months)</span>
                            </th>
                            <th className="eb-bulk-th">
                              <span className="eb-bulk-th-label">DLP Period</span>
                              <span className="eb-bulk-th-sub">(In-Months)</span>
                            </th>
                            <th className="eb-bulk-th eb-bulk-th-period">
                              <span className="eb-bulk-th-label">Total Period</span>
                              <span className="eb-bulk-th-sub">(Read-Only)</span>
                            </th>
                            <th className="eb-bulk-th eb-bulk-th-rate">
                              <span className="eb-bulk-th-label">Rate</span>
                              <span className="eb-bulk-th-sub">(Monthly)</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {formData.map((entry, index) => (
                            <tr key={index} className="eb-bulk-row">
                              <td className="eb-bulk-td eb-bulk-td-rank">
                                <span style={{ fontWeight: '500', color: '#2d3748' }}>{index + 1}.</span>
                              </td>

                              {/* Items (Read-Only) */}
                              <td className="eb-bulk-td">
                                <div className="eb-bulk-input-wrapper">
                                  <input
                                    className="eb-bulk-input"
                                    id={`item_${index}`}
                                    name="item"
                                    type="text"
                                    readOnly
                                    value={entry.item}
                                    style={{ background: 'var(--eb-bulk-input-readonly-bg, #f0f0f0)', cursor: 'not-allowed' }}
                                  />
                                </div>
                              </td>

                              {/* During Construction Period */}
                              <td className="eb-bulk-td">
                                <div className="eb-bulk-input-wrapper">
                                  <input
                                    className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_during_construction_period`] ? "eb-bulk-input-error" : ""}`}
                                    id={`during_construction_period_${index}`}
                                    name="during_construction_period"
                                    type="number"
                                    value={entry.during_construction_period}
                                    onChange={(e) => handleInputChange(e, index)}
                                    placeholder="0"
                                  />
                                  {errors[`${index}_during_construction_period`] && (
                                    <span className="eb-bulk-error-text">{errors[`${index}_during_construction_period`]}</span>
                                  )}
                                </div>
                              </td>

                              {/* DLP / O&M Period */}
                              <td className="eb-bulk-td">
                                <div className="eb-bulk-input-wrapper">
                                  <input
                                    className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_during_dlp_OM_period`] ? "eb-bulk-input-error" : ""}`}
                                    id={`during_dlp_OM_period_${index}`}
                                    name="during_dlp_OM_period"
                                    type="number"
                                    value={entry.during_dlp_OM_period}
                                    onChange={(e) => handleInputChange(e, index)}
                                    placeholder="0"
                                  />
                                  {errors[`${index}_during_dlp_OM_period`] && (
                                    <span className="eb-bulk-error-text">{errors[`${index}_during_dlp_OM_period`]}</span>
                                  )}
                                </div>
                              </td>

                              {/* Total Months (Read-Only) */}
                              <td className="eb-bulk-td">
                                <div className="eb-bulk-input-wrapper">
                                  <input
                                    className="eb-bulk-input eb-bulk-input-number"
                                    id={`months_${index}`}
                                    name="months"
                                    type="text"
                                    readOnly
                                    value={entry.months}
                                    style={{ background: 'var(--eb-bulk-input-readonly-bg, #f0f0f0)', cursor: 'not-allowed' }}
                                  />
                                </div>
                              </td>

                              {/* Monthly Rate */}
                              <td className="eb-bulk-td">
                                <div className="eb-bulk-input-wrapper">
                                  <input
                                    className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_monthly_rate`] ? "eb-bulk-input-error" : ""}`}
                                    id={`monthly_rate_${index}`}
                                    name="monthly_rate"
                                    type="number"
                                    value={entry.monthly_rate}
                                    onChange={(e) => handleInputChange(e, index)}
                                    placeholder="₹ 0.00"
                                  />
                                  {errors[`${index}_monthly_rate`] && (
                                    <span className="eb-bulk-error-text">{errors[`${index}_monthly_rate`]}</span>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="eb-bulk-footer-actions">
                    <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="eb-bulk-btn eb-bulk-btn-submit"
                      disabled={loading}
                      onClick={handleSubmit}
                      style={{ background: "black" }}
                    >
                      {loading ? (
                        <span className="eb-bulk-btn-loader">
                          <span className="eb-bulk-spinner"></span>
                          Updating...
                        </span>
                      ) : (
                        <>
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                            <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                          </svg>
                          Update
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
              <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            </Modal.Body>

            :
            /* ===== STEP 3: EOT Table ===== */
            <Modal.Body className="eb-bulk-modal-body">
              <div className="eb-bulk-container">
                <div className="eb-bulk-content">
                  <div className="eb-bulk-actions" style={{ justifyContent: 'space-between' }}>
                    <button
                      type="button"
                      className="eb-bulk-add-row-btn"
                      style={{ background: '#718096' }}
                      disabled={loading}
                      onClick={handleclOSEOT}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="15 18 9 12 15 6" />
                      </svg>
                      Back
                    </button>
                    <button
                      type="button"
                      className="eb-bulk-add-row-btn"
                      disabled={loading}
                      onClick={addNewEOT}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="12" y1="8" x2="12" y2="16" />
                        <line x1="8" y1="12" x2="16" y2="12" />
                      </svg>
                      Add Another Revised EOT/COS
                    </button>
                  </div>

                  <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
                    {formData[0]?.eot_details?.map((_, detailIndex) => (
                      <div key={detailIndex} style={{ marginBottom: '24px' }}>
                        <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#2d3748', marginBottom: '12px' }}>
                          EOT Round {detailIndex + 1}
                        </h3>
                        <div className="eb-bulk-table-wrapper">
                          <table className="eb-bulk-table">
                            <thead className="eb-bulk-table-head">
                              <tr className="eb-bulk-table-header-row">
                                <th className="eb-bulk-th"><span className="eb-bulk-th-label">Items</span></th>
                                <th className="eb-bulk-th"><span className="eb-bulk-th-label">CP</span></th>
                                <th className="eb-bulk-th"><span className="eb-bulk-th-label">DLP</span></th>
                                <th className="eb-bulk-th">
                                  <span className="eb-bulk-th-label">T Month</span>
                                  <span className="eb-bulk-th-sub">(Read-Only)</span>
                                </th>
                                <th className="eb-bulk-th"><span className="eb-bulk-th-label">Rate</span></th>
                                <th className="eb-bulk-th">
                                  <span className="eb-bulk-th-label">Total Amount</span>
                                  <span className="eb-bulk-th-sub">(Read-Only)</span>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {formData.map((entry, entryIndex) => (
                                <tr key={entryIndex} className="eb-bulk-row">
                                  {/* Items (Read-Only) */}
                                  <td className="eb-bulk-td">
                                    <span style={{ fontWeight: '500', color: '#2d3748' }}>{entry.item}</span>
                                  </td>
                                  {/* CP */}
                                  <td className="eb-bulk-td">
                                    <div className="eb-bulk-input-wrapper">

                                      <input
                                        type="number"
                                        className={`eb-bulk-input eb-bulk-input-number ${errors[`${entryIndex}_cp`] ? "eb-bulk-input-error" : ""}`}
                                        value={entry.eot_details[detailIndex]?.cp || 0}
                                        onChange={(e) => handleEOTChange(entryIndex, detailIndex, "cp", e.target.value)}
                                        placeholder="0"
                                      />
                                    </div>
                                  </td>
                                  {/* DLP */}
                                  <td className="eb-bulk-td">
                                    <div className="eb-bulk-input-wrapper">

                                      <input
                                        type="number"
                                        className={`eb-bulk-input eb-bulk-input-number ${errors[`${entryIndex}_dlp`] ? "eb-bulk-input-error" : ""}`}
                                        value={entry.eot_details[detailIndex]?.dlp || 0}
                                        onChange={(e) => handleEOTChange(entryIndex, detailIndex, "dlp", e.target.value)}
                                        placeholder="0"
                                      />
                                    </div>
                                  </td>
                                  {/* T Month (Read-Only) */}
                                  <td className="eb-bulk-td">
                                    <div className="eb-bulk-input-wrapper">

                                      <input
                                        type="number"
                                        className="eb-bulk-input eb-bulk-input-number"
                                        value={entry.eot_details[detailIndex]?.t_month || 0}
                                        disabled
                                        style={{ background: 'var(--eb-bulk-input-readonly-bg, #f0f0f0)', cursor: 'not-allowed' }}
                                      />
                                    </div>
                                  </td>
                                  {/* Rate */}
                                  <td className="eb-bulk-td">
                                    <div className="eb-bulk-input-wrapper">

                                      <input
                                        type="number"
                                        className={`eb-bulk-input eb-bulk-input-number ${errors[`${entryIndex}_rate`] ? "eb-bulk-input-error" : ""}`}
                                        value={entry.eot_details[detailIndex]?.rate || 0}
                                        onChange={(e) => handleEOTChange(entryIndex, detailIndex, "rate", e.target.value)}
                                        placeholder="₹ 0.00"
                                      />
                                    </div>
                                  </td>
                                  {/* Total Amount (Read-Only) */}
                                  <td className="eb-bulk-td eb-bulk-td-total">
                                    <div className="eb-bulk-input-wrapper">

                                      <span className="eb-bulk-total-value" style={{ minWidth: '80px' }}>
                                        {entry.eot_details[detailIndex]?.total_amount || 0}
                                      </span>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="eb-bulk-footer-actions">
                    <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="eb-bulk-btn eb-bulk-btn-submit"
                      disabled={loading}
                      onClick={handleSubmit}
                      style={{ background: "black" }}
                    >
                      {loading ? (
                        <span className="eb-bulk-btn-loader">
                          <span className="eb-bulk-spinner"></span>
                          Saving...
                        </span>
                      ) : (
                        <>
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" />
                            <polyline points="17 21 17 13 7 13 7 21" />
                            <polyline points="7 3 7 8 15 8" />
                          </svg>
                          Save
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
              <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            </Modal.Body>
        }
      </Modal>
    </>
  );
}
const BulkUpdateOfficeFurnitureData = ({ boqOfficeFurnitureList, i, getData, id, value, getLogData }) => {

  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState([]);
  const [changeReason, setChangeReason] = useState("null");
  const [showChange, setShowChange] = useState(false);



  const createdAt = new Date().toISOString();

  useEffect(() => {
    if (!showChange) {
      setFormData((prevData) =>
        prevData.map((item) => ({
          ...item,
          random_value_of_changes: createdAt,
          change_by_emp_code: sessionStorage.getItem('sitemanagement_emp_code'),
          change_by_emp_name: sessionStorage.getItem('name'),

        }))
      );
    }

  }, [createdAt, showChange])




  useEffect(() => {
    if (changeReason !== "null") {
      setFormData((prevData) =>
        prevData.map((item) => ({
          ...item,
          reason_of_change: changeReason,

        }))
      );
    }
  }, [changeReason]);




  useEffect(() => {
    if (Array.isArray(boqOfficeFurnitureList)) {
      const initialData = boqOfficeFurnitureList.map((item) => ({
        num_of_months: "",
        rate_per_month: "",
        during_dlp_OM_period: "",
        during_construction_period: "",
        project: id,
        random_value_of_changes: "",
        reason_of_change: changeReason !== "null" ? changeReason : "",
        change_by_emp_code: sessionStorage.getItem('sitemanagement_emp_code'),
        change_by_emp_name: sessionStorage.getItem('name'),
        eot_details: [{
          boqId: item.id,
          cp: "",
          dlp: "",
          t_month: "",
          rate: "",
          total_amount: "",
        }],
      }));
      setFormData(initialData);
    }
  }, [boqOfficeFurnitureList]);






  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const [inputState, setInputState] = useState({});


  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const updatedData = [...formData];

    updatedData[index][name] = value;

    const dlp = Number(updatedData[index].during_dlp_OM_period || 0);
    const construction = Number(updatedData[index].during_construction_period || 0);
    updatedData[index].num_of_months = dlp + construction;

    setFormData(updatedData);
  };

  const handleShow = () => {
    setShow(true);
    setFormData(boqOfficeFurnitureList);
  }


  const handleChangeSubmit = () => {
    setShowChange(true);
  }
  const handleChangeback = () => {
    setShowChange(false);

  }


  const handleClose = () => {
    setShow(false);
    setShowChange(false);
    setShowEOT(false)
    setChangeReason("");
  }

  const [loading, setLoading] = useState(false); //loading logic

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

      try {
        let res = await axios.put(
          `${BASE_URL}/siteproject/bulkBOQOfficeFurnitureAndEquipment/`,
          formData
        );

        if (res.status === 200) {
          await getData();
          await getLogData();
          handleClose();
          toast.dismiss(loadingToastId); // Dismiss loading toast
          toast.success('Office Furniture BOQ data updated successfully.')
          // window.location.reload();
        } else {
          alert(res);
        }
      } catch (err) {
        //toast Logic
        handleErrorToast(err, loadingToastId);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };
  const [showEOT, setShowEOT] = useState(false);
  const handleShowWOT = () => {
    setShowEOT(true)
  }
  const handleclOSEOT = () => {
    setShowEOT(false)
  }


  const addNewEOT = () => {
    setFormData((prevFormData) =>
      prevFormData.map((entry) => ({
        ...entry,
        eot_details: [
          ...(entry.eot_details || []),
          {
            cp: "",
            dlp: "",
            t_month: "",
            rate: "",
            total_amount: "",
          },
        ],
      }))
    );
  };


  useEffect(() => {
    if (Array.isArray(boqOfficeFurnitureList)) {
      const initialData = boqOfficeFurnitureList.map((item) => ({
        num_of_months: "",
        rate_per_month: "",
        during_dlp_OM_period: "",
        during_construction_period: "",
        project: id,
        random_value_of_changes: "",
        reason_of_change: changeReason !== "null" ? changeReason : "",
        change_by_emp_code: sessionStorage.getItem('sitemanagement_emp_code'),
        change_by_emp_name: sessionStorage.getItem('name'),
        eot_details: [{
          boqId: item.id,
          cp: "",
          dlp: "",
          t_month: "",
          rate: "",
          total_amount: "",
        }],
      }));
      setFormData(initialData);
      setShowEOT(true); // ✅ show EOT table immediately

    }
  }, [boqOfficeFurnitureList]);



  const handleEOTChange = (entryIndex, detailIndex, field, value) => {
    setFormData((prevFormData) =>
      prevFormData.map((entry, i) => {
        if (i !== entryIndex) return entry;

        const updatedDetails = entry.eot_details.map((detail, j) => {
          if (j !== detailIndex) return detail;

          const updatedDetail = { ...detail, [field]: value };

          // Auto-calc t_month = cp + dlp
          const cp = parseFloat(updatedDetail.cp) || 0;
          const dlp = parseFloat(updatedDetail.dlp) || 0;
          updatedDetail.t_month = cp + dlp;

          // Auto-calc total_amount = t_month * rate
          const rate = parseFloat(updatedDetail.rate) || 0;
          updatedDetail.total_amount = updatedDetail.t_month * rate;

          return updatedDetail;
        });

        return { ...entry, eot_details: updatedDetails };
      })
    );
  };
  // return (
  //   <>
  //     <button title="Update Office Furniture" className="upload-svg flex-row" onClick={handleShow}>
  //       <svg
  //         xmlns="http://www.w3.org/2000/svg"
  //         width="24"
  //         height="24"
  //         fill="white"
  //         viewBox="0 0 24 24"
  //         id="pen-new-square"
  //       >
  //         <path
  //           fill=""
  //           fill-rule="evenodd"
  //           d="M11.9426 1.25L13.5 1.25C13.9142 1.25 14.25 1.58579 14.25 2C14.25 2.41421 13.9142 2.75 13.5 2.75H12C9.62177 2.75 7.91356 2.75159 6.61358 2.92637C5.33517 3.09825 4.56445 3.42514 3.9948 3.9948C3.23505 4.75455 2.91245 5.86509 2.80417 8.03734C2.78355 8.45104 2.43146 8.76969 2.01776 8.74907C1.60406 8.72845 1.28541 8.37636 1.30603 7.96266C1.41642 5.74802 1.74641 4.12187 2.93414 2.93414C3.82895 2.03933 4.96897 1.63399 6.41371 1.43975C7.82519 1.24998 9.63423 1.24999 11.9426 1.25ZM22 9.75C22.4142 9.75 22.75 10.0858 22.75 10.5V12.0574C22.75 14.3658 22.75 16.1748 22.5603 17.5863C22.366 19.031 21.9607 20.1711 21.0659 21.0659C20.1711 21.9607 19.031 22.366 17.5863 22.5603C16.1748 22.75 14.3658 22.75 12.0574 22.75H11.9426C9.63423 22.75 7.82519 22.75 6.41371 22.5603C4.96897 22.366 3.82895 21.9607 2.93414 21.0659C2.03933 20.1711 1.63399 19.031 1.43975 17.5863C1.24998 16.1748 1.24999 14.3658 1.25 12.0574L1.25 12C1.25 11.5858 1.58579 11.25 2 11.25C2.41421 11.25 2.75 11.5858 2.75 12C2.75 14.3782 2.75159 16.0864 2.92637 17.3864C3.09825 18.6648 3.42514 19.4355 3.9948 20.0052C4.56445 20.5749 5.33517 20.9018 6.61358 21.0736C7.91356 21.2484 9.62177 21.25 12 21.25C14.3782 21.25 16.0864 21.2484 17.3864 21.0736C18.6648 20.9018 19.4355 20.5749 20.0052 20.0052C20.5749 19.4355 20.9018 18.6648 21.0736 17.3864C21.2484 16.0864 21.25 14.3782 21.25 12V10.5C21.25 10.0858 21.5858 9.75 22 9.75Z"
  //           clip-rule="evenodd"
  //         ></path>
  //         <path
  //           fill=""
  //           fill-rule="evenodd"
  //           d="M16.7705 2.27592C18.1384 0.908029 20.3562 0.908029 21.7241 2.27592C23.092 3.6438 23.092 5.86158 21.7241 7.22947L18.0928 10.8607C17.7999 11.1536 17.3251 11.1536 17.0322 10.8607C16.7393 10.5678 16.7393 10.093 17.0322 9.80006L19.1051 7.72709C18.5892 7.50519 17.9882 7.14946 17.4193 6.58065C16.8505 6.01185 16.4948 5.41082 16.2729 4.89486L11.2175 9.95026C10.801 10.3668 10.6376 10.532 10.4988 10.71C10.3274 10.9297 10.1804 11.1676 10.0605 11.4192C9.96337 11.623 9.88868 11.8429 9.7024 12.4017L9.27051 13.6974L10.3026 14.7295L11.5983 14.2976C12.1571 14.1113 12.377 14.0366 12.5808 13.9395C12.8324 13.8196 13.0703 13.6726 13.2901 13.5012C13.468 13.3624 13.6332 13.199 14.0497 12.7825C14.3426 12.4896 14.8175 12.4896 15.1104 12.7825C15.4033 13.0754 15.4033 13.5503 15.1104 13.8432L15.076 13.8776C14.7047 14.2489 14.4721 14.4815 14.2126 14.684C13.9069 14.9224 13.5761 15.1268 13.2261 15.2936C12.929 15.4352 12.6169 15.5392 12.1188 15.7052L9.21426 16.6734C8.67801 16.8521 8.0868 16.7126 7.68711 16.3129C7.28742 15.9132 7.14785 15.322 7.3266 14.7857L8.29477 11.8812C8.46079 11.3831 8.56479 11.071 8.7064 10.7739C8.87319 10.4239 9.07761 10.0931 9.31605 9.78742C9.51849 9.52787 9.7511 9.29529 10.1224 8.92401L16.7705 2.27592ZM17.4546 3.7132C17.4773 3.80906 17.509 3.92327 17.5532 4.05066C17.6965 4.46372 17.9677 5.00771 18.48 5.51999C18.9923 6.03227 19.5363 6.30346 19.9493 6.44677C20.0767 6.49097 20.1909 6.52273 20.2868 6.54543L20.6634 6.16881C21.4455 5.38671 21.4455 4.11867 20.6634 3.33658C19.8813 2.55448 18.6133 2.55448 17.8312 3.33658L17.4546 3.7132Z"
  //           clip-rule="evenodd"
  //         ></path>
  //       </svg>
  //       {" "} Update Office Furniture
  //     </button>
  //     <Modal
  //       show={show}
  //       onHide={handleClose}
  //       dialogClassName="request-leave"
  //     >
  //       <Modal.Header closeButton >
  //         <Modal.Title>Update Office Furniture Data for BOQ</Modal.Title>

  //       </Modal.Header>
  //       {
  //         !showChange ?
  //           <Modal.Body>
  //             <div className="parent-div">
  //               <div className="bdy-div">
  //                 <div className="flex-column align-items-center">
  //                   <label className="form-labels font-weight500 font-size-subheading" title="Invoice Number">
  //                     Reason for Change BOQ<span className="required">*</span>
  //                   </label>
  //                   <input
  //                     type="text"
  //                     name="changeReason"
  //                     title="Reason for Change BOQ"
  //                     placeholder="Example- Revise EOT"
  //                     onChange={(e) => setChangeReason(e.target.value)}
  //                     className={`form-input ${errors.changeReason ? "is-invalid" : ""
  //                       }`}
  //                   />
  //                 </div>
  //                 <div className="button-models">
  //                   <button
  //                     className="model-button-cancel model-button font-weight500"
  //                     onClick={handleClose}
  //                   >
  //                     Cancel
  //                   </button>
  //                   {(changeReason !== "null" && changeReason !== "") && (
  //                     <button
  //                       type="submit"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleChangeSubmit}
  //                     >
  //                       Next
  //                     </button>
  //                   )}

  //                 </div>

  //               </div>
  //             </div>
  //             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

  //           </Modal.Body>
  //           : showEOT === false ?
  //             <Modal.Body>
  //               <div className="parent-div">
  //                 <div className="bdy-div">
  //                   <div className='flex-row justify-between'>
  //                     <button
  //                       type="button"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleChangeback}
  //                     >
  //                       Back
  //                     </button>
  //                     <button
  //                       type="button"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleShowWOT}
  //                     >
  //                       <AddwithWhiteCircle /> Add Revised EOT/COS
  //                     </button>
  //                   </div>
  //                   <div className="flex-row justify-center">
  //                     <table className="table-css ">
  //                       <thead className="table-heading">
  //                         <tr className="custom-table-head-tr width-10vw">
  //                           <th className="table-heading-text text-left-sr" >S no.</th>
  //                           <th className="table-heading-text text-center">Duration of Construction Period <br /><span className="required">(In-Months)</span></th>
  //                           <th className="table-heading-text text-center">Duration of DLP <br /><span className="required">(In-Months)</span></th>
  //                           <th className="table-heading-text text-center">Total Period <br /> <span className="required">(Read-Only)</span></th>
  //                           <th className="table-heading-text text-center">Rate  <br /> <span className="required">(Monthly-Rate)</span></th>
  //                         </tr>
  //                       </thead>

  //                       <tbody>

  //                         {formData.map((entry, index) => (
  //                           <tr key={index} className="custom-table-head-td ">

  //                             <td className="align-left width-5vw" >
  //                               {index + 1}
  //                             </td>
  //                             <td>
  //                               <div title="During Construction Period" className="flex-column align-items-center align-items-center">
  //                                 <input
  //                                   className={`form-input width-5vw ${errors[`${index}_during_construction_period`] ? "error" : ""}`}
  //                                   id={`during_construction_period_${index}`}
  //                                   name="during_construction_period"
  //                                   type="number"
  //                                   value={entry.during_construction_period}
  //                                   onChange={(e) => handleInputChange(e, index)}

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_during_construction_period`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_during_construction_period`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>
  //                             <td>
  //                               <div title="O&M Period" className="flex-column align-items-center align-items-center">
  //                                 <input
  //                                   className={`form-input-date  width-5vw  ${errors[`${index}_during_dlp_OM_period`] ? "error" : ""}`}
  //                                   id={`during_dlp_OM_period_${index}`}
  //                                   name="during_dlp_OM_period"
  //                                   type="number"
  //                                   value={entry.during_dlp_OM_period}
  //                                   onChange={(e) => handleInputChange(e, index)}

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_during_dlp_OM_period`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_during_dlp_OM_period`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>
  //                             <td>
  //                               <div title="Total Months" className="flex-column align-items-center align-items-center">
  //                                 <input
  //                                   className={`form-input-date  width-5vw  ${errors[`${index}_num_of_months`] ? "error" : ""}`}
  //                                   id={`num_of_months_${index}`}
  //                                   name="num_of_months"
  //                                   type="text"
  //                                   readOnly
  //                                   value={entry.num_of_months} // Calculate and display the sum
  //                                   onChange={(e) => handleInputChange(e, index)}

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_num_of_months`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_num_of_months`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>
  //                             <td>
  //                               <div title="Rate" className="flex-column align-items-center align-items-center">
  //                                 <input
  //                                   className={`form-input-date  width-5vw  ${errors[`${index}_rate_per_month`] ? "error" : ""}`}
  //                                   id={`rate_per_month_${index}`}
  //                                   name="rate_per_month"
  //                                   type="number"
  //                                   value={entry.rate_per_month}
  //                                   onChange={(e) => handleInputChange(e, index)}

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_rate_per_month`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_rate_per_month`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>


  //                           </tr>
  //                         ))}

  //                       </tbody>

  //                     </table>
  //                   </div>
  //                   <div className="button-models">
  //                     <button
  //                       className="model-button-cancel model-button font-weight500"
  //                       onClick={handleClose}
  //                     >
  //                       Cancel
  //                     </button>
  //                     <button
  //                       type="submit"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleSubmit}
  //                     >
  //                       Update
  //                     </button>
  //                   </div>

  //                 </div>
  //               </div>
  //               <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

  //             </Modal.Body> : showEOT === true ?
  //               <Modal.Body>
  //                 <div className="parent-div">
  //                   <div className="bdy-div">
  //                     <div className='flex-row justify-between'>
  //                       <button
  //                         type="button"
  //                         className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                         disabled={loading}
  //                         onClick={handleclOSEOT}
  //                       >
  //                         Back
  //                       </button>
  //                       <button
  //                         type="button"
  //                         className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                         disabled={loading}
  //                         onClick={addNewEOT}
  //                       >
  //                         <AddwithWhiteCircle /> Add Another Revised EOT/COS
  //                       </button>
  //                     </div>
  //                     {formData[0]?.eot_details?.map((_, detailIndex) => (
  //                       <div key={detailIndex}>
  //                         <h3>EOT Round {detailIndex + 1}</h3>
  //                         <table className="nested-table-lightblue width-90vw payment">

  //                           <thead>
  //                             <tr>
  //                               <th>CP</th>
  //                               <th>DLP</th>
  //                               <th>T Month</th>
  //                               <th>Rate</th>
  //                               <th>Total Amount</th>
  //                             </tr>
  //                           </thead>
  //                           <tbody>
  //                             {formData.map((entry, entryIndex) => (
  //                               <tr key={entryIndex}>
  //                                 <td>
  //                                   <input
  //                                     type="number"
  //                                     className={`form-input-date  width-5vw  ${errors[`${entryIndex}_cp`] ? "error" : ""}`}

  //                                     value={entry.eot_details[detailIndex]?.cp || ""}
  //                                     onChange={(e) =>
  //                                       handleEOTChange(entryIndex, detailIndex, "cp", e.target.value)
  //                                     }
  //                                   />
  //                                 </td>
  //                                 <td>
  //                                   <input
  //                                     type="number"
  //                                     className={`form-input-date  width-5vw  ${errors[`${entryIndex}_dlp`] ? "error" : ""}`}

  //                                     value={entry.eot_details[detailIndex]?.dlp || ""}
  //                                     onChange={(e) =>
  //                                       handleEOTChange(entryIndex, detailIndex, "dlp", e.target.value)
  //                                     }
  //                                   />
  //                                 </td>
  //                                 <td>
  //                                   <input
  //                                     type="number"
  //                                     value={entry.eot_details[detailIndex]?.t_month || ""}
  //                                     className={`form-input-date  width-5vw  ${errors[`${entryIndex}_t_month`] ? "error" : ""}`}
  //                                     disabled
  //                                     onChange={(e) =>
  //                                       handleEOTChange(
  //                                         entryIndex,
  //                                         detailIndex,
  //                                         "t_month",
  //                                         e.target.value
  //                                       )
  //                                     }
  //                                   />
  //                                 </td>
  //                                 <td>
  //                                   <input
  //                                     type="number"
  //                                     value={entry.eot_details[detailIndex]?.rate || ""}
  //                                     onChange={(e) =>
  //                                       handleEOTChange(entryIndex, detailIndex, "rate", e.target.value)
  //                                     }
  //                                     className={`form-input-date  width-5vw  ${errors[`${entryIndex}_rate`] ? "error" : ""}`}

  //                                   />
  //                                 </td>
  //                                 <td>
  //                                   <input
  //                                     type="number"
  //                                     className={`form-input-date  width-5vw  ${errors[`${entryIndex}_total_amount`] ? "error" : ""}`}
  //                                     disabled
  //                                     value={entry.eot_details[detailIndex]?.total_amount || ""}
  //                                     onChange={(e) =>
  //                                       handleEOTChange(
  //                                         entryIndex,
  //                                         detailIndex,
  //                                         "total_amount",
  //                                         e.target.value
  //                                       )
  //                                     }
  //                                   />
  //                                 </td>
  //                               </tr>
  //                             ))}
  //                           </tbody>
  //                         </table>
  //                       </div>
  //                     ))}

  //                     <div className="button-models">
  //                       <button
  //                         className="model-button-cancel model-button font-weight500"
  //                         onClick={handleClose}
  //                       >
  //                         Cancel
  //                       </button>
  //                       <button
  //                         type="submit"
  //                         className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                         disabled={loading}
  //                         onClick={handleSubmit}
  //                       >
  //                         Save
  //                       </button>
  //                     </div>

  //                   </div>
  //                 </div>
  //                 <ToastContainer
  //                   position="top-center"
  //                   autoClose={1000}
  //                   hideProgressBar={false}
  //                   newestOnTop={true}
  //                   closeOnClick
  //                   rtl={false}
  //                   pauseOnFocusLoss
  //                   draggable
  //                   pauseOnHover
  //                 />
  //               </Modal.Body > : ""
  //       }
  //     </Modal >
  //   </>
  // )

  return (
    <>
      <button
        title="Update Office Furniture"
        className="eb-bulk-trigger-btn"
        onClick={handleShow}
        style={{ background: "black" }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="white"
          viewBox="0 0 24 24"
          id="pen-new-square"
        >
          <path fillRule="evenodd" d="M11.9426 1.25L13.5 1.25C13.9142 1.25 14.25 1.58579 14.25 2C14.25 2.41421 13.9142 2.75 13.5 2.75H12C9.62177 2.75 7.91356 2.75159 6.61358 2.92637C5.33517 3.09825 4.56445 3.42514 3.9948 3.9948C3.23505 4.75455 2.91245 5.86509 2.80417 8.03734C2.78355 8.45104 2.43146 8.76969 2.01776 8.74907C1.60406 8.72845 1.28541 8.37636 1.30603 7.96266C1.41642 5.74802 1.74641 4.12187 2.93414 2.93414C3.82895 2.03933 4.96897 1.63399 6.41371 1.43975C7.82519 1.24998 9.63423 1.24999 11.9426 1.25ZM22 9.75C22.4142 9.75 22.75 10.0858 22.75 10.5V12.0574C22.75 14.3658 22.75 16.1748 22.5603 17.5863C22.366 19.031 21.9607 20.1711 21.0659 21.0659C20.1711 21.9607 19.031 22.366 17.5863 22.5603C16.1748 22.75 14.3658 22.75 12.0574 22.75H11.9426C9.63423 22.75 7.82519 22.75 6.41371 22.5603C4.96897 22.366 3.82895 21.9607 2.93414 21.0659C2.03933 20.1711 1.63399 19.031 1.43975 17.5863C1.24998 16.1748 1.24999 14.3658 1.25 12.0574L1.25 12C1.25 11.5858 1.58579 11.25 2 11.25C2.41421 11.25 2.75 11.5858 2.75 12C2.75 14.3782 2.75159 16.0864 2.92637 17.3864C3.09825 18.6648 3.42514 19.4355 3.9948 20.0052C4.56445 20.5749 5.33517 20.9018 6.61358 21.0736C7.91356 21.2484 9.62177 21.25 12 21.25C14.3782 21.25 16.0864 21.2484 17.3864 21.0736C18.6648 20.9018 19.4355 20.5749 20.0052 20.0052C20.5749 19.4355 20.9018 18.6648 21.0736 17.3864C21.2484 16.0864 21.25 14.3782 21.25 12V10.5C21.25 10.0858 21.5858 9.75 22 9.75Z" clipRule="evenodd" />
          <path fillRule="evenodd" d="M16.7705 2.27592C18.1384 0.908029 20.3562 0.908029 21.7241 2.27592C23.092 3.6438 23.092 5.86158 21.7241 7.22947L18.0928 10.8607C17.7999 11.1536 17.3251 11.1536 17.0322 10.8607C16.7393 10.5678 16.7393 10.093 17.0322 9.80006L19.1051 7.72709C18.5892 7.50519 17.9882 7.14946 17.4193 6.58065C16.8505 6.01185 16.4948 5.41082 16.2729 4.89486L11.2175 9.95026C10.801 10.3668 10.6376 10.532 10.4988 10.71C10.3274 10.9297 10.1804 11.1676 10.0605 11.4192C9.96337 11.623 9.88868 11.8429 9.7024 12.4017L9.27051 13.6974L10.3026 14.7295L11.5983 14.2976C12.1571 14.1113 12.377 14.0366 12.5808 13.9395C12.8324 13.8196 13.0703 13.6726 13.2901 13.5012C13.468 13.3624 13.6332 13.199 14.0497 12.7825C14.3426 12.4896 14.8175 12.4896 15.1104 12.7825C15.4033 13.0754 15.4033 13.5503 15.1104 13.8432L15.076 13.8776C14.7047 14.2489 14.4721 14.4815 14.2126 14.684C13.9069 14.9224 13.5761 15.1268 13.2261 15.2936C12.929 15.4352 12.6169 15.5392 12.1188 15.7052L9.21426 16.6734C8.67801 16.8521 8.0868 16.7126 7.68711 16.3129C7.28742 15.9132 7.14785 15.322 7.3266 14.7857L8.29477 11.8812C8.46079 11.3831 8.56479 11.071 8.7064 10.7739C8.87319 10.4239 9.07761 10.0931 9.31605 9.78742C9.51849 9.52787 9.7511 9.29529 10.1224 8.92401L16.7705 2.27592ZM17.4546 3.7132C17.4773 3.80906 17.509 3.92327 17.5532 4.05066C17.6965 4.46372 17.9677 5.00771 18.48 5.51999C18.9923 6.03227 19.5363 6.30346 19.9493 6.44677C20.0767 6.49097 20.1909 6.52273 20.2868 6.54543L20.6634 6.16881C21.4455 5.38671 21.4455 4.11867 20.6634 3.33658C19.8813 2.55448 18.6133 2.55448 17.8312 3.33658L17.4546 3.7132Z" clipRule="evenodd" />
        </svg>
        Update Office Furniture
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName={!showChange ? "eb-bulk-modal request-leave" : "max-heightModal eb-bulk-modal model-width90vw"}
      >
        <Modal.Header className="eb-bulk-modal-header">
          <Modal.Title className="eb-bulk-modal-title">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
              <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
            </svg>
            Update Office Furniture Data for BOQ
            <button
              className="close-btn"
              onClick={handleClose}
              style={{ marginLeft: "auto", background: "none", border: "none", color: "white", fontSize: "24px", cursor: "pointer" }}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </Modal.Title>
        </Modal.Header>

        {!showChange ? (

          /* ===== STEP 1: Reason for Change ===== */
          <Modal.Body className="eb-bulk-modal-body">
            <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
              <div className="eb-bulk-content">
                <div className="eb-bulk-reason-section" style={{ padding: "20px", background: "#f7fafc", borderRadius: "12px" }}>
                  <label className="eb-bulk-label" style={{ display: "block", fontWeight: "600", marginBottom: "8px", color: "#2d3748" }}>
                    Reason for Change BOQ <span className="eb-bulk-required">*</span>
                  </label>
                  <input
                    type="text"
                    name="changeReason"
                    title="Reason for Change BOQ"
                    placeholder="Example- Revise EOT"
                    onChange={(e) => setChangeReason(e.target.value)}
                    className="eb-bulk-input"
                    style={{ width: "90%", padding: "12px 16px", fontSize: "14px" }}
                  />
                </div>
                <div className="eb-bulk-footer-actions" style={{ justifyContent: "flex-end" }}>
                  <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                    Cancel
                  </button>
                  {(changeReason !== "null" && changeReason !== "") && (
                    <button
                      type="submit"
                      className="eb-bulk-btn eb-bulk-btn-submit"
                      disabled={loading}
                      onClick={handleChangeSubmit}
                      style={{ background: "black" }}
                    >
                      Next
                    </button>
                  )}
                </div>
              </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </Modal.Body>

        ) : showEOT === false ? (

          /* ===== STEP 2: Main Table ===== */
          <Modal.Body className="eb-bulk-modal-body">
            <div className="eb-bulk-table-scroll table-box scroll-container-table" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
              <div className="eb-bulk-content">
                <div className="eb-bulk-actions" style={{ justifyContent: "space-between" }}>
                  <button
                    type="button"
                    className="eb-bulk-add-row-btn"
                    style={{ background: "#718096" }}
                    disabled={loading}
                    onClick={handleChangeback}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="15 18 9 12 15 6" />
                    </svg>
                    Back
                  </button>
                  <button
                    type="button"
                    className="eb-bulk-add-row-btn"
                    disabled={loading}
                    onClick={handleShowWOT}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="8" x2="12" y2="16" />
                      <line x1="8" y1="12" x2="16" y2="12" />
                    </svg>
                    Add Revised EOT/COS
                  </button>
                </div>

                <div className="eb-bulk-table-wrapper">
                  <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "40vh", minHeight: "40vh" }}>
                    <table className="eb-bulk-table">
                      <thead className="eb-bulk-table-head">
                        <tr className="eb-bulk-table-header-row">
                          <th className="eb-bulk-th eb-bulk-th-rank">
                            <span className="eb-bulk-th-label">S.No</span>
                          </th>
                          <th className="eb-bulk-th">
                            <span className="eb-bulk-th-label">Construction Period</span>
                            <span className="eb-bulk-th-sub">(In-Months)</span>
                          </th>
                          <th className="eb-bulk-th">
                            <span className="eb-bulk-th-label">DLP Period</span>
                            <span className="eb-bulk-th-sub">(In-Months)</span>
                          </th>
                          <th className="eb-bulk-th eb-bulk-th-period">
                            <span className="eb-bulk-th-label">Total Period</span>
                            <span className="eb-bulk-th-sub">(Read-Only)</span>
                          </th>
                          <th className="eb-bulk-th eb-bulk-th-rate">
                            <span className="eb-bulk-th-label">Rate</span>
                            <span className="eb-bulk-th-sub">(Monthly)</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {formData.map((entry, index) => (
                          <tr key={index} className="eb-bulk-row">
                            <td className="eb-bulk-td eb-bulk-td-rank">
                              <span style={{ fontWeight: "500", color: "#2d3748" }}>{index + 1}.</span>
                            </td>

                            {/* During Construction Period */}
                            <td className="eb-bulk-td">
                              <div className="eb-bulk-input-wrapper">
                                <input
                                  className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_during_construction_period`] ? "eb-bulk-input-error" : ""}`}
                                  id={`during_construction_period_${index}`}
                                  name="during_construction_period"
                                  type="number"
                                  value={entry.during_construction_period}
                                  onChange={(e) => handleInputChange(e, index)}
                                  placeholder="0"
                                />
                                {errors[`${index}_during_construction_period`] && (
                                  <span className="eb-bulk-error-text">{errors[`${index}_during_construction_period`]}</span>
                                )}
                              </div>
                            </td>

                            {/* DLP / O&M Period */}
                            <td className="eb-bulk-td">
                              <div className="eb-bulk-input-wrapper">
                                <input
                                  className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_during_dlp_OM_period`] ? "eb-bulk-input-error" : ""}`}
                                  id={`during_dlp_OM_period_${index}`}
                                  name="during_dlp_OM_period"
                                  type="number"
                                  value={entry.during_dlp_OM_period}
                                  onChange={(e) => handleInputChange(e, index)}
                                  placeholder="0"
                                />
                                {errors[`${index}_during_dlp_OM_period`] && (
                                  <span className="eb-bulk-error-text">{errors[`${index}_during_dlp_OM_period`]}</span>
                                )}
                              </div>
                            </td>

                            {/* Total Months (Read-Only) */}
                            <td className="eb-bulk-td">
                              <div className="eb-bulk-input-wrapper">
                                <input
                                  className="eb-bulk-input eb-bulk-input-number"
                                  id={`num_of_months_${index}`}
                                  name="num_of_months"
                                  type="text"
                                  readOnly
                                  value={entry.num_of_months}
                                  style={{ background: "var(--eb-bulk-input-readonly-bg, #f0f0f0)", cursor: "not-allowed" }}
                                />
                              </div>
                            </td>

                            {/* Rate per Month */}
                            <td className="eb-bulk-td">
                              <div className="eb-bulk-input-wrapper">
                                <input
                                  className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_rate_per_month`] ? "eb-bulk-input-error" : ""}`}
                                  id={`rate_per_month_${index}`}
                                  name="rate_per_month"
                                  type="number"
                                  value={entry.rate_per_month}
                                  onChange={(e) => handleInputChange(e, index)}
                                  placeholder="₹ 0.00"
                                />
                                {errors[`${index}_rate_per_month`] && (
                                  <span className="eb-bulk-error-text">{errors[`${index}_rate_per_month`]}</span>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="eb-bulk-footer-actions">
                  <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="eb-bulk-btn eb-bulk-btn-submit"
                    disabled={loading}
                    onClick={handleSubmit}
                    style={{ background: "black" }}
                  >
                    {loading ? (
                      <span className="eb-bulk-btn-loader">
                        <span className="eb-bulk-spinner"></span>
                        Updating...
                      </span>
                    ) : (
                      <>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                          <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                        </svg>
                        Update
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </Modal.Body>

        ) : (

          /* ===== STEP 3: EOT Table ===== */
          <Modal.Body className="eb-bulk-modal-body">
            <div className="eb-bulk-container">
              <div className="eb-bulk-content">
                <div className="eb-bulk-actions" style={{ justifyContent: "space-between" }}>
                  <button
                    type="button"
                    className="eb-bulk-add-row-btn"
                    style={{ background: "#718096" }}
                    disabled={loading}
                    onClick={handleclOSEOT}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="15 18 9 12 15 6" />
                    </svg>
                    Back
                  </button>
                  <button
                    type="button"
                    className="eb-bulk-add-row-btn"
                    disabled={loading}
                    onClick={addNewEOT}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="8" x2="12" y2="16" />
                      <line x1="8" y1="12" x2="16" y2="12" />
                    </svg>
                    Add Another Revised EOT/COS
                  </button>
                </div>

                <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
                  {formData[0]?.eot_details?.map((_, detailIndex) => (
                    <div key={detailIndex} style={{ marginBottom: "24px" }}>
                      <h3 style={{ fontSize: "16px", fontWeight: "700", color: "#2d3748", marginBottom: "12px" }}>
                        EOT Round {detailIndex + 1}
                      </h3>
                      <div className="eb-bulk-table-wrapper">
                        <table className="eb-bulk-table">
                          <thead className="eb-bulk-table-head">
                            <tr className="eb-bulk-table-header-row">
                              <th className="eb-bulk-th"><span className="eb-bulk-th-label">CP</span></th>
                              <th className="eb-bulk-th"><span className="eb-bulk-th-label">DLP</span></th>
                              <th className="eb-bulk-th">
                                <span className="eb-bulk-th-label">T Month</span>
                                <span className="eb-bulk-th-sub">(Read-Only)</span>
                              </th>
                              <th className="eb-bulk-th"><span className="eb-bulk-th-label">Rate</span></th>
                              <th className="eb-bulk-th">
                                <span className="eb-bulk-th-label">Total Amount</span>
                                <span className="eb-bulk-th-sub">(Read-Only)</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {formData.map((entry, entryIndex) => (
                              <tr key={entryIndex} className="eb-bulk-row">
                                {/* CP */}
                                <td className="eb-bulk-td">
                                  <div className="eb-bulk-input-wrapper">

                                    <input
                                      type="number"
                                      className={`eb-bulk-input eb-bulk-input-number ${errors[`${entryIndex}_cp`] ? "eb-bulk-input-error" : ""}`}
                                      value={entry.eot_details[detailIndex]?.cp || 0}
                                      onChange={(e) => handleEOTChange(entryIndex, detailIndex, "cp", e.target.value)}
                                      placeholder="0"
                                    />
                                  </div>
                                </td>
                                {/* DLP */}
                                <td className="eb-bulk-td">
                                  <div className="eb-bulk-input-wrapper">

                                    <input
                                      type="number"
                                      className={`eb-bulk-input eb-bulk-input-number ${errors[`${entryIndex}_dlp`] ? "eb-bulk-input-error" : ""}`}
                                      value={entry.eot_details[detailIndex]?.dlp || 0}
                                      onChange={(e) => handleEOTChange(entryIndex, detailIndex, "dlp", e.target.value)}
                                      placeholder="0"
                                    />
                                  </div>
                                </td>
                                {/* T Month (Read-Only) */}
                                <td className="eb-bulk-td">
                                  <div className="eb-bulk-input-wrapper">

                                    <input
                                      type="number"
                                      className="eb-bulk-input eb-bulk-input-number"
                                      value={entry.eot_details[detailIndex]?.t_month || 0}
                                      disabled
                                      style={{ background: "var(--eb-bulk-input-readonly-bg, #f0f0f0)", cursor: "not-allowed" }}
                                    />
                                  </div>
                                </td>
                                {/* Rate */}
                                <td className="eb-bulk-td">
                                  <div className="eb-bulk-input-wrapper">

                                    <input
                                      type="number"
                                      className={`eb-bulk-input eb-bulk-input-number ${errors[`${entryIndex}_rate`] ? "eb-bulk-input-error" : ""}`}
                                      value={entry.eot_details[detailIndex]?.rate || 0}
                                      onChange={(e) => handleEOTChange(entryIndex, detailIndex, "rate", e.target.value)}
                                      placeholder="₹ 0.00"
                                    />
                                  </div>
                                </td>
                                {/* Total Amount (Read-Only) */}
                                <td className="eb-bulk-td eb-bulk-td-total">
                                  <div className="eb-bulk-input-wrapper">

                                    <span className="eb-bulk-total-value" style={{ minWidth: "80px" }}>
                                      {entry.eot_details[detailIndex]?.total_amount || 0}
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="eb-bulk-footer-actions">
                  <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="eb-bulk-btn eb-bulk-btn-submit"
                    disabled={loading}
                    onClick={handleSubmit}
                    style={{ background: "black" }}
                  >
                    {loading ? (
                      <span className="eb-bulk-btn-loader">
                        <span className="eb-bulk-spinner"></span>
                        Saving...
                      </span>
                    ) : (
                      <>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" />
                          <polyline points="17 21 17 13 7 13 7 21" />
                          <polyline points="7 3 7 8 15 8" />
                        </svg>
                        Save
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </Modal.Body>
        )}
      </Modal>
    </>
  );
}
const BulkUpdateReportsData = ({ boqReportsList, i, getData, id, value, getLogData }) => {

  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState([]);
  const [changeReason, setChangeReason] = useState("null");
  const [showChange, setShowChange] = useState(false);




  const createdAt = new Date().toISOString();

  useEffect(() => {
    if (!showChange) {
      setFormData((prevData) =>
        prevData.map((item) => ({
          ...item,
          random_value_of_changes: createdAt,
          change_by_emp_code: sessionStorage.getItem('sitemanagement_emp_code'),
          change_by_emp_name: sessionStorage.getItem('name'),

        }))
      );
    }

  }, [createdAt, showChange])




  useEffect(() => {
    if (changeReason !== "null") {
      setFormData((prevData) =>
        prevData.map((item) => ({
          ...item,
          reason_of_change: changeReason,

        }))
      );
    }
  }, [changeReason]);




  useEffect(() => {
    if (Array.isArray(boqReportsList)) {
      const initialData = boqReportsList.map((item) => ({
        description: "",
        num_of_reports: "",
        num_of_copies_per_report: "",
        rate_per_copy: "",
        project: id,
        random_value_of_changes: "",
        reason_of_change: changeReason !== "null" ? changeReason : "",
        change_by_emp_code: sessionStorage.getItem('sitemanagement_emp_code'),
        change_by_emp_name: sessionStorage.getItem('name'),
        revised: [{
          boqId: item.id,
          description: item.description,
          num_of_reports: "",
          num_of_copies_per_report: "",
          t_reports: "",
          rate_per_copy: "",
          total_amount: "",
        }],
      }));
      setFormData(initialData);
    }
  }, [boqReportsList]);






  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const [inputState, setInputState] = useState({});



  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => {
      const newFields = [...prevFormData];
      newFields[index] = {
        ...newFields[index],
        [name]: value,
      };
      return newFields;
    });
  }

  const handleShow = () => {
    setShow(true);
    setFormData(boqReportsList);
  }


  const handleChangeSubmit = () => {
    setShowChange(true);
  }
  const handleChangeback = () => {
    setShowChange(false);

  }



  const handleClose = () => {
    setShow(false);
    setShowChange(false);
    setShowEOT(false)
    setChangeReason("");
  }

  const [loading, setLoading] = useState(false); //loading logic

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

      try {
        let res = await axios.put(
          `${BASE_URL}/siteproject/bulkBOQReportsAndDocumentPrinting/`,
          formData
        );

        if (res.status === 200) {
          await getData();
          await getLogData();
          handleClose();
          toast.dismiss(loadingToastId); // Dismiss loading toast
          toast.success('Reports and Documents BOQ data updated successfully.')
          // window.location.reload();
        } else {
          alert(res);
        }
      } catch (err) {
        //toast Logic
        handleErrorToast(err, loadingToastId);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };
  const [showEOT, setShowEOT] = useState(false);
  const handleShowWOT = () => {
    setShowEOT(true)
  }
  const handleclOSEOT = () => {
    setShowEOT(false)
  }


  const addNewEOT = () => {
    setFormData((prevFormData) =>
      prevFormData.map((entry) => ({
        ...entry,
        revised: [
          ...(entry.revised || []),
          {
            boqId: entry.boqId || entry.id,
            num_of_reports: "",
            num_of_copies_per_report: "",
            t_reports: "",
            rate_per_copy: "",
            total_amount: "",
          },
        ],
      }))
    );
  };


  useEffect(() => {
    if (Array.isArray(boqReportsList)) {
      const initialData = boqReportsList.map((item) => ({
        description: "",
        num_of_reports: "",
        num_of_copies_per_report: "",
        rate_per_copy: "",
        project: id,
        random_value_of_changes: "",
        reason_of_change: changeReason !== "null" ? changeReason : "",
        change_by_emp_code: sessionStorage.getItem('sitemanagement_emp_code'),
        change_by_emp_name: sessionStorage.getItem('name'),
        revised: [{
          boqId: item.id,
          description: item.description,
          num_of_reports: "",
          num_of_copies_per_report: "",
          t_reports: "",
          rate_per_copy: "",
          total_amount: "",
        }],
      }));
      setFormData(initialData);
      setShowEOT(true); // ✅ show EOT table immediately

    }
  }, [boqReportsList]);



  const handleEOTChange = (entryIndex, detailIndex, field, value) => {
    setFormData((prevFormData) =>
      prevFormData.map((entry, i) => {
        if (i !== entryIndex) return entry;

        const updatedDetails = entry.revised.map((detail, j) => {
          if (j !== detailIndex) return detail;

          const updatedDetail = { ...detail, [field]: value };

          // Auto-calc t_month = cp + dlp
          const num_of_reports = parseFloat(updatedDetail.num_of_reports) || 0;
          const num_of_copies_per_report = parseFloat(updatedDetail.num_of_copies_per_report) || 0;
          updatedDetail.t_reports = num_of_reports * num_of_copies_per_report;

          // Auto-calc total_amount = t_month * rate
          const rate = parseFloat(updatedDetail.rate_per_copy) || 0;
          updatedDetail.total_amount = updatedDetail.t_reports * rate;

          return updatedDetail;
        });

        return { ...entry, revised: updatedDetails };
      })
    );
  };
  // return (
  //   <>
  //     <button title="Update RportData" className="upload-svg flex-row" onClick={handleShow}>
  //       <svg
  //         xmlns="http://www.w3.org/2000/svg"
  //         width="24"
  //         height="24"
  //         fill="white"
  //         viewBox="0 0 24 24"
  //         id="pen-new-square"
  //       >
  //         <path
  //           fill=""
  //           fill-rule="evenodd"
  //           d="M11.9426 1.25L13.5 1.25C13.9142 1.25 14.25 1.58579 14.25 2C14.25 2.41421 13.9142 2.75 13.5 2.75H12C9.62177 2.75 7.91356 2.75159 6.61358 2.92637C5.33517 3.09825 4.56445 3.42514 3.9948 3.9948C3.23505 4.75455 2.91245 5.86509 2.80417 8.03734C2.78355 8.45104 2.43146 8.76969 2.01776 8.74907C1.60406 8.72845 1.28541 8.37636 1.30603 7.96266C1.41642 5.74802 1.74641 4.12187 2.93414 2.93414C3.82895 2.03933 4.96897 1.63399 6.41371 1.43975C7.82519 1.24998 9.63423 1.24999 11.9426 1.25ZM22 9.75C22.4142 9.75 22.75 10.0858 22.75 10.5V12.0574C22.75 14.3658 22.75 16.1748 22.5603 17.5863C22.366 19.031 21.9607 20.1711 21.0659 21.0659C20.1711 21.9607 19.031 22.366 17.5863 22.5603C16.1748 22.75 14.3658 22.75 12.0574 22.75H11.9426C9.63423 22.75 7.82519 22.75 6.41371 22.5603C4.96897 22.366 3.82895 21.9607 2.93414 21.0659C2.03933 20.1711 1.63399 19.031 1.43975 17.5863C1.24998 16.1748 1.24999 14.3658 1.25 12.0574L1.25 12C1.25 11.5858 1.58579 11.25 2 11.25C2.41421 11.25 2.75 11.5858 2.75 12C2.75 14.3782 2.75159 16.0864 2.92637 17.3864C3.09825 18.6648 3.42514 19.4355 3.9948 20.0052C4.56445 20.5749 5.33517 20.9018 6.61358 21.0736C7.91356 21.2484 9.62177 21.25 12 21.25C14.3782 21.25 16.0864 21.2484 17.3864 21.0736C18.6648 20.9018 19.4355 20.5749 20.0052 20.0052C20.5749 19.4355 20.9018 18.6648 21.0736 17.3864C21.2484 16.0864 21.25 14.3782 21.25 12V10.5C21.25 10.0858 21.5858 9.75 22 9.75Z"
  //           clip-rule="evenodd"
  //         ></path>
  //         <path
  //           fill=""
  //           fill-rule="evenodd"
  //           d="M16.7705 2.27592C18.1384 0.908029 20.3562 0.908029 21.7241 2.27592C23.092 3.6438 23.092 5.86158 21.7241 7.22947L18.0928 10.8607C17.7999 11.1536 17.3251 11.1536 17.0322 10.8607C16.7393 10.5678 16.7393 10.093 17.0322 9.80006L19.1051 7.72709C18.5892 7.50519 17.9882 7.14946 17.4193 6.58065C16.8505 6.01185 16.4948 5.41082 16.2729 4.89486L11.2175 9.95026C10.801 10.3668 10.6376 10.532 10.4988 10.71C10.3274 10.9297 10.1804 11.1676 10.0605 11.4192C9.96337 11.623 9.88868 11.8429 9.7024 12.4017L9.27051 13.6974L10.3026 14.7295L11.5983 14.2976C12.1571 14.1113 12.377 14.0366 12.5808 13.9395C12.8324 13.8196 13.0703 13.6726 13.2901 13.5012C13.468 13.3624 13.6332 13.199 14.0497 12.7825C14.3426 12.4896 14.8175 12.4896 15.1104 12.7825C15.4033 13.0754 15.4033 13.5503 15.1104 13.8432L15.076 13.8776C14.7047 14.2489 14.4721 14.4815 14.2126 14.684C13.9069 14.9224 13.5761 15.1268 13.2261 15.2936C12.929 15.4352 12.6169 15.5392 12.1188 15.7052L9.21426 16.6734C8.67801 16.8521 8.0868 16.7126 7.68711 16.3129C7.28742 15.9132 7.14785 15.322 7.3266 14.7857L8.29477 11.8812C8.46079 11.3831 8.56479 11.071 8.7064 10.7739C8.87319 10.4239 9.07761 10.0931 9.31605 9.78742C9.51849 9.52787 9.7511 9.29529 10.1224 8.92401L16.7705 2.27592ZM17.4546 3.7132C17.4773 3.80906 17.509 3.92327 17.5532 4.05066C17.6965 4.46372 17.9677 5.00771 18.48 5.51999C18.9923 6.03227 19.5363 6.30346 19.9493 6.44677C20.0767 6.49097 20.1909 6.52273 20.2868 6.54543L20.6634 6.16881C21.4455 5.38671 21.4455 4.11867 20.6634 3.33658C19.8813 2.55448 18.6133 2.55448 17.8312 3.33658L17.4546 3.7132Z"
  //           clip-rule="evenodd"
  //         ></path>
  //       </svg>
  //       {" "} Update Reports & Doc
  //     </button>
  //     <Modal
  //       show={show}
  //       onHide={handleClose}
  //       dialogClassName={!showChange ? "request-leave" : "request-leave-document"}
  //     >
  //       <Modal.Header closeButton >
  //         <Modal.Title>Update Reports & Doc Data for BOQ</Modal.Title>

  //       </Modal.Header>
  //       {
  //         !showChange ?
  //           <Modal.Body>
  //             <div className="parent-div">
  //               <div className="bdy-div">
  //                 <div className="flex-column align-items-center">
  //                   <label className="form-labels font-weight500 font-size-subheading" title="Invoice Number">
  //                     Reason for Change BOQ<span className="required">*</span>
  //                   </label>
  //                   <input
  //                     type="text"
  //                     name="changeReason"
  //                     title="Reason for Change BOQ"
  //                     placeholder="Example- Revise EOT"
  //                     onChange={(e) => setChangeReason(e.target.value)}
  //                     className={`form-input ${errors.changeReason ? "is-invalid" : ""
  //                       }`}
  //                   />
  //                 </div>
  //                 <div className="button-models">
  //                   <button
  //                     className="model-button-cancel model-button font-weight500"
  //                     onClick={handleClose}
  //                   >
  //                     Cancel
  //                   </button>
  //                   {(changeReason !== "null" && changeReason !== "") && (
  //                     <button
  //                       type="submit"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleChangeSubmit}
  //                     >
  //                       Next
  //                     </button>
  //                   )}

  //                 </div>

  //               </div>
  //             </div>
  //             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

  //           </Modal.Body>
  //           : showEOT === false ?

  //             <Modal.Body>
  //               <div className="parent-div">
  //                 <div className="bdy-div">
  //                   <div className='flex-row justify-between'>
  //                     <button
  //                       type="button"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleChangeback}
  //                     >
  //                       Back
  //                     </button>
  //                     <button
  //                       type="button"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleShowWOT}
  //                     >
  //                       <AddwithWhiteCircle /> Add Revised EOT/COS
  //                     </button>
  //                   </div>
  //                   <div className="flex-row justify-center">
  //                     <table className="table-css ">
  //                       <thead className="table-heading">
  //                         <tr className="custom-table-head-tr width-10vw">
  //                           <th className="table-heading-text text-left-sr" >S no.</th>
  //                           <th className="table-heading-text text-center">Description <br /> <span className="required">(Read-Only)</span></th>
  //                           <th className="table-heading-text text-center">Number of Reports</th>
  //                           <th className="table-heading-text text-center">Number of Copies/Report</th>
  //                           <th className="table-heading-text text-center">Total Copies <br /> <span className="required">(Read-Only)</span></th>
  //                           <th className="table-heading-text text-center">Rate  <br /> <span className="required">(Monthly-Rate)</span></th>
  //                         </tr>
  //                       </thead>


  //                       <tbody>

  //                         {formData.map((entry, index) => (
  //                           <tr key={index} className="custom-table-head-td ">

  //                             <td className="align-left width-5vw" >
  //                               {index + 1}
  //                             </td>
  //                             <td>
  //                               <div title="Description" className="flex-column align-items-center align-items-center">
  //                                 <textarea
  //                                   className={`form-input-textarea width-15vw ${errors[`${index}_description`] ? "error" : ""}`}
  //                                   id={`description_${index}`}
  //                                   name="description"
  //                                   type="text"
  //                                   value={entry.description}
  //                                   onChange={(e) => handleInputChange(e, index)}

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_description`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_description`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>
  //                             <td>
  //                               <div title="Number of Reports" className="flex-column align-items-center align-items-center">
  //                                 <input
  //                                   className={`form-input width-15vw ${errors[`${index}_num_of_reports`] ? "error" : ""}`}
  //                                   id={`num_of_reports_${index}`}
  //                                   name="num_of_reports"
  //                                   type="number"
  //                                   value={entry.num_of_reports}
  //                                   onChange={(e) => handleInputChange(e, index)}

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_num_of_reports`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_num_of_reports`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>
  //                             <td>
  //                               <div title="Number of Copies/Report" className="flex-column align-items-center align-items-center">
  //                                 <input
  //                                   className={`form-input-date  width-5vw  ${errors[`${index}_num_of_copies_per_report`] ? "error" : ""}`}
  //                                   id={`num_of_copies_per_report_${index}`}
  //                                   name="num_of_copies_per_report"
  //                                   type="number"
  //                                   value={entry.num_of_copies_per_report}
  //                                   onChange={(e) => handleInputChange(e, index)}

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_num_of_copies_per_report`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_num_of_copies_per_report`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>
  //                             <td>
  //                               <div title="Total Number of Copies" className="flex-column align-items-center align-items-center">
  //                                 <input
  //                                   className={`form-input-date  width-5vw  ${errors[`${index}_num_of_months`] ? "error" : ""}`}
  //                                   id={`num_of_months_${index}`}
  //                                   name="num_of_months"
  //                                   type="text"
  //                                   value={Number(entry.num_of_reports || 0) * Number(entry.num_of_copies_per_report || 0)} // Calculate and display the sum
  //                                   onChange={(e) => handleInputChange(e, index)}

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_num_of_months`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_num_of_months`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>
  //                             <td>
  //                               <div title="Rate Per Copy" className="flex-column align-items-center align-items-center">
  //                                 <input
  //                                   className={`form-input-date  width-5vw  ${errors[`${index}_rate_per_copy`] ? "error" : ""}`}
  //                                   id={`rate_per_copy_${index}`}
  //                                   name="rate_per_copy"
  //                                   type="number"
  //                                   value={entry.rate_per_copy}
  //                                   onChange={(e) => handleInputChange(e, index)}

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_rate_per_copy`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_rate_per_copy`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>


  //                           </tr>
  //                         ))}

  //                       </tbody>

  //                     </table>
  //                   </div>
  //                   <div className="button-models">
  //                     <button
  //                       className="model-button-cancel model-button font-weight500"
  //                       onClick={handleClose}
  //                     >
  //                       Cancel
  //                     </button>
  //                     <button
  //                       type="submit"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleSubmit}
  //                     >
  //                       Update
  //                     </button>
  //                   </div>

  //                 </div>
  //               </div>
  //               <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

  //             </Modal.Body> : showEOT === true ?
  //               <Modal.Body>
  //                 <div className="parent-div">
  //                   <div className="bdy-div">
  //                     <div className='flex-row justify-between'>
  //                       <button
  //                         type="button"
  //                         className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                         disabled={loading}
  //                         onClick={handleclOSEOT}
  //                       >
  //                         Back
  //                       </button>
  //                       <button
  //                         type="button"
  //                         className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                         disabled={loading}
  //                         onClick={addNewEOT}
  //                       >
  //                         <AddwithWhiteCircle /> Add Another Revised EOT/COS
  //                       </button>
  //                     </div>
  //                     {formData[0]?.revised?.map((_, detailIndex) => (
  //                       <div key={detailIndex}>
  //                         <h3>EOT Round {detailIndex + 1}</h3>
  //                         <table className="nested-table-lightblue width-90vw payment">

  //                           <thead>
  //                             <tr>
  //                               <th>Descritption</th>
  //                               <th>No. of Reports</th>
  //                               <th>No. of Copies</th>
  //                               <th>T Copies</th>
  //                               <th>Rate per Copy</th>
  //                               <th>Total Amount</th>
  //                             </tr>
  //                           </thead>
  //                           <tbody>
  //                             {formData.map((entry, entryIndex) => (
  //                               <tr key={entryIndex}>
  //                                 <td>{entry.description}</td>
  //                                 <td>
  //                                   <input
  //                                     type="number"
  //                                     className={`form-input-date  width-5vw  ${errors[`${entryIndex}_num_of_reports`] ? "error" : ""}`}

  //                                     value={entry.revised[detailIndex]?.num_of_reports || ""}
  //                                     onChange={(e) =>
  //                                       handleEOTChange(entryIndex, detailIndex, "num_of_reports", e.target.value)
  //                                     }
  //                                   />
  //                                 </td>
  //                                 <td>
  //                                   <input
  //                                     type="number"
  //                                     className={`form-input-date  width-5vw  ${errors[`${entryIndex}_num_of_copies_per_report`] ? "error" : ""}`}

  //                                     value={entry.revised[detailIndex]?.num_of_copies_per_report || ""}
  //                                     onChange={(e) =>
  //                                       handleEOTChange(entryIndex, detailIndex, "num_of_copies_per_report", e.target.value)
  //                                     }
  //                                   />
  //                                 </td>
  //                                 <td>
  //                                   <input
  //                                     type="number"
  //                                     value={entry.revised[detailIndex]?.t_reports || ""}
  //                                     className={`form-input-date  width-5vw  ${errors[`${entryIndex}_t_reports`] ? "error" : ""}`}
  //                                     disabled
  //                                     onChange={(e) =>
  //                                       handleEOTChange(
  //                                         entryIndex,
  //                                         detailIndex,
  //                                         "t_month",
  //                                         e.target.value
  //                                       )
  //                                     }
  //                                   />
  //                                 </td>
  //                                 <td>
  //                                   <input
  //                                     type="number"
  //                                     value={entry.revised[detailIndex]?.rate_per_copy || ""}
  //                                     onChange={(e) =>
  //                                       handleEOTChange(entryIndex, detailIndex, "rate_per_copy", e.target.value)
  //                                     }
  //                                     className={`form-input-date  width-5vw  ${errors[`${entryIndex}_rate_per_copy`] ? "error" : ""}`}

  //                                   />
  //                                 </td>
  //                                 <td>
  //                                   <input
  //                                     type="number"
  //                                     className={`form-input-date  width-5vw  ${errors[`${entryIndex}_total_amount`] ? "error" : ""}`}
  //                                     disabled
  //                                     value={entry.revised[detailIndex]?.total_amount || ""}
  //                                     onChange={(e) =>
  //                                       handleEOTChange(
  //                                         entryIndex,
  //                                         detailIndex,
  //                                         "total_amount",
  //                                         e.target.value
  //                                       )
  //                                     }
  //                                   />
  //                                 </td>
  //                               </tr>
  //                             ))}
  //                           </tbody>
  //                         </table>
  //                       </div>
  //                     ))}

  //                     <div className="button-models">
  //                       <button
  //                         className="model-button-cancel model-button font-weight500"
  //                         onClick={handleClose}
  //                       >
  //                         Cancel
  //                       </button>
  //                       <button
  //                         type="submit"
  //                         className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                         disabled={loading}
  //                         onClick={handleSubmit}
  //                       >
  //                         Save
  //                       </button>
  //                     </div>

  //                   </div>
  //                 </div>
  //                 <ToastContainer
  //                   position="top-center"
  //                   autoClose={1000}
  //                   hideProgressBar={false}
  //                   newestOnTop={true}
  //                   closeOnClick
  //                   rtl={false}
  //                   pauseOnFocusLoss
  //                   draggable
  //                   pauseOnHover
  //                 />
  //               </Modal.Body > : ""
  //       }
  //     </Modal >
  //   </>
  // )
  return (
    <>
      <button
        title="Update Reports & Doc"
        className="eb-bulk-trigger-btn"
        onClick={handleShow}
        style={{ background: "black" }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="white"
          viewBox="0 0 24 24"
          id="pen-new-square"
        >
          <path fillRule="evenodd" d="M11.9426 1.25L13.5 1.25C13.9142 1.25 14.25 1.58579 14.25 2C14.25 2.41421 13.9142 2.75 13.5 2.75H12C9.62177 2.75 7.91356 2.75159 6.61358 2.92637C5.33517 3.09825 4.56445 3.42514 3.9948 3.9948C3.23505 4.75455 2.91245 5.86509 2.80417 8.03734C2.78355 8.45104 2.43146 8.76969 2.01776 8.74907C1.60406 8.72845 1.28541 8.37636 1.30603 7.96266C1.41642 5.74802 1.74641 4.12187 2.93414 2.93414C3.82895 2.03933 4.96897 1.63399 6.41371 1.43975C7.82519 1.24998 9.63423 1.24999 11.9426 1.25ZM22 9.75C22.4142 9.75 22.75 10.0858 22.75 10.5V12.0574C22.75 14.3658 22.75 16.1748 22.5603 17.5863C22.366 19.031 21.9607 20.1711 21.0659 21.0659C20.1711 21.9607 19.031 22.366 17.5863 22.5603C16.1748 22.75 14.3658 22.75 12.0574 22.75H11.9426C9.63423 22.75 7.82519 22.75 6.41371 22.5603C4.96897 22.366 3.82895 21.9607 2.93414 21.0659C2.03933 20.1711 1.63399 19.031 1.43975 17.5863C1.24998 16.1748 1.24999 14.3658 1.25 12.0574L1.25 12C1.25 11.5858 1.58579 11.25 2 11.25C2.41421 11.25 2.75 11.5858 2.75 12C2.75 14.3782 2.75159 16.0864 2.92637 17.3864C3.09825 18.6648 3.42514 19.4355 3.9948 20.0052C4.56445 20.5749 5.33517 20.9018 6.61358 21.0736C7.91356 21.2484 9.62177 21.25 12 21.25C14.3782 21.25 16.0864 21.2484 17.3864 21.0736C18.6648 20.9018 19.4355 20.5749 20.0052 20.0052C20.5749 19.4355 20.9018 18.6648 21.0736 17.3864C21.2484 16.0864 21.25 14.3782 21.25 12V10.5C21.25 10.0858 21.5858 9.75 22 9.75Z" clipRule="evenodd" />
          <path fillRule="evenodd" d="M16.7705 2.27592C18.1384 0.908029 20.3562 0.908029 21.7241 2.27592C23.092 3.6438 23.092 5.86158 21.7241 7.22947L18.0928 10.8607C17.7999 11.1536 17.3251 11.1536 17.0322 10.8607C16.7393 10.5678 16.7393 10.093 17.0322 9.80006L19.1051 7.72709C18.5892 7.50519 17.9882 7.14946 17.4193 6.58065C16.8505 6.01185 16.4948 5.41082 16.2729 4.89486L11.2175 9.95026C10.801 10.3668 10.6376 10.532 10.4988 10.71C10.3274 10.9297 10.1804 11.1676 10.0605 11.4192C9.96337 11.623 9.88868 11.8429 9.7024 12.4017L9.27051 13.6974L10.3026 14.7295L11.5983 14.2976C12.1571 14.1113 12.377 14.0366 12.5808 13.9395C12.8324 13.8196 13.0703 13.6726 13.2901 13.5012C13.468 13.3624 13.6332 13.199 14.0497 12.7825C14.3426 12.4896 14.8175 12.4896 15.1104 12.7825C15.4033 13.0754 15.4033 13.5503 15.1104 13.8432L15.076 13.8776C14.7047 14.2489 14.4721 14.4815 14.2126 14.684C13.9069 14.9224 13.5761 15.1268 13.2261 15.2936C12.929 15.4352 12.6169 15.5392 12.1188 15.7052L9.21426 16.6734C8.67801 16.8521 8.0868 16.7126 7.68711 16.3129C7.28742 15.9132 7.14785 15.322 7.3266 14.7857L8.29477 11.8812C8.46079 11.3831 8.56479 11.071 8.7064 10.7739C8.87319 10.4239 9.07761 10.0931 9.31605 9.78742C9.51849 9.52787 9.7511 9.29529 10.1224 8.92401L16.7705 2.27592ZM17.4546 3.7132C17.4773 3.80906 17.509 3.92327 17.5532 4.05066C17.6965 4.46372 17.9677 5.00771 18.48 5.51999C18.9923 6.03227 19.5363 6.30346 19.9493 6.44677C20.0767 6.49097 20.1909 6.52273 20.2868 6.54543L20.6634 6.16881C21.4455 5.38671 21.4455 4.11867 20.6634 3.33658C19.8813 2.55448 18.6133 2.55448 17.8312 3.33658L17.4546 3.7132Z" clipRule="evenodd" />
        </svg>
        Update Reports & Doc
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName={!showChange ? "eb-bulk-modal request-leave" : "max-heightModal eb-bulk-modal model-width90vw"}
      >
        <Modal.Header className="eb-bulk-modal-header">
          <Modal.Title className="eb-bulk-modal-title">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
              <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
            </svg>
            Update Reports & Doc Data for BOQ
            <button
              className="close-btn"
              onClick={handleClose}
              style={{ marginLeft: "auto", background: "none", border: "none", color: "white", fontSize: "24px", cursor: "pointer" }}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </Modal.Title>
        </Modal.Header>

        {!showChange ? (

          /* ===== STEP 1: Reason for Change ===== */
          <Modal.Body className="eb-bulk-modal-body">
            <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
              <div className="eb-bulk-content">
                <div className="eb-bulk-reason-section" style={{ padding: "20px", background: "#f7fafc", borderRadius: "12px" }}>
                  <label className="eb-bulk-label" style={{ display: "block", fontWeight: "600", marginBottom: "8px", color: "#2d3748" }}>
                    Reason for Change BOQ <span className="eb-bulk-required">*</span>
                  </label>
                  <input
                    type="text"
                    name="changeReason"
                    title="Reason for Change BOQ"
                    placeholder="Example- Revise EOT"
                    onChange={(e) => setChangeReason(e.target.value)}
                    className="eb-bulk-input"
                    style={{ width: "90%", padding: "12px 16px", fontSize: "14px" }}
                  />
                </div>
                <div className="eb-bulk-footer-actions" style={{ justifyContent: "flex-end" }}>
                  <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                    Cancel
                  </button>
                  {(changeReason !== "null" && changeReason !== "") && (
                    <button
                      type="submit"
                      className="eb-bulk-btn eb-bulk-btn-submit"
                      disabled={loading}
                      onClick={handleChangeSubmit}
                      style={{ background: "black" }}
                    >
                      Next
                    </button>
                  )}
                </div>
              </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </Modal.Body>

        ) : showEOT === false ? (

          /* ===== STEP 2: Main Table ===== */
          <Modal.Body className="eb-bulk-modal-body">
            <div className="eb-bulk-table-scroll table-box scroll-container-table" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
              <div className="eb-bulk-content">
                <div className="eb-bulk-actions" style={{ justifyContent: "space-between" }}>
                  <button
                    type="button"
                    className="eb-bulk-add-row-btn"
                    style={{ background: "#718096" }}
                    disabled={loading}
                    onClick={handleChangeback}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="15 18 9 12 15 6" />
                    </svg>
                    Back
                  </button>
                  <button
                    type="button"
                    className="eb-bulk-add-row-btn"
                    disabled={loading}
                    onClick={handleShowWOT}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="8" x2="12" y2="16" />
                      <line x1="8" y1="12" x2="16" y2="12" />
                    </svg>
                    Add Revised EOT/COS
                  </button>
                </div>

                <div className="eb-bulk-table-wrapper">
                  <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "40vh", minHeight: "40vh" }}>
                    <table className="eb-bulk-table">
                      <thead className="eb-bulk-table-head">
                        <tr className="eb-bulk-table-header-row">
                          <th className="eb-bulk-th eb-bulk-th-rank">
                            <span className="eb-bulk-th-label">S.No</span>
                          </th>
                          <th className="eb-bulk-th">
                            <span className="eb-bulk-th-label">Description</span>
                            <span className="eb-bulk-th-sub">(Read-Only)</span>
                          </th>
                          <th className="eb-bulk-th">
                            <span className="eb-bulk-th-label">No. of Reports</span>
                          </th>
                          <th className="eb-bulk-th">
                            <span className="eb-bulk-th-label">No. of Copies/Report</span>
                          </th>
                          <th className="eb-bulk-th">
                            <span className="eb-bulk-th-label">Total Copies</span>
                            <span className="eb-bulk-th-sub">(Read-Only)</span>
                          </th>
                          <th className="eb-bulk-th eb-bulk-th-rate">
                            <span className="eb-bulk-th-label">Rate</span>
                            <span className="eb-bulk-th-sub">(Monthly-Rate)</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {formData.map((entry, index) => (
                          <tr key={index} className="eb-bulk-row">

                            {/* S.No */}
                            <td className="eb-bulk-td eb-bulk-td-rank">
                              <span style={{ fontWeight: "500", color: "#2d3748" }}>{index + 1}.</span>
                            </td>

                            {/* Description */}
                            <td className="eb-bulk-td">
                              <div className="eb-bulk-input-wrapper">
                                <textarea
                                  className={`eb-bulk-input ${errors[`${index}_description`] ? "eb-bulk-input-error" : ""}`}
                                  id={`description_${index}`}
                                  name="description"
                                  disabled
                                  value={entry.description}
                                  onChange={(e) => handleInputChange(e, index)}
                                  rows={2}
                                />
                                {errors[`${index}_description`] && (
                                  <span className="eb-bulk-error-text">{errors[`${index}_description`]}</span>
                                )}
                              </div>
                            </td>

                            {/* No. of Reports */}
                            <td className="eb-bulk-td">
                              <div className="eb-bulk-input-wrapper">
                                <input
                                  className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_num_of_reports`] ? "eb-bulk-input-error" : ""}`}
                                  id={`num_of_reports_${index}`}
                                  name="num_of_reports"
                                  type="number"
                                  value={entry.num_of_reports}
                                  onChange={(e) => handleInputChange(e, index)}
                                  placeholder="0"
                                />
                                {errors[`${index}_num_of_reports`] && (
                                  <span className="eb-bulk-error-text">{errors[`${index}_num_of_reports`]}</span>
                                )}
                              </div>
                            </td>

                            {/* No. of Copies per Report */}
                            <td className="eb-bulk-td">
                              <div className="eb-bulk-input-wrapper">
                                <input
                                  className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_num_of_copies_per_report`] ? "eb-bulk-input-error" : ""}`}
                                  id={`num_of_copies_per_report_${index}`}
                                  name="num_of_copies_per_report"
                                  type="number"
                                  value={entry.num_of_copies_per_report}
                                  onChange={(e) => handleInputChange(e, index)}
                                  placeholder="0"
                                />
                                {errors[`${index}_num_of_copies_per_report`] && (
                                  <span className="eb-bulk-error-text">{errors[`${index}_num_of_copies_per_report`]}</span>
                                )}
                              </div>
                            </td>

                            {/* Total Copies (Read-Only) */}
                            <td className="eb-bulk-td">
                              <div className="eb-bulk-input-wrapper">
                                <input
                                  className="eb-bulk-input eb-bulk-input-number"
                                  id={`num_of_months_${index}`}
                                  name="num_of_months"
                                  type="text"
                                  readOnly
                                  value={Number(entry.num_of_reports || 0) * Number(entry.num_of_copies_per_report || 0)}
                                  style={{ background: "var(--eb-bulk-input-readonly-bg, #f0f0f0)", cursor: "not-allowed" }}
                                />
                              </div>
                            </td>

                            {/* Rate per Copy */}
                            <td className="eb-bulk-td">
                              <div className="eb-bulk-input-wrapper">
                                <input
                                  className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_rate_per_copy`] ? "eb-bulk-input-error" : ""}`}
                                  id={`rate_per_copy_${index}`}
                                  name="rate_per_copy"
                                  type="number"
                                  value={entry.rate_per_copy}
                                  onChange={(e) => handleInputChange(e, index)}
                                  placeholder="₹ 0.00"
                                />
                                {errors[`${index}_rate_per_copy`] && (
                                  <span className="eb-bulk-error-text">{errors[`${index}_rate_per_copy`]}</span>
                                )}
                              </div>
                            </td>

                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="eb-bulk-footer-actions">
                  <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="eb-bulk-btn eb-bulk-btn-submit"
                    disabled={loading}
                    onClick={handleSubmit}
                    style={{ background: "black" }}
                  >
                    {loading ? (
                      <span className="eb-bulk-btn-loader">
                        <span className="eb-bulk-spinner"></span>
                        Updating...
                      </span>
                    ) : (
                      <>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                          <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                        </svg>
                        Update
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </Modal.Body>

        ) : (

          /* ===== STEP 3: EOT Table ===== */
          <Modal.Body className="eb-bulk-modal-body">
            <div className="eb-bulk-container">
              <div className="eb-bulk-content">
                <div className="eb-bulk-actions" style={{ justifyContent: "space-between" }}>
                  <button
                    type="button"
                    className="eb-bulk-add-row-btn"
                    style={{ background: "#718096" }}
                    disabled={loading}
                    onClick={handleclOSEOT}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="15 18 9 12 15 6" />
                    </svg>
                    Back
                  </button>
                  <button
                    type="button"
                    className="eb-bulk-add-row-btn"
                    disabled={loading}
                    onClick={addNewEOT}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="8" x2="12" y2="16" />
                      <line x1="8" y1="12" x2="16" y2="12" />
                    </svg>
                    Add Another Revised EOT/COS
                  </button>
                </div>

                <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
                  {formData[0]?.revised?.map((_, detailIndex) => (
                    <div key={detailIndex} style={{ marginBottom: "24px" }}>
                      <h3 style={{ fontSize: "16px", fontWeight: "700", color: "#2d3748", marginBottom: "12px" }}>
                        EOT Round {detailIndex + 1}
                      </h3>
                      <div className="eb-bulk-table-wrapper">
                        <table className="eb-bulk-table">
                          <thead className="eb-bulk-table-head">
                            <tr className="eb-bulk-table-header-row">
                              <th className="eb-bulk-th"><span className="eb-bulk-th-label">Description</span></th>
                              <th className="eb-bulk-th"><span className="eb-bulk-th-label">No. of Reports</span></th>
                              <th className="eb-bulk-th"><span className="eb-bulk-th-label">No. of Copies</span></th>
                              <th className="eb-bulk-th">
                                <span className="eb-bulk-th-label">T Copies</span>
                                <span className="eb-bulk-th-sub">(Read-Only)</span>
                              </th>
                              <th className="eb-bulk-th"><span className="eb-bulk-th-label">Rate per Copy</span></th>
                              <th className="eb-bulk-th">
                                <span className="eb-bulk-th-label">Total Amount</span>
                                <span className="eb-bulk-th-sub">(Read-Only)</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {formData.map((entry, entryIndex) => (
                              <tr key={entryIndex} className="eb-bulk-row">

                                {/* Description (Read-Only) */}
                                <td className="eb-bulk-td">
                                  <span style={{ fontSize: "13px", color: "black" }}>{entry.description}</span>
                                </td>

                                {/* No. of Reports */}
                                <td className="eb-bulk-td">
                                  <div className="eb-bulk-input-wrapper">
                                    <input
                                      type="number"
                                      className={`eb-bulk-input eb-bulk-input-number ${errors[`${entryIndex}_num_of_reports`] ? "eb-bulk-input-error" : ""}`}
                                      value={entry.revised[detailIndex]?.num_of_reports || ""}
                                      onChange={(e) => handleEOTChange(entryIndex, detailIndex, "num_of_reports", e.target.value)}
                                      placeholder="0"
                                    />
                                  </div>
                                </td>

                                {/* No. of Copies */}
                                <td className="eb-bulk-td">
                                  <div className="eb-bulk-input-wrapper">
                                    <input
                                      type="number"
                                      className={`eb-bulk-input eb-bulk-input-number ${errors[`${entryIndex}_num_of_copies_per_report`] ? "eb-bulk-input-error" : ""}`}
                                      value={entry.revised[detailIndex]?.num_of_copies_per_report || ""}
                                      onChange={(e) => handleEOTChange(entryIndex, detailIndex, "num_of_copies_per_report", e.target.value)}
                                      placeholder="0"
                                    />
                                  </div>

                                </td>

                                {/* T Copies (Read-Only) */}
                                <td className="eb-bulk-td">
                                  <div className="eb-bulk-input-wrapper">
                                    <input
                                      type="number"
                                      className="eb-bulk-input eb-bulk-input-number"
                                      value={entry.revised[detailIndex]?.t_reports || ""}
                                      disabled
                                      style={{ background: "var(--eb-bulk-input-readonly-bg, #f0f0f0)", cursor: "not-allowed" }}
                                    />
                                  </div>
                                </td>

                                {/* Rate per Copy */}
                                <td className="eb-bulk-td">
                                  <div className="eb-bulk-input-wrapper">
                                    <input
                                      type="number"
                                      className={`eb-bulk-input eb-bulk-input-number ${errors[`${entryIndex}_rate_per_copy`] ? "eb-bulk-input-error" : ""}`}
                                      value={entry.revised[detailIndex]?.rate_per_copy || ""}
                                      onChange={(e) => handleEOTChange(entryIndex, detailIndex, "rate_per_copy", e.target.value)}
                                      placeholder="₹ 0.00"
                                    />
                                  </div>
                                </td>

                                {/* Total Amount (Read-Only) */}
                                <td className="eb-bulk-td eb-bulk-td-total">
                                  <div className="eb-bulk-input-wrapper">
                                    <span className="eb-bulk-total-value" style={{ minWidth: "80px" }}>
                                      {entry.revised[detailIndex]?.total_amount || 0}
                                    </span>
                                  </div>
                                </td>

                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="eb-bulk-footer-actions">
                  <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="eb-bulk-btn eb-bulk-btn-submit"
                    disabled={loading}
                    onClick={handleSubmit}
                    style={{ background: "black" }}
                  >
                    {loading ? (
                      <span className="eb-bulk-btn-loader">
                        <span className="eb-bulk-spinner"></span>
                        Saving...
                      </span>
                    ) : (
                      <>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" />
                          <polyline points="17 21 17 13 7 13 7 21" />
                          <polyline points="7 3 7 8 15 8" />
                        </svg>
                        Save
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </Modal.Body>
        )}
      </Modal>
    </>
  );
}

const BulkUpdateRoadSurveyData = ({ boqSurveyList, i, getData, id, value, getLogData }) => {

  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState([]);
  const [changeReason, setChangeReason] = useState("null");
  const [showChange, setShowChange] = useState(false);




  const createdAt = new Date().toISOString();

  useEffect(() => {
    if (!showChange) {
      setFormData((prevData) =>
        prevData.map((item) => ({
          ...item,
          random_value_of_changes: createdAt,
          change_by_emp_code: sessionStorage.getItem('sitemanagement_emp_code'),
          change_by_emp_name: sessionStorage.getItem('name'),
        }))
      );
    }

  }, [createdAt, showChange])

  useEffect(() => {
    if (changeReason !== "null") {
      setFormData((prevData) =>
        prevData.map((item) => ({
          ...item,
          reason_of_change: changeReason,
        }))
      );
    }
  }, [changeReason]);



  useEffect(() => {
    if (Array.isArray(boqSurveyList)) {
      const initialData = boqSurveyList.map((item) => ({
        rate_per_km_times: "",
        description: "",
        project: id,
        num_of_times_survey_concluded: "",
        designation_name: "",
        KM: "",
        reason_of_change: changeReason !== "null" ? changeReason : "",
        change_by_emp_code: sessionStorage.getItem('sitemanagement_emp_code'),
        change_by_emp_name: sessionStorage.getItem('name'),
        eot_details: [{
          boqId: item.id,
          description: item.description,
          KM: item.KM,
          num_of_times_survey_concluded: "",
          rate_per_km_times: "",
          total_amount: "",
        }],
      }));
      setFormData(initialData);
    }
  }, [boqSurveyList]);






  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const [inputState, setInputState] = useState({});



  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => {
      const newFields = [...prevFormData];
      newFields[index] = {
        ...newFields[index],
        [name]: value,
      };
      return newFields;
    });
  }

  const handleShow = () => {
    setShow(true);
    setFormData(boqSurveyList);
  }


  const handleChangeSubmit = () => {
    setShowChange(true);
  }
  const handleChangeback = () => {
    setShowChange(false);

  }


  const handleClose = () => {
    setShow(false);
    setShowChange(false);
    setShowEOT(false)
    setChangeReason("");
  }

  const [loading, setLoading] = useState(false); //loading logic

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

      try {
        let res = await axios.put(
          `${BASE_URL}/siteproject/bulkBOQRoadSurveyEquipment/`,
          formData
        );

        if (res.status === 200) {
          await getData();
          await getLogData();
          handleClose();
          toast.dismiss(loadingToastId); // Dismiss loading toast
          toast.success('Road Survey BOQ data updated successfully.')
          // window.location.reload();
        } else {
          alert(res);
        }
      } catch (err) {
        //toast Logic
        handleErrorToast(err, loadingToastId);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  const [showEOT, setShowEOT] = useState(false);
  const handleShowWOT = () => {
    setShowEOT(true)
  }
  const handleclOSEOT = () => {
    setShowEOT(false)
  }


  const addNewEOT = () => {
    setFormData((prevFormData) =>
      prevFormData.map((entry) => ({
        ...entry,
        eot_details: [
          ...(entry.eot_details || []),
          {
            boqId: entry.boqId || entry.id,
            KM: entry.KM,
            num_of_times_survey_concluded: "",
            rate_per_km_times: "",
            total_amount: "",
          },
        ],
      }))
    );
  };

  useEffect(() => {
    if (Array.isArray(boqSurveyList)) {
      const initialData = boqSurveyList.map((item) => ({
        rate_per_km_times: "",
        description: "",
        project: id,
        num_of_times_survey_concluded: "",
        designation_name: "",
        KM: "",
        reason_of_change: changeReason !== "null" ? changeReason : "",
        change_by_emp_code: sessionStorage.getItem('sitemanagement_emp_code'),
        change_by_emp_name: sessionStorage.getItem('name'),
        eot_details: [{
          boqId: item.id,
          description: item.description,
          KM: item.KM,
          num_of_times_survey_concluded: "",
          rate_per_km_times: "",
          total_amount: "",
        }],
      }));
      setFormData(initialData);
      setShowEOT(true); // ✅ show EOT table immediately

    }
  }, [boqSurveyList]);



  const handleEOTChange = (entryIndex, detailIndex, field, value) => {
    setFormData((prevFormData) =>
      prevFormData.map((entry, i) => {
        if (i !== entryIndex) return entry;

        const updatedDetails = entry.eot_details.map((detail, j) => {
          if (j !== detailIndex) return detail;

          const updatedDetail = { ...detail, [field]: value };

          // Auto-calc t_month = cp + dlp
          const KM = parseFloat(updatedDetail.KM) || 0;
          const num_of_times_survey_concluded = parseFloat(updatedDetail.num_of_times_survey_concluded) || 0;

          // Auto-calc total_amount = t_month * rate
          const rate = parseFloat(updatedDetail.rate_per_km_times) || 0;
          updatedDetail.total_amount = KM * num_of_times_survey_concluded * rate;

          return updatedDetail;
        });

        return { ...entry, eot_details: updatedDetails };
      })
    );
  };
  // return (
  //   <>
  //     <button title="Update Road Survey" className="upload-svg flex-row" onClick={handleShow}>
  //       <svg
  //         xmlns="http://www.w3.org/2000/svg"
  //         width="24"
  //         height="24"
  //         fill="white"
  //         viewBox="0 0 24 24"
  //         id="pen-new-square"
  //       >
  //         <path
  //           fill=""
  //           fill-rule="evenodd"
  //           d="M11.9426 1.25L13.5 1.25C13.9142 1.25 14.25 1.58579 14.25 2C14.25 2.41421 13.9142 2.75 13.5 2.75H12C9.62177 2.75 7.91356 2.75159 6.61358 2.92637C5.33517 3.09825 4.56445 3.42514 3.9948 3.9948C3.23505 4.75455 2.91245 5.86509 2.80417 8.03734C2.78355 8.45104 2.43146 8.76969 2.01776 8.74907C1.60406 8.72845 1.28541 8.37636 1.30603 7.96266C1.41642 5.74802 1.74641 4.12187 2.93414 2.93414C3.82895 2.03933 4.96897 1.63399 6.41371 1.43975C7.82519 1.24998 9.63423 1.24999 11.9426 1.25ZM22 9.75C22.4142 9.75 22.75 10.0858 22.75 10.5V12.0574C22.75 14.3658 22.75 16.1748 22.5603 17.5863C22.366 19.031 21.9607 20.1711 21.0659 21.0659C20.1711 21.9607 19.031 22.366 17.5863 22.5603C16.1748 22.75 14.3658 22.75 12.0574 22.75H11.9426C9.63423 22.75 7.82519 22.75 6.41371 22.5603C4.96897 22.366 3.82895 21.9607 2.93414 21.0659C2.03933 20.1711 1.63399 19.031 1.43975 17.5863C1.24998 16.1748 1.24999 14.3658 1.25 12.0574L1.25 12C1.25 11.5858 1.58579 11.25 2 11.25C2.41421 11.25 2.75 11.5858 2.75 12C2.75 14.3782 2.75159 16.0864 2.92637 17.3864C3.09825 18.6648 3.42514 19.4355 3.9948 20.0052C4.56445 20.5749 5.33517 20.9018 6.61358 21.0736C7.91356 21.2484 9.62177 21.25 12 21.25C14.3782 21.25 16.0864 21.2484 17.3864 21.0736C18.6648 20.9018 19.4355 20.5749 20.0052 20.0052C20.5749 19.4355 20.9018 18.6648 21.0736 17.3864C21.2484 16.0864 21.25 14.3782 21.25 12V10.5C21.25 10.0858 21.5858 9.75 22 9.75Z"
  //           clip-rule="evenodd"
  //         ></path>
  //         <path
  //           fill=""
  //           fill-rule="evenodd"
  //           d="M16.7705 2.27592C18.1384 0.908029 20.3562 0.908029 21.7241 2.27592C23.092 3.6438 23.092 5.86158 21.7241 7.22947L18.0928 10.8607C17.7999 11.1536 17.3251 11.1536 17.0322 10.8607C16.7393 10.5678 16.7393 10.093 17.0322 9.80006L19.1051 7.72709C18.5892 7.50519 17.9882 7.14946 17.4193 6.58065C16.8505 6.01185 16.4948 5.41082 16.2729 4.89486L11.2175 9.95026C10.801 10.3668 10.6376 10.532 10.4988 10.71C10.3274 10.9297 10.1804 11.1676 10.0605 11.4192C9.96337 11.623 9.88868 11.8429 9.7024 12.4017L9.27051 13.6974L10.3026 14.7295L11.5983 14.2976C12.1571 14.1113 12.377 14.0366 12.5808 13.9395C12.8324 13.8196 13.0703 13.6726 13.2901 13.5012C13.468 13.3624 13.6332 13.199 14.0497 12.7825C14.3426 12.4896 14.8175 12.4896 15.1104 12.7825C15.4033 13.0754 15.4033 13.5503 15.1104 13.8432L15.076 13.8776C14.7047 14.2489 14.4721 14.4815 14.2126 14.684C13.9069 14.9224 13.5761 15.1268 13.2261 15.2936C12.929 15.4352 12.6169 15.5392 12.1188 15.7052L9.21426 16.6734C8.67801 16.8521 8.0868 16.7126 7.68711 16.3129C7.28742 15.9132 7.14785 15.322 7.3266 14.7857L8.29477 11.8812C8.46079 11.3831 8.56479 11.071 8.7064 10.7739C8.87319 10.4239 9.07761 10.0931 9.31605 9.78742C9.51849 9.52787 9.7511 9.29529 10.1224 8.92401L16.7705 2.27592ZM17.4546 3.7132C17.4773 3.80906 17.509 3.92327 17.5532 4.05066C17.6965 4.46372 17.9677 5.00771 18.48 5.51999C18.9923 6.03227 19.5363 6.30346 19.9493 6.44677C20.0767 6.49097 20.1909 6.52273 20.2868 6.54543L20.6634 6.16881C21.4455 5.38671 21.4455 4.11867 20.6634 3.33658C19.8813 2.55448 18.6133 2.55448 17.8312 3.33658L17.4546 3.7132Z"
  //           clip-rule="evenodd"
  //         ></path>
  //       </svg>
  //       {" "} Update Road Survey
  //     </button>
  //     <Modal
  //       show={show}
  //       onHide={handleClose}
  //       dialogClassName={!showChange ? "request-leave" : "request-leave-document"}
  //     >
  //       <Modal.Header closeButton >
  //         <Modal.Title>Update Road Survey Data for BOQ</Modal.Title>

  //       </Modal.Header>
  //       {
  //         !showChange ?
  //           <Modal.Body>
  //             <div className="parent-div">
  //               <div className="bdy-div">
  //                 <div className="flex-column align-items-center">
  //                   <label className="form-labels font-weight500 font-size-subheading" title="Invoice Number">
  //                     Reason for Change BOQ<span className="required">*</span>
  //                   </label>
  //                   <input
  //                     type="text"
  //                     name="changeReason"
  //                     title="Reason for Change BOQ"
  //                     placeholder="Example- Revise EOT"
  //                     onChange={(e) => setChangeReason(e.target.value)}
  //                     className={`form-input ${errors.changeReason ? "is-invalid" : ""
  //                       }`}
  //                   />
  //                 </div>
  //                 <div className="button-models">
  //                   <button
  //                     className="model-button-cancel model-button font-weight500"
  //                     onClick={handleClose}
  //                   >
  //                     Cancel
  //                   </button>
  //                   {(changeReason !== "null" && changeReason !== "") && (
  //                     <button
  //                       type="submit"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleChangeSubmit}
  //                     >
  //                       Next
  //                     </button>
  //                   )}

  //                 </div>

  //               </div>
  //             </div>
  //             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

  //           </Modal.Body>
  //           : showEOT === false ?
  //             <Modal.Body>
  //               <div className="parent-div">
  //                 <div className="bdy-div">
  //                   <div className='flex-row justify-between'>
  //                     <button
  //                       type="button"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleChangeback}
  //                     >
  //                       Back
  //                     </button>
  //                     <button
  //                       type="button"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleShowWOT}
  //                     >
  //                       <AddwithWhiteCircle /> Add Revised EOT/COS
  //                     </button>
  //                   </div>
  //                   <div className="flex-row justify-center">
  //                     <table className="table-css ">
  //                       <thead className="table-heading">
  //                         <tr className="custom-table-head-tr width-10vw">
  //                           <th className="table-heading-text text-left-sr" >S no.</th>
  //                           <th className="table-heading-text text-center">Description <br /> <span className="required">(Read-Only)</span></th>
  //                           <th className="table-heading-text text-center">KM <br /><span className="required">(Number)</span></th>
  //                           <th className="table-heading-text text-center">No. of times survey to be concluded <br /><span className="required">(Number)</span></th>
  //                           <th className="table-heading-text text-center">Rate per Survey <br /> <span className="required">(Read-Only)</span></th>
  //                           <th className="table-heading-text text-center">Total Amount  <br /> <span className="required">(Read-Only)</span></th>
  //                         </tr>
  //                       </thead>


  //                       <tbody>

  //                         {formData.map((entry, index) => (
  //                           <tr key={index} className="custom-table-head-td ">

  //                             <td className="align-left width-5vw" >
  //                               {index + 1}
  //                             </td>
  //                             <td>
  //                               <div title="Description" className="flex-column align-items-center">
  //                                 <input
  //                                   className={`form-input width-15vw ${errors[`${index}_description`] ? "error" : ""}`}
  //                                   id={`description_${index}`}
  //                                   name="description"
  //                                   type="text"
  //                                   readOnly
  //                                   value={entry.description}
  //                                   onChange={(e) => handleInputChange(e, index)}

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_description`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_description`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>

  //                             <td>
  //                               <div title="KM" className="flex-column align-items-center">
  //                                 <input
  //                                   className={`form-input width-15vw ${errors[`${index}_KM`] ? "error" : ""}`}
  //                                   id={`KM_${index}`}
  //                                   name="KM"
  //                                   type="number"
  //                                   value={entry.KM}
  //                                   onChange={(e) => handleInputChange(e, index)}

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_KM`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_KM`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>
  //                             <td>
  //                               <div title="Number of Survey" className="flex-column align-items-center">
  //                                 <input
  //                                   className={`form-input-date  width-5vw  ${errors[`${index}_num_of_times_survey_concluded`] ? "error" : ""}`}
  //                                   id={`num_of_times_survey_concluded_${index}`}
  //                                   name="num_of_times_survey_concluded"
  //                                   type="number"
  //                                   value={entry.num_of_times_survey_concluded}
  //                                   onChange={(e) => handleInputChange(e, index)}

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_num_of_times_survey_concluded`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_num_of_times_survey_concluded`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>
  //                             <td>
  //                               <div title="Rate Per Survey" className="flex-column align-items-center">
  //                                 <input
  //                                   className={`form-input-date  width-5vw  ${errors[`${index}_rate_per_km_times`] ? "error" : ""}`}
  //                                   id={`rate_per_km_times_${index}`}
  //                                   name="rate_per_km_times"
  //                                   type="text"
  //                                   value={entry.rate_per_km_times}
  //                                   onChange={(e) => handleInputChange(e, index)}

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_rate_per_km_times`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_rate_per_km_times`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>
  //                             <td>
  //                               <div title="Rate" className="flex-column align-items-center">
  //                                 <input
  //                                   className={`form-input-date  width-5vw  ${errors[`${index}_rate`] ? "error" : ""}`}
  //                                   id={`rate_${index}`}
  //                                   name="rate"
  //                                   type="text"
  //                                   value={Number(entry.KM || 0) * Number(entry.num_of_times_survey_concluded || 0) * Number(entry.rate_per_km_times || 0)} // Calculate and display the sum
  //                                   readOnly
  //                                   onChange={(e) => handleInputChange(e, index)}

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_rate`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_rate`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>


  //                           </tr>
  //                         ))}

  //                       </tbody>

  //                     </table>
  //                   </div>
  //                   <div className="button-models">
  //                     <button
  //                       className="model-button-cancel model-button font-weight500"
  //                       onClick={handleClose}
  //                     >
  //                       Cancel
  //                     </button>
  //                     <button
  //                       type="submit"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleSubmit}
  //                     >
  //                       Update
  //                     </button>
  //                   </div>

  //                 </div>
  //               </div>
  //               <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

  //             </Modal.Body> : showEOT === true ?
  //               <Modal.Body>
  //                 <div className="parent-div">
  //                   <div className="bdy-div">
  //                     <div className='flex-row justify-between'>
  //                       <button
  //                         type="button"
  //                         className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                         disabled={loading}
  //                         onClick={handleclOSEOT}
  //                       >
  //                         Back
  //                       </button>
  //                       <button
  //                         type="button"
  //                         className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                         disabled={loading}
  //                         onClick={addNewEOT}
  //                       >
  //                         <AddwithWhiteCircle /> Add Another Revised EOT/COS
  //                       </button>
  //                     </div>
  //                     {formData[0]?.eot_details?.map((_, detailIndex) => (
  //                       <div key={detailIndex}>
  //                         <h3>EOT Round {detailIndex + 1}</h3>
  //                         <table className="nested-table-lightblue width-90vw payment">

  //                           <thead>
  //                             <tr>
  //                               <th>Descritption</th>
  //                               <th>KM</th>
  //                               <th>No. of Times Survey Concluded</th>
  //                               <th>Rate per Survey</th>
  //                               <th>Total Amount</th>
  //                             </tr>
  //                           </thead>
  //                           <tbody>
  //                             {formData.map((entry, entryIndex) => (
  //                               <tr key={entryIndex}>
  //                                 <td>{entry.description}</td>
  //                                 <td>{entry.KM}</td>
  //                                 {/* <td>
  //                                   <input
  //                                     type="number"
  //                                     className={`form-input-date  width-5vw  ${errors[`${entryIndex}_KM`] ? "error" : ""}`}
  //                                     readOnly
  //                                     value={entry.eot_details[detailIndex]?.KM || ""}
  //                                     onChange={(e) =>
  //                                       handleEOTChange(entryIndex, detailIndex, "KM", e.target.value)
  //                                     }
  //                                   />
  //                                 </td> */}
  //                                 <td>
  //                                   <input
  //                                     type="number"
  //                                     className={`form-input-date  width-5vw  ${errors[`${entryIndex}_num_of_times_survey_concluded`] ? "error" : ""}`}

  //                                     value={entry.eot_details[detailIndex]?.num_of_times_survey_concluded || ""}
  //                                     onChange={(e) =>
  //                                       handleEOTChange(entryIndex, detailIndex, "num_of_times_survey_concluded", e.target.value)
  //                                     }
  //                                   />
  //                                 </td>
  //                                 <td>
  //                                   <input
  //                                     type="number"
  //                                     value={entry.eot_details[detailIndex]?.rate_per_km_times || ""}
  //                                     onChange={(e) =>
  //                                       handleEOTChange(entryIndex, detailIndex, "rate_per_km_times", e.target.value)
  //                                     }
  //                                     className={`form-input-date  width-5vw  ${errors[`${entryIndex}_rate_per_km_times`] ? "error" : ""}`}

  //                                   />
  //                                 </td>
  //                                 <td>
  //                                   <input
  //                                     type="number"
  //                                     className={`form-input-date  width-5vw  ${errors[`${entryIndex}_total_amount`] ? "error" : ""}`}
  //                                     disabled
  //                                     value={entry.eot_details[detailIndex]?.total_amount || ""}
  //                                     onChange={(e) =>
  //                                       handleEOTChange(
  //                                         entryIndex,
  //                                         detailIndex,
  //                                         "total_amount",
  //                                         e.target.value
  //                                       )
  //                                     }
  //                                   />
  //                                 </td>
  //                               </tr>
  //                             ))}
  //                           </tbody>
  //                         </table>
  //                       </div>
  //                     ))}

  //                     <div className="button-models">
  //                       <button
  //                         className="model-button-cancel model-button font-weight500"
  //                         onClick={handleClose}
  //                       >
  //                         Cancel
  //                       </button>
  //                       <button
  //                         type="submit"
  //                         className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                         disabled={loading}
  //                         onClick={handleSubmit}
  //                       >
  //                         Save
  //                       </button>
  //                     </div>

  //                   </div>
  //                 </div>
  //                 <ToastContainer
  //                   position="top-center"
  //                   autoClose={1000}
  //                   hideProgressBar={false}
  //                   newestOnTop={true}
  //                   closeOnClick
  //                   rtl={false}
  //                   pauseOnFocusLoss
  //                   draggable
  //                   pauseOnHover
  //                 />
  //               </Modal.Body > : ""
  //       }
  //     </Modal >
  //   </>
  // )

  return (
    <>
      <button
        title="Update Road Survey"
        className="eb-bulk-trigger-btn"
        onClick={handleShow}
        style={{ background: "black" }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="white"
          viewBox="0 0 24 24"
          id="pen-new-square"
        >
          <path fillRule="evenodd" d="M11.9426 1.25L13.5 1.25C13.9142 1.25 14.25 1.58579 14.25 2C14.25 2.41421 13.9142 2.75 13.5 2.75H12C9.62177 2.75 7.91356 2.75159 6.61358 2.92637C5.33517 3.09825 4.56445 3.42514 3.9948 3.9948C3.23505 4.75455 2.91245 5.86509 2.80417 8.03734C2.78355 8.45104 2.43146 8.76969 2.01776 8.74907C1.60406 8.72845 1.28541 8.37636 1.30603 7.96266C1.41642 5.74802 1.74641 4.12187 2.93414 2.93414C3.82895 2.03933 4.96897 1.63399 6.41371 1.43975C7.82519 1.24998 9.63423 1.24999 11.9426 1.25ZM22 9.75C22.4142 9.75 22.75 10.0858 22.75 10.5V12.0574C22.75 14.3658 22.75 16.1748 22.5603 17.5863C22.366 19.031 21.9607 20.1711 21.0659 21.0659C20.1711 21.9607 19.031 22.366 17.5863 22.5603C16.1748 22.75 14.3658 22.75 12.0574 22.75H11.9426C9.63423 22.75 7.82519 22.75 6.41371 22.5603C4.96897 22.366 3.82895 21.9607 2.93414 21.0659C2.03933 20.1711 1.63399 19.031 1.43975 17.5863C1.24998 16.1748 1.24999 14.3658 1.25 12.0574L1.25 12C1.25 11.5858 1.58579 11.25 2 11.25C2.41421 11.25 2.75 11.5858 2.75 12C2.75 14.3782 2.75159 16.0864 2.92637 17.3864C3.09825 18.6648 3.42514 19.4355 3.9948 20.0052C4.56445 20.5749 5.33517 20.9018 6.61358 21.0736C7.91356 21.2484 9.62177 21.25 12 21.25C14.3782 21.25 16.0864 21.2484 17.3864 21.0736C18.6648 20.9018 19.4355 20.5749 20.0052 20.0052C20.5749 19.4355 20.9018 18.6648 21.0736 17.3864C21.2484 16.0864 21.25 14.3782 21.25 12V10.5C21.25 10.0858 21.5858 9.75 22 9.75Z" clipRule="evenodd" />
          <path fillRule="evenodd" d="M16.7705 2.27592C18.1384 0.908029 20.3562 0.908029 21.7241 2.27592C23.092 3.6438 23.092 5.86158 21.7241 7.22947L18.0928 10.8607C17.7999 11.1536 17.3251 11.1536 17.0322 10.8607C16.7393 10.5678 16.7393 10.093 17.0322 9.80006L19.1051 7.72709C18.5892 7.50519 17.9882 7.14946 17.4193 6.58065C16.8505 6.01185 16.4948 5.41082 16.2729 4.89486L11.2175 9.95026C10.801 10.3668 10.6376 10.532 10.4988 10.71C10.3274 10.9297 10.1804 11.1676 10.0605 11.4192C9.96337 11.623 9.88868 11.8429 9.7024 12.4017L9.27051 13.6974L10.3026 14.7295L11.5983 14.2976C12.1571 14.1113 12.377 14.0366 12.5808 13.9395C12.8324 13.8196 13.0703 13.6726 13.2901 13.5012C13.468 13.3624 13.6332 13.199 14.0497 12.7825C14.3426 12.4896 14.8175 12.4896 15.1104 12.7825C15.4033 13.0754 15.4033 13.5503 15.1104 13.8432L15.076 13.8776C14.7047 14.2489 14.4721 14.4815 14.2126 14.684C13.9069 14.9224 13.5761 15.1268 13.2261 15.2936C12.929 15.4352 12.6169 15.5392 12.1188 15.7052L9.21426 16.6734C8.67801 16.8521 8.0868 16.7126 7.68711 16.3129C7.28742 15.9132 7.14785 15.322 7.3266 14.7857L8.29477 11.8812C8.46079 11.3831 8.56479 11.071 8.7064 10.7739C8.87319 10.4239 9.07761 10.0931 9.31605 9.78742C9.51849 9.52787 9.7511 9.29529 10.1224 8.92401L16.7705 2.27592ZM17.4546 3.7132C17.4773 3.80906 17.509 3.92327 17.5532 4.05066C17.6965 4.46372 17.9677 5.00771 18.48 5.51999C18.9923 6.03227 19.5363 6.30346 19.9493 6.44677C20.0767 6.49097 20.1909 6.52273 20.2868 6.54543L20.6634 6.16881C21.4455 5.38671 21.4455 4.11867 20.6634 3.33658C19.8813 2.55448 18.6133 2.55448 17.8312 3.33658L17.4546 3.7132Z" clipRule="evenodd" />
        </svg>
        Update Road Survey
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName={!showChange ? "eb-bulk-modal request-leave" : "max-heightModal eb-bulk-modal model-width90vw"}
      >
        <Modal.Header className="eb-bulk-modal-header">
          <Modal.Title className="eb-bulk-modal-title">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
              <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
            </svg>
            Update Road Survey Data for BOQ
            <button
              className="close-btn"
              onClick={handleClose}
              style={{ marginLeft: "auto", background: "none", border: "none", color: "white", fontSize: "24px", cursor: "pointer" }}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </Modal.Title>
        </Modal.Header>

        {!showChange ? (

          /* ===== STEP 1: Reason for Change ===== */
          <Modal.Body className="eb-bulk-modal-body">
            <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
              <div className="eb-bulk-content">
                <div className="eb-bulk-reason-section" style={{ padding: "20px", background: "#f7fafc", borderRadius: "12px" }}>
                  <label className="eb-bulk-label" style={{ display: "block", fontWeight: "600", marginBottom: "8px", color: "#2d3748" }}>
                    Reason for Change BOQ <span className="eb-bulk-required">*</span>
                  </label>
                  <input
                    type="text"
                    name="changeReason"
                    title="Reason for Change BOQ"
                    placeholder="Example- Revise EOT"
                    onChange={(e) => setChangeReason(e.target.value)}
                    className="eb-bulk-input"
                    style={{ width: "90%", padding: "12px 16px", fontSize: "14px" }}
                  />
                </div>
                <div className="eb-bulk-footer-actions" style={{ justifyContent: "flex-end" }}>
                  <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                    Cancel
                  </button>
                  {(changeReason !== "null" && changeReason !== "") && (
                    <button
                      type="submit"
                      className="eb-bulk-btn eb-bulk-btn-submit"
                      disabled={loading}
                      onClick={handleChangeSubmit}
                      style={{ background: "black" }}
                    >
                      Next
                    </button>
                  )}
                </div>
              </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </Modal.Body>

        ) : showEOT === false ? (

          /* ===== STEP 2: Main Table ===== */
          <Modal.Body className="eb-bulk-modal-body">
            <div className="eb-bulk-table-scroll table-box scroll-container-table" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
              <div className="eb-bulk-content">
                <div className="eb-bulk-actions" style={{ justifyContent: "space-between" }}>
                  <button
                    type="button"
                    className="eb-bulk-add-row-btn"
                    style={{ background: "#718096" }}
                    disabled={loading}
                    onClick={handleChangeback}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="15 18 9 12 15 6" />
                    </svg>
                    Back
                  </button>
                  <button
                    type="button"
                    className="eb-bulk-add-row-btn"
                    disabled={loading}
                    onClick={handleShowWOT}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="8" x2="12" y2="16" />
                      <line x1="8" y1="12" x2="16" y2="12" />
                    </svg>
                    Add Revised EOT/COS
                  </button>
                </div>

                <div className="eb-bulk-table-wrapper">
                  <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "40vh", minHeight: "40vh" }}>
                    <table className="eb-bulk-table">
                      <thead className="eb-bulk-table-head">
                        <tr className="eb-bulk-table-header-row">
                          <th className="eb-bulk-th eb-bulk-th-rank">
                            <span className="eb-bulk-th-label">S.No</span>
                          </th>
                          <th className="eb-bulk-th">
                            <span className="eb-bulk-th-label">Description</span>
                            <span className="eb-bulk-th-sub">(Read-Only)</span>
                          </th>
                          <th className="eb-bulk-th">
                            <span className="eb-bulk-th-label">KM</span>
                            <span className="eb-bulk-th-sub">(Number)</span>
                          </th>
                          <th className="eb-bulk-th">
                            <span className="eb-bulk-th-label">No. of Times Survey</span>
                            <span className="eb-bulk-th-sub">(Number)</span>
                          </th>
                          <th className="eb-bulk-th">
                            <span className="eb-bulk-th-label">Rate per Survey</span>
                            <span className="eb-bulk-th-sub">(Read-Only)</span>
                          </th>
                          <th className="eb-bulk-th eb-bulk-th-rate">
                            <span className="eb-bulk-th-label">Total Amount</span>
                            <span className="eb-bulk-th-sub">(Read-Only)</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {formData.map((entry, index) => (
                          <tr key={index} className="eb-bulk-row">

                            {/* S.No */}
                            <td className="eb-bulk-td eb-bulk-td-rank">
                              <span style={{ fontWeight: "500", color: "#2d3748" }}>{index + 1}.</span>
                            </td>

                            {/* Description (Read-Only) */}
                            <td className="eb-bulk-td">
                              <div className="eb-bulk-input-wrapper">
                                <input
                                  className="eb-bulk-input"
                                  id={`description_${index}`}
                                  name="description"
                                  type="text"
                                  readOnly
                                  value={entry.description}
                                  style={{ background: "var(--eb-bulk-input-readonly-bg, #f0f0f0)", cursor: "not-allowed" }}
                                />
                              </div>
                            </td>

                            {/* KM */}
                            <td className="eb-bulk-td">
                              <div className="eb-bulk-input-wrapper">
                                <input
                                  className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_KM`] ? "eb-bulk-input-error" : ""}`}
                                  id={`KM_${index}`}
                                  name="KM"
                                  type="number"
                                  value={entry.KM}
                                  onChange={(e) => handleInputChange(e, index)}
                                  placeholder="0"
                                />
                                {errors[`${index}_KM`] && (
                                  <span className="eb-bulk-error-text">{errors[`${index}_KM`]}</span>
                                )}
                              </div>
                            </td>

                            {/* No. of Times Survey Concluded */}
                            <td className="eb-bulk-td">
                              <div className="eb-bulk-input-wrapper">
                                <input
                                  className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_num_of_times_survey_concluded`] ? "eb-bulk-input-error" : ""}`}
                                  id={`num_of_times_survey_concluded_${index}`}
                                  name="num_of_times_survey_concluded"
                                  type="number"
                                  value={entry.num_of_times_survey_concluded}
                                  onChange={(e) => handleInputChange(e, index)}
                                  placeholder="0"
                                />
                                {errors[`${index}_num_of_times_survey_concluded`] && (
                                  <span className="eb-bulk-error-text">{errors[`${index}_num_of_times_survey_concluded`]}</span>
                                )}
                              </div>
                            </td>

                            {/* Rate per Survey (Read-Only) */}
                            <td className="eb-bulk-td">
                              <div className="eb-bulk-input-wrapper">
                                <input
                                  className="eb-bulk-input eb-bulk-input-number"
                                  id={`rate_per_km_times_${index}`}
                                  name="rate_per_km_times"
                                  type="text"
                                  readOnly
                                  value={entry.rate_per_km_times}
                                  style={{ background: "var(--eb-bulk-input-readonly-bg, #f0f0f0)", cursor: "not-allowed" }}
                                />
                              </div>
                            </td>

                            {/* Total Amount (Read-Only) */}
                            <td className="eb-bulk-td">
                              <div className="eb-bulk-input-wrapper">
                                <input
                                  className="eb-bulk-input eb-bulk-input-number"
                                  id={`rate_${index}`}
                                  name="rate"
                                  type="text"
                                  readOnly
                                  value={Number(entry.KM || 0) * Number(entry.num_of_times_survey_concluded || 0) * Number(entry.rate_per_km_times || 0)}
                                  style={{ background: "var(--eb-bulk-input-readonly-bg, #f0f0f0)", cursor: "not-allowed" }}
                                />
                              </div>
                            </td>

                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="eb-bulk-footer-actions">
                  <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="eb-bulk-btn eb-bulk-btn-submit"
                    disabled={loading}
                    onClick={handleSubmit}
                    style={{ background: "black" }}
                  >
                    {loading ? (
                      <span className="eb-bulk-btn-loader">
                        <span className="eb-bulk-spinner"></span>
                        Updating...
                      </span>
                    ) : (
                      <>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                          <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                        </svg>
                        Update
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </Modal.Body>

        ) : (

          /* ===== STEP 3: EOT Table ===== */
          <Modal.Body className="eb-bulk-modal-body">
            <div className="eb-bulk-container">
              <div className="eb-bulk-content">
                <div className="eb-bulk-actions" style={{ justifyContent: "space-between" }}>
                  <button
                    type="button"
                    className="eb-bulk-add-row-btn"
                    style={{ background: "#718096" }}
                    disabled={loading}
                    onClick={handleclOSEOT}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="15 18 9 12 15 6" />
                    </svg>
                    Back
                  </button>
                  <button
                    type="button"
                    className="eb-bulk-add-row-btn"
                    disabled={loading}
                    onClick={addNewEOT}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="8" x2="12" y2="16" />
                      <line x1="8" y1="12" x2="16" y2="12" />
                    </svg>
                    Add Another Revised EOT/COS
                  </button>
                </div>

                <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
                  {formData[0]?.eot_details?.map((_, detailIndex) => (
                    <div key={detailIndex} style={{ marginBottom: "24px" }}>
                      <h3 style={{ fontSize: "16px", fontWeight: "700", color: "#2d3748", marginBottom: "12px" }}>
                        EOT Round {detailIndex + 1}
                      </h3>
                      <div className="eb-bulk-table-wrapper">
                        <table className="eb-bulk-table">
                          <thead className="eb-bulk-table-head">
                            <tr className="eb-bulk-table-header-row">
                              <th className="eb-bulk-th"><span className="eb-bulk-th-label">Description</span></th>
                              <th className="eb-bulk-th"><span className="eb-bulk-th-label">KM</span></th>
                              <th className="eb-bulk-th">
                                <span className="eb-bulk-th-label">No. of Times Survey</span>
                              </th>
                              <th className="eb-bulk-th">
                                <span className="eb-bulk-th-label">Rate per Survey</span>
                              </th>
                              <th className="eb-bulk-th">
                                <span className="eb-bulk-th-label">Total Amount</span>
                                <span className="eb-bulk-th-sub">(Read-Only)</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {formData.map((entry, entryIndex) => (
                              <tr key={entryIndex} className="eb-bulk-row">

                                {/* Description (Read-Only) */}
                                <td className="eb-bulk-td">
                                  <span style={{ fontSize: "13px", color: "#2d3748" }}>{entry.description}</span>
                                </td>

                                {/* KM (Read-Only) */}
                                <td className="eb-bulk-td">
                                  <div className="eb-bulk-input-wrapper">

                                    <span style={{ fontSize: "13px", color: "#2d3748" }}>{entry.KM}</span>
                                  </div>
                                </td>

                                {/* No. of Times Survey Concluded */}
                                <td className="eb-bulk-td">
                                  <div className="eb-bulk-input-wrapper">
                                    <input
                                      type="number"
                                      className={`eb-bulk-input eb-bulk-input-number ${errors[`${entryIndex}_num_of_times_survey_concluded`] ? "eb-bulk-input-error" : ""}`}
                                      value={entry.eot_details[detailIndex]?.num_of_times_survey_concluded || ""}
                                      onChange={(e) => handleEOTChange(entryIndex, detailIndex, "num_of_times_survey_concluded", e.target.value)}
                                      placeholder="0"
                                    />
                                  </div>
                                </td>

                                {/* Rate per Survey */}
                                <td className="eb-bulk-td">
                                  <div className="eb-bulk-input-wrapper">
                                    <input
                                      type="number"
                                      className={`eb-bulk-input eb-bulk-input-number ${errors[`${entryIndex}_rate_per_km_times`] ? "eb-bulk-input-error" : ""}`}
                                      value={entry.eot_details[detailIndex]?.rate_per_km_times || ""}
                                      onChange={(e) => handleEOTChange(entryIndex, detailIndex, "rate_per_km_times", e.target.value)}
                                      placeholder="₹ 0.00"
                                    />
                                  </div>
                                </td>

                                {/* Total Amount (Read-Only) */}
                                <td className="eb-bulk-td eb-bulk-td-total">
                                  <div className="eb-bulk-input-wrapper">

                                    <span className="eb-bulk-total-value" style={{ minWidth: "80px" }}>
                                      {entry.eot_details[detailIndex]?.total_amount || 0}
                                    </span>
                                  </div>
                                </td>

                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="eb-bulk-footer-actions">
                  <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="eb-bulk-btn eb-bulk-btn-submit"
                    disabled={loading}
                    onClick={handleSubmit}
                    style={{ background: "black" }}
                  >
                    {loading ? (
                      <span className="eb-bulk-btn-loader">
                        <span className="eb-bulk-spinner"></span>
                        Saving...
                      </span>
                    ) : (
                      <>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" />
                          <polyline points="17 21 17 13 7 13 7 21" />
                          <polyline points="7 3 7 8 15 8" />
                        </svg>
                        Save
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </Modal.Body>
        )}
      </Modal>
    </>
  );
}
const BulkUpdateContieneous = ({ boqContieneousList, i, getData, id, value, getLogData }) => {

  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState([]);
  const [changeReason, setChangeReason] = useState("null");
  const [showChange, setShowChange] = useState(false);




  const createdAt = new Date().toISOString();

  useEffect(() => {
    if (!showChange) {
      setFormData((prevData) =>
        prevData.map((item) => ({
          ...item,
          random_value_of_changes: createdAt,
          change_by_emp_code: sessionStorage.getItem('sitemanagement_emp_code'),
          change_by_emp_name: sessionStorage.getItem('name'),
        }))
      );
    }

  }, [createdAt, showChange])

  useEffect(() => {
    if (changeReason !== "null") {
      setFormData((prevData) =>
        prevData.map((item) => ({
          ...item,
          reason_of_change: changeReason,
        }))
      );
    }
  }, [changeReason]);



  useEffect(() => {
    if (Array.isArray(boqContieneousList)) {
      const initialData = boqContieneousList.map((item) => ({
        description: "",
        project: id,
        unit: "",
        ammount: "",
        reason_of_change: changeReason !== "null" ? changeReason : "",
        change_by_emp_code: sessionStorage.getItem('sitemanagement_emp_code'),
        change_by_emp_name: sessionStorage.getItem('name'),
        eot_details: [{
          boqId: item.id,
          description: item.description,
          unit: "",
          ammount: "",

        }],
      }));
      setFormData(initialData);
    }
  }, [boqContieneousList]);







  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const [inputState, setInputState] = useState({});



  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => {
      const newFields = [...prevFormData];
      newFields[index] = {
        ...newFields[index],
        [name]: value,
      };
      return newFields;
    });
  }

  const handleShow = () => {
    setShow(true);
    setFormData(boqContieneousList);
  }


  const handleChangeSubmit = () => {
    setShowChange(true);
  }
  const handleChangeback = () => {
    setShowChange(false);

  }


  const handleClose = () => {
    setShow(false);
    setShowChange(false);
    setShowEOT(false)
    setChangeReason("");
  }

  const [loading, setLoading] = useState(false); //loading logic

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

      try {
        let res = await axios.put(
          `${BASE_URL}/siteproject/bulkBOQContingencies/`,
          formData
        );

        if (res.status === 200) {
          await getData();
          await getLogData();
          handleClose();
          toast.dismiss(loadingToastId); // Dismiss loading toast
          toast.success('Contingencies BOQ data updated successfully.')
          // window.location.reload();
        } else {
          alert(res);
        }
      } catch (err) {
        //toast Logic
        handleErrorToast(err, loadingToastId);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  const [showEOT, setShowEOT] = useState(false);
  const handleShowWOT = () => {
    setShowEOT(true)
  }
  const handleclOSEOT = () => {
    setShowEOT(false)
  }


  const addNewEOT = () => {
    setFormData((prevFormData) =>
      prevFormData.map((entry) => ({
        ...entry,
        eot_details: [
          ...(entry.eot_details || []),
          {
            boqId: entry.boqId || entry.id,
            unit: "",
            ammount: "",

          },
        ],
      }))
    );
  };

  useEffect(() => {
    if (Array.isArray(boqContieneousList)) {
      const initialData = boqContieneousList.map((item) => ({
        description: "",
        project: id,
        unit: "",
        ammount: "",
        reason_of_change: changeReason !== "null" ? changeReason : "",
        change_by_emp_code: sessionStorage.getItem('sitemanagement_emp_code'),
        change_by_emp_name: sessionStorage.getItem('name'),
        eot_details: [{
          boqId: item.id,
          description: item.description,
          unit: "",
          ammount: "",

        }],
      }));
      setFormData(initialData);
      setShowEOT(true); // ✅ show EOT table immediately

    }
  }, [boqContieneousList]);



  const handleEOTChange = (entryIndex, detailIndex, field, value) => {
    setFormData((prevFormData) =>
      prevFormData.map((entry, i) => {
        if (i !== entryIndex) return entry;

        const updatedDetails = entry.eot_details.map((detail, j) => {
          if (j !== detailIndex) return detail;

          const updatedDetail = { ...detail, [field]: value };

          ;

          return updatedDetail;
        });

        return { ...entry, eot_details: updatedDetails };
      })
    );
  };
  // return (
  //   <>
  //     <button title="Update Contingencies  " className="upload-svg flex-row" onClick={handleShow}>
  //       <svg
  //         xmlns="http://www.w3.org/2000/svg"
  //         width="24"
  //         height="24"
  //         fill="white"
  //         viewBox="0 0 24 24"
  //         id="pen-new-square"
  //       >
  //         <path
  //           fill=""
  //           fill-rule="evenodd"
  //           d="M11.9426 1.25L13.5 1.25C13.9142 1.25 14.25 1.58579 14.25 2C14.25 2.41421 13.9142 2.75 13.5 2.75H12C9.62177 2.75 7.91356 2.75159 6.61358 2.92637C5.33517 3.09825 4.56445 3.42514 3.9948 3.9948C3.23505 4.75455 2.91245 5.86509 2.80417 8.03734C2.78355 8.45104 2.43146 8.76969 2.01776 8.74907C1.60406 8.72845 1.28541 8.37636 1.30603 7.96266C1.41642 5.74802 1.74641 4.12187 2.93414 2.93414C3.82895 2.03933 4.96897 1.63399 6.41371 1.43975C7.82519 1.24998 9.63423 1.24999 11.9426 1.25ZM22 9.75C22.4142 9.75 22.75 10.0858 22.75 10.5V12.0574C22.75 14.3658 22.75 16.1748 22.5603 17.5863C22.366 19.031 21.9607 20.1711 21.0659 21.0659C20.1711 21.9607 19.031 22.366 17.5863 22.5603C16.1748 22.75 14.3658 22.75 12.0574 22.75H11.9426C9.63423 22.75 7.82519 22.75 6.41371 22.5603C4.96897 22.366 3.82895 21.9607 2.93414 21.0659C2.03933 20.1711 1.63399 19.031 1.43975 17.5863C1.24998 16.1748 1.24999 14.3658 1.25 12.0574L1.25 12C1.25 11.5858 1.58579 11.25 2 11.25C2.41421 11.25 2.75 11.5858 2.75 12C2.75 14.3782 2.75159 16.0864 2.92637 17.3864C3.09825 18.6648 3.42514 19.4355 3.9948 20.0052C4.56445 20.5749 5.33517 20.9018 6.61358 21.0736C7.91356 21.2484 9.62177 21.25 12 21.25C14.3782 21.25 16.0864 21.2484 17.3864 21.0736C18.6648 20.9018 19.4355 20.5749 20.0052 20.0052C20.5749 19.4355 20.9018 18.6648 21.0736 17.3864C21.2484 16.0864 21.25 14.3782 21.25 12V10.5C21.25 10.0858 21.5858 9.75 22 9.75Z"
  //           clip-rule="evenodd"
  //         ></path>
  //         <path
  //           fill=""
  //           fill-rule="evenodd"
  //           d="M16.7705 2.27592C18.1384 0.908029 20.3562 0.908029 21.7241 2.27592C23.092 3.6438 23.092 5.86158 21.7241 7.22947L18.0928 10.8607C17.7999 11.1536 17.3251 11.1536 17.0322 10.8607C16.7393 10.5678 16.7393 10.093 17.0322 9.80006L19.1051 7.72709C18.5892 7.50519 17.9882 7.14946 17.4193 6.58065C16.8505 6.01185 16.4948 5.41082 16.2729 4.89486L11.2175 9.95026C10.801 10.3668 10.6376 10.532 10.4988 10.71C10.3274 10.9297 10.1804 11.1676 10.0605 11.4192C9.96337 11.623 9.88868 11.8429 9.7024 12.4017L9.27051 13.6974L10.3026 14.7295L11.5983 14.2976C12.1571 14.1113 12.377 14.0366 12.5808 13.9395C12.8324 13.8196 13.0703 13.6726 13.2901 13.5012C13.468 13.3624 13.6332 13.199 14.0497 12.7825C14.3426 12.4896 14.8175 12.4896 15.1104 12.7825C15.4033 13.0754 15.4033 13.5503 15.1104 13.8432L15.076 13.8776C14.7047 14.2489 14.4721 14.4815 14.2126 14.684C13.9069 14.9224 13.5761 15.1268 13.2261 15.2936C12.929 15.4352 12.6169 15.5392 12.1188 15.7052L9.21426 16.6734C8.67801 16.8521 8.0868 16.7126 7.68711 16.3129C7.28742 15.9132 7.14785 15.322 7.3266 14.7857L8.29477 11.8812C8.46079 11.3831 8.56479 11.071 8.7064 10.7739C8.87319 10.4239 9.07761 10.0931 9.31605 9.78742C9.51849 9.52787 9.7511 9.29529 10.1224 8.92401L16.7705 2.27592ZM17.4546 3.7132C17.4773 3.80906 17.509 3.92327 17.5532 4.05066C17.6965 4.46372 17.9677 5.00771 18.48 5.51999C18.9923 6.03227 19.5363 6.30346 19.9493 6.44677C20.0767 6.49097 20.1909 6.52273 20.2868 6.54543L20.6634 6.16881C21.4455 5.38671 21.4455 4.11867 20.6634 3.33658C19.8813 2.55448 18.6133 2.55448 17.8312 3.33658L17.4546 3.7132Z"
  //           clip-rule="evenodd"
  //         ></path>
  //       </svg>
  //       {" "} Update Contingencies
  //     </button>
  //     <Modal
  //       show={show}
  //       onHide={handleClose}
  //       dialogClassName={!showChange ? "request-leave" : "request-leave-document"}
  //     >
  //       <Modal.Header closeButton >
  //         <Modal.Title>Update Contingencies Data for BOQ</Modal.Title>

  //       </Modal.Header>
  //       {
  //         !showChange ?
  //           <Modal.Body>
  //             <div className="parent-div">
  //               <div className="bdy-div">
  //                 <div className="flex-column align-items-center">
  //                   <label className="form-labels font-weight500 font-size-subheading" title="Invoice Number">
  //                     Reason for Change BOQ<span className="required">*</span>
  //                   </label>
  //                   <input
  //                     type="text"
  //                     name="changeReason"
  //                     title="Reason for Change BOQ"
  //                     placeholder="Example- Revise EOT"
  //                     onChange={(e) => setChangeReason(e.target.value)}
  //                     className={`form-input ${errors.changeReason ? "is-invalid" : ""
  //                       }`}
  //                   />
  //                 </div>
  //                 <div className="button-models">
  //                   <button
  //                     className="model-button-cancel model-button font-weight500"
  //                     onClick={handleClose}
  //                   >
  //                     Cancel
  //                   </button>
  //                   {(changeReason !== "null" && changeReason !== "") && (
  //                     <button
  //                       type="submit"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleChangeSubmit}
  //                     >
  //                       Next
  //                     </button>
  //                   )}

  //                 </div>

  //               </div>
  //             </div>
  //             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

  //           </Modal.Body>
  //           : showEOT === false ?
  //             <Modal.Body>
  //               <div className="parent-div">
  //                 <div className="bdy-div">
  //                   <div className='flex-row justify-between'>
  //                     <button
  //                       type="button"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleChangeback}
  //                     >
  //                       Back
  //                     </button>
  //                     <button
  //                       type="button"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleShowWOT}
  //                     >
  //                       <AddwithWhiteCircle /> Add Revised EOT/COS
  //                     </button>
  //                   </div>
  //                   <div className="flex-row justify-center">
  //                     <table className="table-css ">
  //                       <thead className="table-heading">
  //                         <tr className="custom-table-head-tr width-10vw">
  //                           <th className="table-heading-text text-left-sr" >S no.</th>
  //                           <th className="table-heading-text text-center">Description <br /> <span className="required">(Read-Only)</span></th>
  //                           <th className="table-heading-text text-center">Unit <br /><span className="required">(Number)</span></th>
  //                           <th className="table-heading-text text-center">Amount <br /><span className="required">(Number)</span></th>
  //                         </tr>
  //                       </thead>


  //                       <tbody>

  //                         {formData.map((entry, index) => (
  //                           <tr key={index} className="custom-table-head-td ">

  //                             <td className="align-left width-5vw" >
  //                               {index + 1}
  //                             </td>
  //                             <td>
  //                               <div title="Description" className="flex-column align-items-center">
  //                                 <input
  //                                   className={`form-input width-15vw ${errors[`${index}_description`] ? "error" : ""}`}
  //                                   id={`description_${index}`}
  //                                   name="description"
  //                                   type="text"
  //                                   readOnly
  //                                   value={entry.description}
  //                                   onChange={(e) => handleInputChange(e, index)}

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_description`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_description`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>

  //                             <td>
  //                               <div title="unit" className="flex-column align-items-center">
  //                                 <input
  //                                   className={`form-input width-15vw ${errors[`${index}_unit`] ? "error" : ""}`}
  //                                   id={`unit_${index}`}
  //                                   name="unit"
  //                                   type="number"
  //                                   value={entry.unit}
  //                                   onChange={(e) => handleInputChange(e, index)}

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_unit`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_unit`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>
  //                             <td>
  //                               <div title="Number of Survey" className="flex-column align-items-center">
  //                                 <input
  //                                   className={`form-input-date  width-5vw  ${errors[`${index}_ammount`] ? "error" : ""}`}
  //                                   id={`ammount_${index}`}
  //                                   name="ammount"
  //                                   type="number"
  //                                   value={entry.ammount}
  //                                   onChange={(e) => handleInputChange(e, index)}

  //                                 />
  //                                 <div>
  //                                   {errors[`${index}_ammount`] && (
  //                                     <span className="error-message font-size-text ">{errors[`${index}_ammount`]}</span>
  //                                   )}
  //                                 </div>
  //                               </div>
  //                             </td>
  //                           </tr>
  //                         ))}

  //                       </tbody>

  //                     </table>
  //                   </div>
  //                   <div className="button-models">
  //                     <button
  //                       className="model-button-cancel model-button font-weight500"
  //                       onClick={handleClose}
  //                     >
  //                       Cancel
  //                     </button>
  //                     <button
  //                       type="submit"
  //                       className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                       disabled={loading}
  //                       onClick={handleSubmit}
  //                     >
  //                       Update
  //                     </button>
  //                   </div>

  //                 </div>
  //               </div>
  //               <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

  //             </Modal.Body> : showEOT === true ?
  //               <Modal.Body>
  //                 <div className="parent-div">
  //                   <div className="bdy-div">
  //                     <div className='flex-row justify-between'>
  //                       <button
  //                         type="button"
  //                         className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                         disabled={loading}
  //                         onClick={handleclOSEOT}
  //                       >
  //                         Back
  //                       </button>
  //                       <button
  //                         type="button"
  //                         className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                         disabled={loading}
  //                         onClick={addNewEOT}
  //                       >
  //                         <AddwithWhiteCircle /> Add Another Revised EOT/COS
  //                       </button>
  //                     </div>
  //                     {formData[0]?.eot_details?.map((_, detailIndex) => (
  //                       <div key={detailIndex}>
  //                         <h3>EOT Round {detailIndex + 1}</h3>
  //                         <table className="nested-table-lightblue width-90vw payment">

  //                           <thead>
  //                             <tr>
  //                               <th>Descritption</th>
  //                               <th>Units</th>
  //                               <th>Amount</th>
  //                             </tr>
  //                           </thead>
  //                           <tbody>
  //                             {formData.map((entry, entryIndex) => (
  //                               <tr key={entryIndex}>
  //                                 <td>{entry.description}</td>
  //                                 <td>
  //                                   <input
  //                                     type="number"
  //                                     className={`form-input-date  width-5vw  ${errors[`${entryIndex}_unit`] ? "error" : ""}`}

  //                                     value={entry.eot_details[detailIndex]?.unit || ""}
  //                                     onChange={(e) =>
  //                                       handleEOTChange(entryIndex, detailIndex, "unit", e.target.value)
  //                                     }
  //                                   />
  //                                 </td>
  //                                 <td>
  //                                   <input
  //                                     type="number"
  //                                     value={entry.eot_details[detailIndex]?.ammount || ""}
  //                                     onChange={(e) =>
  //                                       handleEOTChange(entryIndex, detailIndex, "ammount", e.target.value)
  //                                     }
  //                                     className={`form-input-date  width-5vw  ${errors[`${entryIndex}_ammount`] ? "error" : ""}`}

  //                                   />
  //                                 </td>
  //                               </tr>
  //                             ))}
  //                           </tbody>
  //                         </table>
  //                       </div>
  //                     ))}

  //                     <div className="button-models">
  //                       <button
  //                         className="model-button-cancel model-button font-weight500"
  //                         onClick={handleClose}
  //                       >
  //                         Cancel
  //                       </button>
  //                       <button
  //                         type="submit"
  //                         className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
  //                         disabled={loading}
  //                         onClick={handleSubmit}
  //                       >
  //                         Save
  //                       </button>
  //                     </div>

  //                   </div>
  //                 </div>
  //                 <ToastContainer
  //                   position="top-center"
  //                   autoClose={1000}
  //                   hideProgressBar={false}
  //                   newestOnTop={true}
  //                   closeOnClick
  //                   rtl={false}
  //                   pauseOnFocusLoss
  //                   draggable
  //                   pauseOnHover
  //                 />
  //               </Modal.Body > : ""
  //       }
  //     </Modal >
  //   </>
  // )

  return (
    <>
      <button
        title="Update Contingencies"
        className="eb-bulk-trigger-btn"
        onClick={handleShow}
        style={{ background: "black" }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="white"
          viewBox="0 0 24 24"
          id="pen-new-square"
        >
          <path fillRule="evenodd" d="M11.9426 1.25L13.5 1.25C13.9142 1.25 14.25 1.58579 14.25 2C14.25 2.41421 13.9142 2.75 13.5 2.75H12C9.62177 2.75 7.91356 2.75159 6.61358 2.92637C5.33517 3.09825 4.56445 3.42514 3.9948 3.9948C3.23505 4.75455 2.91245 5.86509 2.80417 8.03734C2.78355 8.45104 2.43146 8.76969 2.01776 8.74907C1.60406 8.72845 1.28541 8.37636 1.30603 7.96266C1.41642 5.74802 1.74641 4.12187 2.93414 2.93414C3.82895 2.03933 4.96897 1.63399 6.41371 1.43975C7.82519 1.24998 9.63423 1.24999 11.9426 1.25ZM22 9.75C22.4142 9.75 22.75 10.0858 22.75 10.5V12.0574C22.75 14.3658 22.75 16.1748 22.5603 17.5863C22.366 19.031 21.9607 20.1711 21.0659 21.0659C20.1711 21.9607 19.031 22.366 17.5863 22.5603C16.1748 22.75 14.3658 22.75 12.0574 22.75H11.9426C9.63423 22.75 7.82519 22.75 6.41371 22.5603C4.96897 22.366 3.82895 21.9607 2.93414 21.0659C2.03933 20.1711 1.63399 19.031 1.43975 17.5863C1.24998 16.1748 1.24999 14.3658 1.25 12.0574L1.25 12C1.25 11.5858 1.58579 11.25 2 11.25C2.41421 11.25 2.75 11.5858 2.75 12C2.75 14.3782 2.75159 16.0864 2.92637 17.3864C3.09825 18.6648 3.42514 19.4355 3.9948 20.0052C4.56445 20.5749 5.33517 20.9018 6.61358 21.0736C7.91356 21.2484 9.62177 21.25 12 21.25C14.3782 21.25 16.0864 21.2484 17.3864 21.0736C18.6648 20.9018 19.4355 20.5749 20.0052 20.0052C20.5749 19.4355 20.9018 18.6648 21.0736 17.3864C21.2484 16.0864 21.25 14.3782 21.25 12V10.5C21.25 10.0858 21.5858 9.75 22 9.75Z" clipRule="evenodd" />
          <path fillRule="evenodd" d="M16.7705 2.27592C18.1384 0.908029 20.3562 0.908029 21.7241 2.27592C23.092 3.6438 23.092 5.86158 21.7241 7.22947L18.0928 10.8607C17.7999 11.1536 17.3251 11.1536 17.0322 10.8607C16.7393 10.5678 16.7393 10.093 17.0322 9.80006L19.1051 7.72709C18.5892 7.50519 17.9882 7.14946 17.4193 6.58065C16.8505 6.01185 16.4948 5.41082 16.2729 4.89486L11.2175 9.95026C10.801 10.3668 10.6376 10.532 10.4988 10.71C10.3274 10.9297 10.1804 11.1676 10.0605 11.4192C9.96337 11.623 9.88868 11.8429 9.7024 12.4017L9.27051 13.6974L10.3026 14.7295L11.5983 14.2976C12.1571 14.1113 12.377 14.0366 12.5808 13.9395C12.8324 13.8196 13.0703 13.6726 13.2901 13.5012C13.468 13.3624 13.6332 13.199 14.0497 12.7825C14.3426 12.4896 14.8175 12.4896 15.1104 12.7825C15.4033 13.0754 15.4033 13.5503 15.1104 13.8432L15.076 13.8776C14.7047 14.2489 14.4721 14.4815 14.2126 14.684C13.9069 14.9224 13.5761 15.1268 13.2261 15.2936C12.929 15.4352 12.6169 15.5392 12.1188 15.7052L9.21426 16.6734C8.67801 16.8521 8.0868 16.7126 7.68711 16.3129C7.28742 15.9132 7.14785 15.322 7.3266 14.7857L8.29477 11.8812C8.46079 11.3831 8.56479 11.071 8.7064 10.7739C8.87319 10.4239 9.07761 10.0931 9.31605 9.78742C9.51849 9.52787 9.7511 9.29529 10.1224 8.92401L16.7705 2.27592ZM17.4546 3.7132C17.4773 3.80906 17.509 3.92327 17.5532 4.05066C17.6965 4.46372 17.9677 5.00771 18.48 5.51999C18.9923 6.03227 19.5363 6.30346 19.9493 6.44677C20.0767 6.49097 20.1909 6.52273 20.2868 6.54543L20.6634 6.16881C21.4455 5.38671 21.4455 4.11867 20.6634 3.33658C19.8813 2.55448 18.6133 2.55448 17.8312 3.33658L17.4546 3.7132Z" clipRule="evenodd" />
        </svg>
        Update Contingencies
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName={!showChange ? "eb-bulk-modal request-leave" : "max-heightModal eb-bulk-modal model-width90vw"}
      >
        <Modal.Header className="eb-bulk-modal-header">
          <Modal.Title className="eb-bulk-modal-title">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
              <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
            </svg>
            Update Contingencies Data for BOQ
            <button
              className="close-btn"
              onClick={handleClose}
              style={{ marginLeft: "auto", background: "none", border: "none", color: "white", fontSize: "24px", cursor: "pointer" }}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </Modal.Title>
        </Modal.Header>

        {!showChange ? (

          /* ===== STEP 1: Reason for Change ===== */
          <Modal.Body className="eb-bulk-modal-body">
            <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
              <div className="eb-bulk-content">
                <div className="eb-bulk-reason-section" style={{ padding: "20px", background: "#f7fafc", borderRadius: "12px" }}>
                  <label className="eb-bulk-label" style={{ display: "block", fontWeight: "600", marginBottom: "8px", color: "#2d3748" }}>
                    Reason for Change BOQ <span className="eb-bulk-required">*</span>
                  </label>
                  <input
                    type="text"
                    name="changeReason"
                    title="Reason for Change BOQ"
                    placeholder="Example- Revise EOT"
                    onChange={(e) => setChangeReason(e.target.value)}
                    className="eb-bulk-input"
                    style={{ width: "90%", padding: "12px 16px", fontSize: "14px" }}
                  />
                </div>
                <div className="eb-bulk-footer-actions" style={{ justifyContent: "flex-end" }}>
                  <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                    Cancel
                  </button>
                  {(changeReason !== "null" && changeReason !== "") && (
                    <button
                      type="submit"
                      className="eb-bulk-btn eb-bulk-btn-submit"
                      disabled={loading}
                      onClick={handleChangeSubmit}
                      style={{ background: "black" }}
                    >
                      Next
                    </button>
                  )}
                </div>
              </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </Modal.Body>

        ) : showEOT === false ? (

          /* ===== STEP 2: Main Table ===== */
          <Modal.Body className="eb-bulk-modal-body">
            <div className="eb-bulk-table-scroll table-box scroll-container-table" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
              <div className="eb-bulk-content">
                <div className="eb-bulk-actions" style={{ justifyContent: "space-between" }}>
                  <button
                    type="button"
                    className="eb-bulk-add-row-btn"
                    style={{ background: "#718096" }}
                    disabled={loading}
                    onClick={handleChangeback}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="15 18 9 12 15 6" />
                    </svg>
                    Back
                  </button>
                  <button
                    type="button"
                    className="eb-bulk-add-row-btn"
                    disabled={loading}
                    onClick={handleShowWOT}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="8" x2="12" y2="16" />
                      <line x1="8" y1="12" x2="16" y2="12" />
                    </svg>
                    Add Revised EOT/COS
                  </button>
                </div>

                <div className="eb-bulk-table-wrapper">
                  <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "40vh", minHeight: "40vh" }}>
                    <table className="eb-bulk-table">
                      <thead className="eb-bulk-table-head">
                        <tr className="eb-bulk-table-header-row">
                          <th className="eb-bulk-th eb-bulk-th-rank">
                            <span className="eb-bulk-th-label">S.No</span>
                          </th>
                          <th className="eb-bulk-th">
                            <span className="eb-bulk-th-label">Description</span>
                            <span className="eb-bulk-th-sub">(Read-Only)</span>
                          </th>
                          <th className="eb-bulk-th">
                            <span className="eb-bulk-th-label">Unit</span>
                            <span className="eb-bulk-th-sub">(Number)</span>
                          </th>
                          <th className="eb-bulk-th">
                            <span className="eb-bulk-th-label">Amount</span>
                            <span className="eb-bulk-th-sub">(Number)</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {formData.map((entry, index) => (
                          <tr key={index} className="eb-bulk-row">

                            {/* S.No */}
                            <td className="eb-bulk-td eb-bulk-td-rank">
                              <span style={{ fontWeight: "500", color: "#2d3748" }}>{index + 1}.</span>
                            </td>

                            {/* Description (Read-Only) */}
                            <td className="eb-bulk-td">
                              <div className="eb-bulk-input-wrapper">
                                <input
                                  className="eb-bulk-input"
                                  id={`description_${index}`}
                                  name="description"
                                  type="text"
                                  readOnly
                                  value={entry.description}
                                  style={{ background: "var(--eb-bulk-input-readonly-bg, #f0f0f0)", cursor: "not-allowed" }}
                                />
                              </div>
                            </td>

                            {/* Unit */}
                            <td className="eb-bulk-td">
                              <div className="eb-bulk-input-wrapper">
                                <input
                                  className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_unit`] ? "eb-bulk-input-error" : ""}`}
                                  id={`unit_${index}`}
                                  name="unit"
                                  type="number"
                                  value={entry.unit}
                                  onChange={(e) => handleInputChange(e, index)}
                                  placeholder="0"
                                />
                                {errors[`${index}_unit`] && (
                                  <span className="eb-bulk-error-text">{errors[`${index}_unit`]}</span>
                                )}
                              </div>
                            </td>

                            {/* Amount */}
                            <td className="eb-bulk-td">
                              <div className="eb-bulk-input-wrapper">
                                <input
                                  className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_ammount`] ? "eb-bulk-input-error" : ""}`}
                                  id={`ammount_${index}`}
                                  name="ammount"
                                  type="number"
                                  value={entry.ammount}
                                  onChange={(e) => handleInputChange(e, index)}
                                  placeholder="₹ 0.00"
                                />
                                {errors[`${index}_ammount`] && (
                                  <span className="eb-bulk-error-text">{errors[`${index}_ammount`]}</span>
                                )}
                              </div>
                            </td>

                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="eb-bulk-footer-actions">
                  <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="eb-bulk-btn eb-bulk-btn-submit"
                    disabled={loading}
                    onClick={handleSubmit}
                    style={{ background: "black" }}
                  >
                    {loading ? (
                      <span className="eb-bulk-btn-loader">
                        <span className="eb-bulk-spinner"></span>
                        Updating...
                      </span>
                    ) : (
                      <>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                          <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                        </svg>
                        Update
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </Modal.Body>

        ) : (

          /* ===== STEP 3: EOT Table ===== */
          <Modal.Body className="eb-bulk-modal-body">
            <div className="eb-bulk-container">
              <div className="eb-bulk-content">
                <div className="eb-bulk-actions" style={{ justifyContent: "space-between" }}>
                  <button
                    type="button"
                    className="eb-bulk-add-row-btn"
                    style={{ background: "#718096" }}
                    disabled={loading}
                    onClick={handleclOSEOT}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="15 18 9 12 15 6" />
                    </svg>
                    Back
                  </button>
                  <button
                    type="button"
                    className="eb-bulk-add-row-btn"
                    disabled={loading}
                    onClick={addNewEOT}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="8" x2="12" y2="16" />
                      <line x1="8" y1="12" x2="16" y2="12" />
                    </svg>
                    Add Another Revised EOT/COS
                  </button>
                </div>

                <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
                  {formData[0]?.eot_details?.map((_, detailIndex) => (
                    <div key={detailIndex} style={{ marginBottom: "24px" }}>
                      <h3 style={{ fontSize: "16px", fontWeight: "700", color: "#2d3748", marginBottom: "12px" }}>
                        EOT Round {detailIndex + 1}
                      </h3>
                      <div className="eb-bulk-table-wrapper">
                        <table className="eb-bulk-table">
                          <thead className="eb-bulk-table-head">
                            <tr className="eb-bulk-table-header-row">
                              <th className="eb-bulk-th"><span className="eb-bulk-th-label">Description</span></th>
                              <th className="eb-bulk-th"><span className="eb-bulk-th-label">Unit</span></th>
                              <th className="eb-bulk-th"><span className="eb-bulk-th-label">Amount</span></th>
                            </tr>
                          </thead>
                          <tbody>
                            {formData.map((entry, entryIndex) => (
                              <tr key={entryIndex} className="eb-bulk-row">

                                {/* Description (Read-Only) */}
                                <td className="eb-bulk-td">
                                  <span style={{ fontSize: "13px", color: "#2d3748" }}>{entry.description}</span>
                                </td>

                                {/* Unit */}
                                <td className="eb-bulk-td">
                                  <div className="eb-bulk-input-wrapper">
                                    <input
                                      type="number"
                                      className={`eb-bulk-input eb-bulk-input-number ${errors[`${entryIndex}_unit`] ? "eb-bulk-input-error" : ""}`}
                                      value={entry.eot_details[detailIndex]?.unit || ""}
                                      onChange={(e) => handleEOTChange(entryIndex, detailIndex, "unit", e.target.value)}
                                      placeholder="0"
                                    />
                                  </div>
                                </td>

                                {/* Amount */}
                                <td className="eb-bulk-td">
                                  <div className="eb-bulk-input-wrapper">
                                    <input
                                      type="number"
                                      className={`eb-bulk-input eb-bulk-input-number ${errors[`${entryIndex}_ammount`] ? "eb-bulk-input-error" : ""}`}
                                      value={entry.eot_details[detailIndex]?.ammount || ""}
                                      onChange={(e) => handleEOTChange(entryIndex, detailIndex, "ammount", e.target.value)}
                                      placeholder="₹ 0.00"
                                    />
                                  </div>
                                </td>

                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="eb-bulk-footer-actions">
                  <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="eb-bulk-btn eb-bulk-btn-submit"
                    disabled={loading}
                    onClick={handleSubmit}
                    style={{ background: "black" }}
                  >
                    {loading ? (
                      <span className="eb-bulk-btn-loader">
                        <span className="eb-bulk-spinner"></span>
                        Saving...
                      </span>
                    ) : (
                      <>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" />
                          <polyline points="17 21 17 13 7 13 7 21" />
                          <polyline points="7 3 7 8 15 8" />
                        </svg>
                        Save
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </Modal.Body>
        )}
      </Modal>
    </>
  );
}
export { BulkUpdateEmployeeBOQ, BulkUpdateTransportData, BulkUpdateutyTravelData, BulkUpdateOfficeRentData, BulkUpdateOfficeSuppliesData, BulkUpdateOfficeFurnitureData, BulkUpdateReportsData, BulkUpdateRoadSurveyData, BulkUpdateContieneous };